(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire052e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire052e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("fgNUY", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $9f461817433b7b57$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $9f461817433b7b57$export$cc3e2d3244e01b7f);
"use strict";
var $9f461817433b7b57$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    return ExtensionType2;
})($9f461817433b7b57$export$4f037c6ec2da4eeb || {});
const $9f461817433b7b57$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $9f461817433b7b57$export$ba4241979983e013 = (ext, defaultPriority)=>$9f461817433b7b57$var$normalizeExtension(ext).priority ?? defaultPriority;
const $9f461817433b7b57$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {extensions} For chaining.
   */ remove (...extensions2) {
        extensions2.map($9f461817433b7b57$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {extensions} For chaining.
   */ add (...extensions2) {
        extensions2.map($9f461817433b7b57$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns {extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns {extensions} For chaining.
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$9f461817433b7b57$export$ba4241979983e013(b.value, defaultPriority) - $9f461817433b7b57$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$9f461817433b7b57$export$ba4241979983e013(b, defaultPriority) - $9f461817433b7b57$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    }
};

});

parcelRegister("seZ39", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("fGguE")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lvvYF")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("1cJ4E"))
]).then(()=>parcelRequire("aZyXG"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("hdGnR", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("fGguE")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lvvYF")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("gFiOe"))
]).then(()=>parcelRequire("619Sj"));

});

parcelRegister("guhjI", function(module, exports) {

var $fgNUY = parcelRequire("fgNUY");

var $b0MpV = parcelRequire("b0MpV");

var $gT51M = parcelRequire("gT51M");

var $57F6H = parcelRequire("57F6H");

var $80oKY = parcelRequire("80oKY");

var $ihl4g = parcelRequire("ihl4g");

var $9mHtV = parcelRequire("9mHtV");

var $c9Vdb = parcelRequire("c9Vdb");
parcelRequire("PSAj8");

"use strict";
(0, $fgNUY.extensions).add((0, $b0MpV.AlphaMask), (0, $gT51M.ColorMask), (0, $57F6H.StencilMask), (0, $c9Vdb.VideoSource), (0, $9mHtV.ImageSource), (0, $ihl4g.CanvasSource), (0, $80oKY.BufferImageSource));

});
parcelRegister("b0MpV", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $68d1187ead67fa8a$export$3c32667be409917c);

var $fgNUY = parcelRequire("fgNUY");

var $bJJoy = parcelRequire("bJJoy");

var $6KN0H = parcelRequire("6KN0H");

var $ftLNB = parcelRequire("ftLNB");
"use strict";
class $68d1187ead67fa8a$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $bJJoy.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $6KN0H.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $ftLNB.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $bJJoy.Sprite);
    }
}
$68d1187ead67fa8a$export$3c32667be409917c.extension = (0, $fgNUY.ExtensionType).MaskEffect;

});
parcelRegister("bJJoy", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $abf2a96c239812e7$export$3075603db8e6204c);

var $9U7PO = parcelRequire("9U7PO");

var $kYZ33 = parcelRequire("kYZ33");

var $guhnW = parcelRequire("guhnW");

var $jNMvk = parcelRequire("jNMvk");
"use strict";
class $abf2a96c239812e7$export$3075603db8e6204c extends (0, $jNMvk.Container) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $kYZ33.Texture).EMPTY){
        if (options instanceof (0, $kYZ33.Texture)) options = {
            texture: options
        };
        const { texture: texture, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        this.renderPipeId = "sprite";
        this.batched = true;
        this._didSpriteUpdate = false;
        this._bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._sourceBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._boundsDirty = true;
        this._sourceBoundsDirty = true;
        this._roundPixels = 0;
        this._anchor = new (0, $9U7PO.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width) this.width = width;
        if (height) this.height = height;
    }
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image, video, canvas element, video element, texture
   * @param source - Source to create texture from
   * @param [skipCache] - Whether to skip the cache or not
   * @returns The newly created sprite
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $kYZ33.Texture)) return new $abf2a96c239812e7$export$3075603db8e6204c(source);
        return new $abf2a96c239812e7$export$3075603db8e6204c((0, $kYZ33.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $kYZ33.Texture).EMPTY);
        if (this._texture === value) return;
        this._texture = value;
        this.onViewUpdate();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    /**
   * The local bounds of the sprite.
   * @type {rendering.Bounds}
   */ get bounds() {
        if (this._boundsDirty) {
            this._updateBounds();
            this._boundsDirty = false;
        }
        return this._bounds;
    }
    /**
   * The bounds of the sprite, taking the texture's trim into account.
   * @type {rendering.Bounds}
   */ get sourceBounds() {
        if (this._sourceBoundsDirty) {
            this._updateSourceBounds();
            this._sourceBoundsDirty = false;
        }
        return this._sourceBounds;
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const bounds = this.sourceBounds;
        if (point.x >= bounds.maxX && point.x <= bounds.minX) {
            if (point.y >= bounds.maxY && point.y <= bounds.minY) return true;
        }
        return false;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        const _bounds = this._texture.trim ? this.sourceBounds : this.bounds;
        bounds.addFrame(_bounds.minX, _bounds.minY, _bounds.maxX, _bounds.maxY);
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._didSpriteUpdate = true;
        this._sourceBoundsDirty = this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        if (this.renderGroup) this.renderGroup.onChildViewUpdate(this);
    }
    _updateBounds() {
        (0, $guhnW.updateQuadBounds)(this._bounds, this._anchor, this._texture, 0);
    }
    _updateSourceBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const sourceBounds = this._sourceBounds;
        const { width: width, height: height } = texture.orig;
        sourceBounds.maxX = -anchor._x * width;
        sourceBounds.minX = sourceBounds.maxX + width;
        sourceBounds.maxY = -anchor._y * height;
        sourceBounds.minY = sourceBounds.maxY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._bounds = null;
        this._sourceBounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   *  Whether or not to round the x/y position of the sprite.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Sprite.
   */ getSize(out) {
        if (!out) out = {};
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        let convertedWidth;
        let convertedHeight;
        if (typeof value !== "object") {
            convertedWidth = value;
            convertedHeight = height ?? value;
        } else {
            convertedWidth = value.width;
            convertedHeight = value.height ?? value.width;
        }
        if (convertedWidth !== void 0) this._setWidth(convertedWidth, this._texture.orig.width);
        if (convertedHeight !== void 0) this._setHeight(convertedHeight, this._texture.orig.height);
    }
}

});
parcelRegister("9U7PO", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $9cb475b0b3a05d49$export$3755aaad3fd42e52);
"use strict";
class $9cb475b0b3a05d49$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @param observer - Optional observer to pass to the new observable point.
   * @returns a copy of this observable point
   */ clone(observer) {
        return new $9cb475b0b3a05d49$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `PointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${0} y=${0} scope=${this._observer}]`;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("kYZ33", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $2555407cc72c3d03$export$5431306cf43de24a);

var $hcgfX = parcelRequire("hcgfX");

var $3eYct = parcelRequire("3eYct");

var $cYXQE = parcelRequire("cYXQE");

var $1UVG8 = parcelRequire("1UVG8");

var $fi8wV = parcelRequire("fi8wV");

var $jCXMN = parcelRequire("jCXMN");

var $80oKY = parcelRequire("80oKY");

var $cyN9N = parcelRequire("cyN9N");

var $4BA77 = parcelRequire("4BA77");
"use strict";
class $2555407cc72c3d03$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * @param {TextureOptions} param0 - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $1UVG8.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $cYXQE.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $cyN9N.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $4BA77.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $3eYct.groupD8).add(rotate, (0, $3eYct.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $3eYct.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $3eYct.groupD8).uY(rotate);
            rotate = (0, $3eYct.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $3eYct.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $3eYct.groupD8).uY(rotate);
            rotate = (0, $3eYct.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $3eYct.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $3eYct.groupD8).uY(rotate);
            rotate = (0, $3eYct.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $3eYct.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $3eYct.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /** call this if you have modified the `texture outside` of the constructor */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$2555407cc72c3d03$export$5431306cf43de24a.EMPTY = new $2555407cc72c3d03$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $cyN9N.TextureSource)({
        label: "EMPTY"
    })
});
$2555407cc72c3d03$export$5431306cf43de24a.EMPTY.destroy = (0, $jCXMN.NOOP);
$2555407cc72c3d03$export$5431306cf43de24a.WHITE = new $2555407cc72c3d03$export$5431306cf43de24a({
    source: new (0, $80oKY.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$2555407cc72c3d03$export$5431306cf43de24a.WHITE.destroy = (0, $jCXMN.NOOP);

});
parcelRegister("hcgfX", function(module, exports) {
"use strict";
var $c8502ad98c072938$var$has = Object.prototype.hasOwnProperty, $c8502ad98c072938$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c8502ad98c072938$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c8502ad98c072938$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c8502ad98c072938$var$Events().__proto__) $c8502ad98c072938$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c8502ad98c072938$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c8502ad98c072938$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $c8502ad98c072938$var$EE(fn, context || emitter, once), evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c8502ad98c072938$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c8502ad98c072938$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c8502ad98c072938$var$EventEmitter() {
    this._events = new $c8502ad98c072938$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c8502ad98c072938$var$has.call(events, name)) names.push($c8502ad98c072938$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c8502ad98c072938$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c8502ad98c072938$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c8502ad98c072938$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c8502ad98c072938$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c8502ad98c072938$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
        if (this._events[evt]) $c8502ad98c072938$var$clearEvent(this, evt);
    } else {
        this._events = new $c8502ad98c072938$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c8502ad98c072938$var$EventEmitter.prototype.off = $c8502ad98c072938$var$EventEmitter.prototype.removeListener;
$c8502ad98c072938$var$EventEmitter.prototype.addListener = $c8502ad98c072938$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c8502ad98c072938$var$EventEmitter.prefixed = $c8502ad98c072938$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c8502ad98c072938$var$EventEmitter.EventEmitter = $c8502ad98c072938$var$EventEmitter;
module.exports = $c8502ad98c072938$var$EventEmitter;

});

parcelRegister("3eYct", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102);

var $2FMN6 = parcelRequire("2FMN6");
"use strict";
const $d9e6f1cfbdce5c9a$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $d9e6f1cfbdce5c9a$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $d9e6f1cfbdce5c9a$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $d9e6f1cfbdce5c9a$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $d9e6f1cfbdce5c9a$var$rotationCayley = [];
const $d9e6f1cfbdce5c9a$var$rotationMatrices = [];
const $d9e6f1cfbdce5c9a$var$signum = Math.sign;
function $d9e6f1cfbdce5c9a$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $d9e6f1cfbdce5c9a$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $d9e6f1cfbdce5c9a$var$signum($d9e6f1cfbdce5c9a$var$ux[i] * $d9e6f1cfbdce5c9a$var$ux[j] + $d9e6f1cfbdce5c9a$var$vx[i] * $d9e6f1cfbdce5c9a$var$uy[j]);
            const _uy = $d9e6f1cfbdce5c9a$var$signum($d9e6f1cfbdce5c9a$var$uy[i] * $d9e6f1cfbdce5c9a$var$ux[j] + $d9e6f1cfbdce5c9a$var$vy[i] * $d9e6f1cfbdce5c9a$var$uy[j]);
            const _vx = $d9e6f1cfbdce5c9a$var$signum($d9e6f1cfbdce5c9a$var$ux[i] * $d9e6f1cfbdce5c9a$var$vx[j] + $d9e6f1cfbdce5c9a$var$vx[i] * $d9e6f1cfbdce5c9a$var$vy[j]);
            const _vy = $d9e6f1cfbdce5c9a$var$signum($d9e6f1cfbdce5c9a$var$uy[i] * $d9e6f1cfbdce5c9a$var$vx[j] + $d9e6f1cfbdce5c9a$var$vy[i] * $d9e6f1cfbdce5c9a$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($d9e6f1cfbdce5c9a$var$ux[k] === _ux && $d9e6f1cfbdce5c9a$var$uy[k] === _uy && $d9e6f1cfbdce5c9a$var$vx[k] === _vx && $d9e6f1cfbdce5c9a$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $2FMN6.Matrix)();
        mat.set($d9e6f1cfbdce5c9a$var$ux[i], $d9e6f1cfbdce5c9a$var$uy[i], $d9e6f1cfbdce5c9a$var$vx[i], $d9e6f1cfbdce5c9a$var$vy[i], 0, 0);
        $d9e6f1cfbdce5c9a$var$rotationMatrices.push(mat);
    }
}
$d9e6f1cfbdce5c9a$var$init();
const $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$d9e6f1cfbdce5c9a$var$ux[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$d9e6f1cfbdce5c9a$var$uy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$d9e6f1cfbdce5c9a$var$vx[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$d9e6f1cfbdce5c9a$var$vy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$d9e6f1cfbdce5c9a$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$d9e6f1cfbdce5c9a$var$rotationCayley[rotationSecond][$d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof maths.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof maths.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.S;
            return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.E;
            return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.SE;
            return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.NE;
        return $d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof maths.groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $d9e6f1cfbdce5c9a$var$rotationMatrices[$d9e6f1cfbdce5c9a$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

});
parcelRegister("2FMN6", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $bcca596c6ce5cb5a$export$5b12bf1653c0dd85);

var $977Gy = parcelRequire("977Gy");

var $dXIDd = parcelRequire("dXIDd");
"use strict";
class $bcca596c6ce5cb5a$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /** An array of the current matrix. Only populated when `toArray` is called */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $dXIDd.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $dXIDd.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrix's and sets the result to this matrix. AB = A * B
   * @param a - The matrix to append.
   * @param b - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $977Gy.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /** Checks if this matrix is an identity matrix */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $bcca596c6ce5cb5a$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param matrix - The matrix to copy from.
   * @returns this
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * check to see if two matrices are the same
   * @param matrix - The matrix to compare to.
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix.
   *
   * This is a shared object, if you want to modify it consider creating a new `Matrix`
   * @readonly
   */ static get IDENTITY() {
        return $bcca596c6ce5cb5a$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   * Use this object for fast but temporary calculations, as it may be mutated later on.
   * This is a different object to the `IDENTITY` object and so can be modified without changing `IDENTITY`.
   * @readonly
   */ static get shared() {
        return $bcca596c6ce5cb5a$var$tempMatrix.identity();
    }
}
const $bcca596c6ce5cb5a$var$tempMatrix = new $bcca596c6ce5cb5a$export$5b12bf1653c0dd85();
const $bcca596c6ce5cb5a$var$identityMatrix = new $bcca596c6ce5cb5a$export$5b12bf1653c0dd85();

});
parcelRegister("977Gy", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $8c9edb2e40029022$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $8c9edb2e40029022$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $8c9edb2e40029022$export$870617f62e3187f1);
"use strict";
const $8c9edb2e40029022$export$59ed0a0a5de1084b = Math.PI * 2;
const $8c9edb2e40029022$export$3f91627dc85c5d57 = 180 / Math.PI;
const $8c9edb2e40029022$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("dXIDd", function(module, exports) {

$parcel$export(module.exports, "Point", () => $6acc3fd51c3bd2e8$export$baf26146a414f24a);
"use strict";
class $6acc3fd51c3bd2e8$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /** Position of the point on the x axis */ this.x = 0;
        /** Position of the point on the y axis */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $6acc3fd51c3bd2e8$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`. Can be used to avoid creating new objects multiple times.
   * @readonly
   */ static get shared() {
        $6acc3fd51c3bd2e8$var$tempPoint.x = 0;
        $6acc3fd51c3bd2e8$var$tempPoint.y = 0;
        return $6acc3fd51c3bd2e8$var$tempPoint;
    }
}
const $6acc3fd51c3bd2e8$var$tempPoint = new $6acc3fd51c3bd2e8$export$baf26146a414f24a();

});



parcelRegister("cYXQE", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $ad8c9b7b668a3eec$export$4617fb02663045ef);

var $dXIDd = parcelRequire("dXIDd");
"use strict";
const $ad8c9b7b668a3eec$var$tempPoints = [
    new (0, $dXIDd.Point)(),
    new (0, $dXIDd.Point)(),
    new (0, $dXIDd.Point)(),
    new (0, $dXIDd.Point)()
];
class $ad8c9b7b668a3eec$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'rectangle'
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** Determines whether the Rectangle is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /** A constant empty rectangle. This is a new object every time the property is accessed */ static get EMPTY() {
        return new $ad8c9b7b668a3eec$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $ad8c9b7b668a3eec$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @param bounds - The bounds to copy and convert to a rectangle.
   * @returns Returns itself.
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(x, y, strokeWidth) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const outerLeft = _x - strokeWidth / 2;
        const outerRight = _x + width + strokeWidth / 2;
        const outerTop = _y - strokeWidth / 2;
        const outerBottom = _y + height + strokeWidth / 2;
        const innerLeft = _x + strokeWidth / 2;
        const innerRight = _x + width - strokeWidth / 2;
        const innerTop = _y + strokeWidth / 2;
        const innerBottom = _y + height - strokeWidth / 2;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $ad8c9b7b668a3eec$var$tempPoints[0].set(other.left, other.top);
        const lb = $ad8c9b7b668a3eec$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $ad8c9b7b668a3eec$var$tempPoints[2].set(other.right, other.top);
        const rb = $ad8c9b7b668a3eec$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new $ad8c9b7b668a3eec$export$4617fb02663045ef();
        out.copyFrom(this);
        return out;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("1UVG8", function(module, exports) {

$parcel$export(module.exports, "uid", () => $9eee26c5bd2e578f$export$e2a22331486dcca0);
"use strict";
const $9eee26c5bd2e578f$var$uidCache = {
    default: -1
};
function $9eee26c5bd2e578f$export$e2a22331486dcca0(name = "default") {
    if ($9eee26c5bd2e578f$var$uidCache[name] === void 0) $9eee26c5bd2e578f$var$uidCache[name] = -1;
    return ++$9eee26c5bd2e578f$var$uidCache[name];
}
function $9eee26c5bd2e578f$export$220409b686c277d0() {
    for(const key in $9eee26c5bd2e578f$var$uidCache)delete $9eee26c5bd2e578f$var$uidCache[key];
}

});

parcelRegister("fi8wV", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $7548c3290a0b92aa$export$dc79da96439604f0);
$parcel$export(module.exports, "deprecation", () => $7548c3290a0b92aa$export$afd31d834b512e89);
"use strict";
const $7548c3290a0b92aa$var$warnings = {};
const $7548c3290a0b92aa$export$dc79da96439604f0 = "8.0.0";
function $7548c3290a0b92aa$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($7548c3290a0b92aa$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $7548c3290a0b92aa$var$warnings[message] = true;
}

});

parcelRegister("jCXMN", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $a94c12e66d26e3bc$export$5702a91a6f42969f);
"use strict";
const $a94c12e66d26e3bc$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("80oKY", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $20169a0857ac9a8a$export$1872462350fcb7cd);

var $fgNUY = parcelRequire("fgNUY");

var $cyN9N = parcelRequire("cyN9N");
"use strict";
class $20169a0857ac9a8a$export$1872462350fcb7cd extends (0, $cyN9N.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$20169a0857ac9a8a$export$1872462350fcb7cd.extension = (0, $fgNUY.ExtensionType).TextureSource;

});
parcelRegister("cyN9N", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $fabb285a502b33f5$export$8498e6a2e655d3d8);

var $hcgfX = parcelRequire("hcgfX");

var $ijJaR = parcelRequire("ijJaR");

var $lLo8O = parcelRequire("lLo8O");

var $1UVG8 = parcelRequire("1UVG8");

var $g9Ts2 = parcelRequire("g9Ts2");
"use strict";
const $fabb285a502b33f5$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** unique id for this Texture source */ this.uid = (0, $1UVG8.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @ignore
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     */ this._resourceId = (0, $1UVG8.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @ignore
     * @internal
     */ this.uploadMethodId = "unknown";
        // dimensions
        this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     * @ignore
     */ this.sampleCount = 1;
        /** The number of mip levels to generate for this texture. this is  overridden if autoGenerateMipmaps is true */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $g9Ts2.TextureStyle)((0, $lLo8O.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $1UVG8.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution = resolution || this._resolution;
        width = width || this.width;
        height = height || this.height;
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $1UVG8.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $ijJaR.isPow2)(this.pixelWidth) && (0, $ijJaR.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $fabb285a502b33f5$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $fabb285a502b33f5$export$8498e6a2e655d3d8 = $fabb285a502b33f5$var$_TextureSource;

});
parcelRegister("ijJaR", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $474ac5fc86590247$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $474ac5fc86590247$export$eb50b9c078eb6ae7);
"use strict";
function $474ac5fc86590247$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $474ac5fc86590247$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $474ac5fc86590247$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("lLo8O", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $867263fcb0f2f2af$export$801feaffb936a09d);
"use strict";
function $867263fcb0f2f2af$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("g9Ts2", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $155219e297cae2f2$export$1ce1d0c10d3de5d5);

var $hcgfX = parcelRequire("hcgfX");

var $1UVG8 = parcelRequire("1UVG8");

var $fi8wV = parcelRequire("fi8wV");
"use strict";
const $155219e297cae2f2$var$idHash = /* @__PURE__ */ Object.create(null);
function $155219e297cae2f2$var$createResourceIdFromString(value) {
    const id = $155219e297cae2f2$var$idHash[value];
    if (id === void 0) $155219e297cae2f2$var$idHash[value] = (0, $1UVG8.uid)("resource");
    return id;
}
const $155219e297cae2f2$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        this._resourceType = "textureSampler";
        this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link GPUSamplerDescriptor#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link GPUSamplerDescriptor#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     * @ignore
     */ this._maxAnisotropy = 1;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this.emit("change", this);
        this._sharedResourceId = null;
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $155219e297cae2f2$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.emit("destroy", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $155219e297cae2f2$var$_TextureStyle.defaultOptions = {
    addressMode: "repeat",
    scaleMode: "linear"
};
let $155219e297cae2f2$export$1ce1d0c10d3de5d5 = $155219e297cae2f2$var$_TextureStyle;

});



parcelRegister("4BA77", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $d5ac5018339c2658$export$dbea3135e9da48cb);

var $2FMN6 = parcelRequire("2FMN6");
"use strict";
const $d5ac5018339c2658$var$tempMat = new (0, $2FMN6.Matrix)();
class $d5ac5018339c2658$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $2FMN6.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $d5ac5018339c2658$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($d5ac5018339c2658$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.pixelWidth;
        this.uClampOffset[1] = offset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("guhnW", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $82d773403fe26958$export$558ce66aa5723f1d);
"use strict";
function $82d773403fe26958$export$558ce66aa5723f1d(bounds, anchor, texture, padding) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width - padding;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height - padding;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width - padding;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height - padding;
        bounds.maxY = bounds.minY + height;
    }
    return;
}

});

parcelRegister("jNMvk", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $177a2a91ba0b5f32$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $177a2a91ba0b5f32$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $177a2a91ba0b5f32$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $177a2a91ba0b5f32$export$42a852a2b6b56249);

var $hcgfX = parcelRequire("hcgfX");

var $iUbYJ = parcelRequire("iUbYJ");

var $3tk93 = parcelRequire("3tk93");

var $2FMN6 = parcelRequire("2FMN6");

var $977Gy = parcelRequire("977Gy");

var $9U7PO = parcelRequire("9U7PO");

var $1UVG8 = parcelRequire("1UVG8");

var $fi8wV = parcelRequire("fi8wV");

var $hKFbH = parcelRequire("hKFbH");

var $2JeRg = parcelRequire("2JeRg");

var $5kror = parcelRequire("5kror");

var $4MlTv = parcelRequire("4MlTv");

var $1noWE = parcelRequire("1noWE");

var $6yt8T = parcelRequire("6yt8T");

var $6qBjJ = parcelRequire("6qBjJ");

var $bAaEb = parcelRequire("bAaEb");

var $7SE2m = parcelRequire("7SE2m");
"use strict";
const $177a2a91ba0b5f32$var$defaultSkew = new (0, $9U7PO.ObservablePoint)(null);
const $177a2a91ba0b5f32$var$defaultPivot = new (0, $9U7PO.ObservablePoint)(null);
const $177a2a91ba0b5f32$var$defaultScale = new (0, $9U7PO.ObservablePoint)(null, 1, 1);
const $177a2a91ba0b5f32$export$f8ede8d8bf091ab5 = 1;
const $177a2a91ba0b5f32$export$e4801e7edc7582f = 2;
const $177a2a91ba0b5f32$export$83db162b74637ea = 4;
const $177a2a91ba0b5f32$export$8363b5079568fbee = 8;
class $177a2a91ba0b5f32$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    constructor(options = {}){
        super();
        /** @private */ this.uid = (0, $1UVG8.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // is this container the root of a renderGroup?
        // TODO implement this in a few more places
        /** @private */ this.isRenderGroupRoot = false;
        // the render group this container belongs to OR owns
        /** @private */ this.renderGroup = null;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container.
     * @readonly
     */ this.children = [];
        /** The display object container that contains this display object. */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /**
     * @internal
     * @ignore
     */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * @readonly
     */ this.localTransform = new (0, $2FMN6.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     */ this.relativeGroupTransform = new (0, $2FMN6.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     */ this.groupTransform = this.relativeGroupTransform;
        /** If the object has been destroyed via destroy(). If true, it should not be used. */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     * @ignore
     */ this._position = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     * @ignore
     */ this._scale = $177a2a91ba0b5f32$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     * @ignore
     */ this._pivot = $177a2a91ba0b5f32$var$defaultPivot;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     * @ignore
     */ this._skew = $177a2a91ba0b5f32$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     * @ignore
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        this.localColor = 16777215;
        this.localAlpha = 1;
        this.groupAlpha = 1;
        // A
        this.groupColor = 16777215;
        // BGR
        this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /**
     * @internal
     * @ignore
     */ this.localBlendMode = "inherit";
        /**
     * @internal
     * @ignore
     */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = renderable, 1 = not renderable) 0b001
     * @internal
     * @ignore
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /**
     * @internal
     * @ignore
     */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the container is modified
     * the first 12 bits represent the container changes (eg transform, alpha, visible etc)
     * the second 12 bits represent the view changes (eg texture swap, geometry change etc)
     *
     *  view          container
     * [000000000000][00000000000]
     * @ignore
     */ this._didChangeId = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        (0, $7SE2m.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        this.effects = [];
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        Object.defineProperties($177a2a91ba0b5f32$export$42a852a2b6b56249.prototype, Object.getOwnPropertyDescriptors(source));
    }
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...Container} children - The Container(s) to add to the container
   * @returns {Container} - The first child that was added.
   */ addChild(...children) {
        if (!this.allowChildren) (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        if (this.renderGroup) this.renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * @param {...Container} children - The Container(s) to remove
   * @returns {Container} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didChangeId++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.isRenderGroupRoot) {
            const renderGroupParent = this.renderGroup.renderGroupParent;
            if (renderGroupParent) renderGroupParent.onChildUpdate(this);
        } else if (this.renderGroup) this.renderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (this.isRenderGroupRoot && value === false) throw new Error("[Pixi] cannot undo a render group just yet");
        if (value) this.enableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   */ get isRenderGroup() {
        return this.isRenderGroupRoot;
    }
    /** This enables the container to be rendered as a render group. */ enableRenderGroup() {
        if (this.renderGroup && this.renderGroup.root === this) return;
        this.isRenderGroupRoot = true;
        const parentRenderGroup = this.renderGroup;
        if (parentRenderGroup) parentRenderGroup.removeChild(this);
        this.renderGroup = new (0, $bAaEb.RenderGroup)(this);
        if (parentRenderGroup) {
            for(let i = 0; i < parentRenderGroup.renderGroupChildren.length; i++){
                const childRenderGroup = parentRenderGroup.renderGroupChildren[i];
                let parent = childRenderGroup.root;
                while(parent){
                    if (parent === this) {
                        this.renderGroup.addRenderGroupChild(childRenderGroup);
                        break;
                    }
                    parent = parent.parent;
                }
            }
            parentRenderGroup.addRenderGroupChild(this.renderGroup);
        }
        this._updateIsSimple();
        this.groupTransform = (0, $2FMN6.Matrix).IDENTITY;
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.isRenderGroupRoot && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $2FMN6.Matrix)());
        if (this.renderGroup) {
            if (this.isRenderGroupRoot) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
            else this._worldTransform.appendFrom(this.relativeGroupTransform, this.renderGroup.worldTransform);
        }
        return this._worldTransform;
    }
    // / ////// transform related stuff
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.rotation * (0, $977Gy.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $977Gy.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $177a2a91ba0b5f32$var$defaultPivot) this._pivot = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $177a2a91ba0b5f32$var$defaultPivot) this._pivot = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        if (this._skew === $177a2a91ba0b5f32$var$defaultSkew) this._skew = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $177a2a91ba0b5f32$var$defaultSkew) this._skew = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $177a2a91ba0b5f32$var$defaultScale) this._scale = new (0, $9U7PO.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $177a2a91ba0b5f32$var$defaultScale) this._scale = new (0, $9U7PO.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   * @memberof scene.Container#
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   * @memberof scene.Container#
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        let convertedWidth;
        let convertedHeight;
        if (typeof value !== "object") {
            convertedWidth = value;
            convertedHeight = height ?? value;
        } else {
            convertedWidth = value.width;
            convertedHeight = value.height ?? value.width;
        }
        if (convertedWidth !== void 0) this._setWidth(convertedWidth, size.width);
        if (convertedHeight !== void 0) this._setHeight(convertedHeight, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container (accepts partial values).
   * @param {object} opts - The options for updating the transform.
   * @param {number} opts.x - The x position of the container.
   * @param {number} opts.y - The y position of the container.
   * @param {number} opts.scaleX - The scale factor on the x-axis.
   * @param {number} opts.scaleY - The scale factor on the y-axis.
   * @param {number} opts.rotation - The rotation of the container, in radians.
   * @param {number} opts.skewX - The skew factor on the x-axis.
   * @param {number} opts.skewY - The skew factor on the y-axis.
   * @param {number} opts.pivotX - The x coordinate of the pivot point.
   * @param {number} opts.pivotY - The y coordinate of the pivot point.
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        return this;
    }
    /**
   * Updates the local transform using the given matrix.
   * @param matrix - The matrix to use for updating the transform.
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        if ((this._didLocalTransformChangeId & 15) === this._didChangeId) return;
        this._didLocalTransformChangeId = this._didChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c);
        lt.ty = position._y - (px * lt.b + py * lt.d);
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $177a2a91ba0b5f32$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /** The opacity of the object. */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $iUbYJ.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $177a2a91ba0b5f32$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        const bgr = this.localColor;
        return ((bgr & 255) << 16) + (bgr & 65280) + (bgr >> 16 & 255);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $177a2a91ba0b5f32$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Apply a value of `'normal'` to reset the blend mode.
   * @default 'normal'
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /** The visibility of the object. If false the object will not be drawn, and the transform will not be updated. */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 2) >> 1 === valueNumber) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $177a2a91ba0b5f32$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 4) >> 2 === valueNumber) return;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._updateFlags |= $177a2a91ba0b5f32$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /** Can this object be rendered, if false the object will not be drawn but the transform will still be updated. */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $177a2a91ba0b5f32$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /** Whether or not the object should be rendered. */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites. If options.children
   * is set to true it should destroy the texture of the child sprite
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true it should destroy the texture source of the child sprite
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true it should destroy the context of the child graphics
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        this.removeFromParent();
        this.parent = null;
        this._mask = null;
        this._filters = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        const oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
}
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $hKFbH.childrenHelperMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $6qBjJ.toLocalGlobalMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $1noWE.onRenderMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $4MlTv.measureMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $2JeRg.effectsMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $5kror.findMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $6yt8T.sortMixin));
$177a2a91ba0b5f32$export$42a852a2b6b56249.mixin((0, $3tk93.cullingMixin));

});
parcelRegister("iUbYJ", function(module, exports) {

$parcel$export(module.exports, "Color", () => $7daef879e2287d6f$export$892596cec99bc70e);

var $hYEBi = parcelRequire("hYEBi");

var $7xShe = parcelRequire("7xShe");
"use strict";
(0, $hYEBi.extend)([
    (0, $7xShe.default)
]);
const $7daef879e2287d6f$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see Color.value
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link Color.multiply multiply},
   *   {@link Color.premultiply premultiply} or {@link Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._normalize(value);
            this._value = this._cloneSource(value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out = out || this._arrayRgba;
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {Color} - Itself.
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $hYEBi.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if the value is a color-like object
   * @param value - Value to check
   * @returns True if the value is a color-like object
   * @static
   * @example
   * import { Color } from 'pixi.js';
   * Color.isColorLike('white'); // returns true
   * Color.isColorLike(0xffffff); // returns true
   * Color.isColorLike([1, 1, 1]); // returns true
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Default Color object for static uses
 * @example
 * import { Color } from 'pixi.js';
 * Color.shared.setValue(0xffffff).toHex(); // '#ffffff'
 */ $7daef879e2287d6f$var$_Color.shared = new $7daef879e2287d6f$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $7daef879e2287d6f$var$_Color._temp = new $7daef879e2287d6f$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$7daef879e2287d6f$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $7daef879e2287d6f$export$892596cec99bc70e = $7daef879e2287d6f$var$_Color;

});
parcelRegister("hYEBi", function(module, exports) {

$parcel$export(module.exports, "colord", () => $7fa50c3074c458ff$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $7fa50c3074c458ff$export$8b58be045bf06082);
var $7fa50c3074c458ff$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $7fa50c3074c458ff$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $7fa50c3074c458ff$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $7fa50c3074c458ff$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $7fa50c3074c458ff$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $7fa50c3074c458ff$var$a = function(r) {
    return {
        r: $7fa50c3074c458ff$var$e(r.r, 0, 255),
        g: $7fa50c3074c458ff$var$e(r.g, 0, 255),
        b: $7fa50c3074c458ff$var$e(r.b, 0, 255),
        a: $7fa50c3074c458ff$var$e(r.a)
    };
}, $7fa50c3074c458ff$var$o = function(r) {
    return {
        r: $7fa50c3074c458ff$var$n(r.r),
        g: $7fa50c3074c458ff$var$n(r.g),
        b: $7fa50c3074c458ff$var$n(r.b),
        a: $7fa50c3074c458ff$var$n(r.a, 3)
    };
}, $7fa50c3074c458ff$var$i = /^#([0-9a-f]{3,8})$/i, $7fa50c3074c458ff$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $7fa50c3074c458ff$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $7fa50c3074c458ff$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $7fa50c3074c458ff$var$g = function(r) {
    return {
        h: $7fa50c3074c458ff$var$u(r.h),
        s: $7fa50c3074c458ff$var$e(r.s, 0, 100),
        l: $7fa50c3074c458ff$var$e(r.l, 0, 100),
        a: $7fa50c3074c458ff$var$e(r.a)
    };
}, $7fa50c3074c458ff$var$d = function(r) {
    return {
        h: $7fa50c3074c458ff$var$n(r.h),
        s: $7fa50c3074c458ff$var$n(r.s),
        l: $7fa50c3074c458ff$var$n(r.l),
        a: $7fa50c3074c458ff$var$n(r.a, 3)
    };
}, $7fa50c3074c458ff$var$f = function(r) {
    var t, n, e;
    return $7fa50c3074c458ff$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $7fa50c3074c458ff$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $7fa50c3074c458ff$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $7fa50c3074c458ff$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7fa50c3074c458ff$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7fa50c3074c458ff$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7fa50c3074c458ff$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $7fa50c3074c458ff$var$y = {
    string: [
        [
            function(r) {
                var t = $7fa50c3074c458ff$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $7fa50c3074c458ff$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $7fa50c3074c458ff$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $7fa50c3074c458ff$var$v.exec(r) || $7fa50c3074c458ff$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $7fa50c3074c458ff$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $7fa50c3074c458ff$var$l.exec(t) || $7fa50c3074c458ff$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $7fa50c3074c458ff$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($7fa50c3074c458ff$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $7fa50c3074c458ff$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $7fa50c3074c458ff$var$t(n) && $7fa50c3074c458ff$var$t(e) && $7fa50c3074c458ff$var$t(u) ? $7fa50c3074c458ff$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$7fa50c3074c458ff$var$t(n) || !$7fa50c3074c458ff$var$t(e) || !$7fa50c3074c458ff$var$t(u)) return null;
                var i = $7fa50c3074c458ff$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $7fa50c3074c458ff$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$7fa50c3074c458ff$var$t(n) || !$7fa50c3074c458ff$var$t(a) || !$7fa50c3074c458ff$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $7fa50c3074c458ff$var$u(r.h),
                        s: $7fa50c3074c458ff$var$e(r.s, 0, 100),
                        v: $7fa50c3074c458ff$var$e(r.v, 0, 100),
                        a: $7fa50c3074c458ff$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $7fa50c3074c458ff$var$b(h);
            },
            "hsv"
        ]
    ]
}, $7fa50c3074c458ff$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $7fa50c3074c458ff$var$x = function(r) {
    return "string" == typeof r ? $7fa50c3074c458ff$var$N(r.trim(), $7fa50c3074c458ff$var$y.string) : "object" == typeof r && null !== r ? $7fa50c3074c458ff$var$N(r, $7fa50c3074c458ff$var$y.object) : [
        null,
        void 0
    ];
}, $7fa50c3074c458ff$export$f61ac8b6f1f46202 = function(r) {
    return $7fa50c3074c458ff$var$x(r)[1];
}, $7fa50c3074c458ff$var$M = function(r, t) {
    var n = $7fa50c3074c458ff$var$c(r);
    return {
        h: n.h,
        s: $7fa50c3074c458ff$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $7fa50c3074c458ff$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $7fa50c3074c458ff$var$$ = function(r, t) {
    var n = $7fa50c3074c458ff$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $7fa50c3074c458ff$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $7fa50c3074c458ff$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $7fa50c3074c458ff$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $7fa50c3074c458ff$var$n($7fa50c3074c458ff$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $7fa50c3074c458ff$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $7fa50c3074c458ff$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $7fa50c3074c458ff$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $7fa50c3074c458ff$var$s($7fa50c3074c458ff$var$n(255 * a)) : "", "#" + $7fa50c3074c458ff$var$s(t) + $7fa50c3074c458ff$var$s(e) + $7fa50c3074c458ff$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $7fa50c3074c458ff$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $7fa50c3074c458ff$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $7fa50c3074c458ff$var$d($7fa50c3074c458ff$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $7fa50c3074c458ff$var$d($7fa50c3074c458ff$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $7fa50c3074c458ff$var$h(this.rgba), {
            h: $7fa50c3074c458ff$var$n(r.h),
            s: $7fa50c3074c458ff$var$n(r.s),
            v: $7fa50c3074c458ff$var$n(r.v),
            a: $7fa50c3074c458ff$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $7fa50c3074c458ff$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $7fa50c3074c458ff$export$c8efe09109f9cb9e($7fa50c3074c458ff$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $7fa50c3074c458ff$export$c8efe09109f9cb9e($7fa50c3074c458ff$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $7fa50c3074c458ff$export$c8efe09109f9cb9e($7fa50c3074c458ff$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $7fa50c3074c458ff$export$c8efe09109f9cb9e($7fa50c3074c458ff$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $7fa50c3074c458ff$export$c8efe09109f9cb9e($7fa50c3074c458ff$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $7fa50c3074c458ff$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $7fa50c3074c458ff$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $7fa50c3074c458ff$var$c(this.rgba);
        return "number" == typeof r ? $7fa50c3074c458ff$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $7fa50c3074c458ff$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $7fa50c3074c458ff$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $7fa50c3074c458ff$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $7fa50c3074c458ff$export$4d30ed660ff08d0 ? r : new $7fa50c3074c458ff$export$4d30ed660ff08d0(r);
}, $7fa50c3074c458ff$var$S = [], $7fa50c3074c458ff$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $7fa50c3074c458ff$var$S.indexOf(r) < 0 && (r($7fa50c3074c458ff$export$4d30ed660ff08d0, $7fa50c3074c458ff$var$y), $7fa50c3074c458ff$var$S.push(r));
    });
}, $7fa50c3074c458ff$export$4385e60b38654f68 = function() {
    return new $7fa50c3074c458ff$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("7xShe", function(module, exports) {

$parcel$export(module.exports, "default", () => $255defd3342980cb$export$2e2bcd8739ae039);
function $255defd3342980cb$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("3tk93", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $b0e2f520539650be$export$dce76d4f0fd249ed);
"use strict";
const $b0e2f520539650be$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("hKFbH", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $03b50412862dec3b$export$64cca9f0c2df174a);

var $7XRlD = parcelRequire("7XRlD");

var $fi8wV = parcelRequire("fi8wV");
"use strict";
const $03b50412862dec3b$export$64cca9f0c2df174a = {
    allowChildren: true,
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   * @memberof scene.Container#
   */ removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                if (this.renderGroup) this.renderGroup.removeChild(child);
                removed.push(child);
                child.parent = null;
            }
            (0, $7XRlD.removeItems)(this.children, beginIndex, end);
            for(let i = 0; i < removed.length; ++i){
                this.emit("childRemoved", removed[i], this, i);
                removed[i].emit("removed", this);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   * @memberof scene.Container#
   */ removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   * @memberof scene.Container#
   */ getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    /**
   * Changes the position of an existing child in the container container
   * @param child - The child Container instance for which you want to change the index number
   * @param index - The resulting index number for the child container
   * @memberof scene.Container#
   */ setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    /**
   * Returns the index position of a child Container instance
   * @param child - The Container instance to identify
   * @returns - The index position of the child container to identify
   * @memberof scene.Container#
   */ getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {Container} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {Container} The child that was added.
   * @memberof scene.Container#
   */ addChildAt (child, index) {
        if (!this.allowChildren) (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        if (this.renderGroup) this.renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    /**
   * Swaps the position of 2 Containers within this container.
   * @param child - First container to swap
   * @param child2 - Second container to swap
   */ swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
    },
    /**
   * Remove the Container from its parent Container. If the Container has no parent, do nothing.
   * @memberof scene.Container#
   */ removeFromParent () {
        this.parent?.removeChild(this);
    }
};

});
parcelRegister("7XRlD", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $f3f3fd3cfd4eddf1$export$8d47c0e1ce445404);
"use strict";
function $f3f3fd3cfd4eddf1$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("2JeRg", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $d6623b962f33f3bd$export$eec5e288a9d02a7c);

var $g4vXD = parcelRequire("g4vXD");

var $1Krol = parcelRequire("1Krol");

var $6oSd9 = parcelRequire("6oSd9");
"use strict";
const $d6623b962f33f3bd$export$eec5e288a9d02a7c = {
    _mask: null,
    _filters: null,
    /**
   * @todo Needs docs.
   * @memberof scene.Container#
   * @type {Array<Effect>}
   */ effects: [],
    /**
   * @todo Needs docs.
   * @param effect - The effect to add.
   * @memberof scene.Container#
   * @ignore
   */ addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        if (this.renderGroup) this.renderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    /**
   * @todo Needs docs.
   * @param effect - The effect to remove.
   * @memberof scene.Container#
   * @ignore
   */ removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        if (!this.isRenderGroupRoot && this.renderGroup) this.renderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    set mask (value){
        this._mask || (this._mask = {
            mask: null,
            effect: null
        });
        if (this._mask.mask === value) return;
        if (this._mask.effect) {
            this.removeEffect(this._mask.effect);
            (0, $1Krol.MaskEffectManager).returnMaskEffect(this._mask.effect);
            this._mask.effect = null;
        }
        this._mask.mask = value;
        if (value === null || value === void 0) return;
        const effect = (0, $1Krol.MaskEffectManager).getMaskEffect(value);
        this._mask.effect = effect;
        this.addEffect(effect);
    },
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link Graphics} or a {@link Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @memberof scene.Container#
   */ get mask () {
        return this._mask?.mask;
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        value;
        this._filters || (this._filters = {
            filters: null,
            effect: null,
            filterArea: null
        });
        const hasFilters = value?.length > 0;
        const didChange = this._filters.effect && !hasFilters || !this._filters.effect && hasFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        this._filters.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) {
                const effect = (0, $6oSd9.BigPool).get((0, $g4vXD.FilterEffect));
                this._filters.effect = effect;
                this.addEffect(effect);
            } else {
                const effect = this._filters.effect;
                this.removeEffect(effect);
                effect.filterArea = null;
                effect.filters = null;
                this._filters.effect = null;
                (0, $6oSd9.BigPool).return(effect);
            }
        }
        if (hasFilters) {
            this._filters.effect.filters = value;
            this._filters.effect.filterArea = this.filterArea;
        }
    },
    /**
   * Sets the filters for the displayObject.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * To remove filters simply set this property to `'null'`.
   * @memberof scene.Container#
   */ get filters () {
        return this._filters?.filters;
    },
    set filterArea (value){
        this._filters || (this._filters = {
            filters: null,
            effect: null,
            filterArea: null
        });
        this._filters.filterArea = value;
    },
    /**
   * The area the filter is applied to. This is used as more of an optimization
   * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
   *
   * Also works as an interaction mask.
   * @memberof scene.Container#
   */ get filterArea () {
        return this._filters?.filterArea;
    }
};

});
parcelRegister("g4vXD", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $daf1a6cf06b69313$export$d66c06ffe23037ab);
"use strict";
class $daf1a6cf06b69313$export$d66c06ffe23037ab {
    constructor(options){
        this.pipe = "filter";
        this.priority = 1;
        this.filters = options?.filters;
        this.filterArea = options?.filterArea;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("1Krol", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $5b7c89bfa20bb703$export$1eb319167fe02d04);

var $fgNUY = parcelRequire("fgNUY");

var $6oSd9 = parcelRequire("6oSd9");
"use strict";
class $5b7c89bfa20bb703$export$3b0749bf144d4b29 {
    constructor(){
        /**
     * @private
     */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $6oSd9.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $6oSd9.BigPool).return(effect);
    }
}
const $5b7c89bfa20bb703$export$1eb319167fe02d04 = new $5b7c89bfa20bb703$export$3b0749bf144d4b29();
(0, $fgNUY.extensions).handleByList((0, $fgNUY.ExtensionType).MaskEffect, $5b7c89bfa20bb703$export$1eb319167fe02d04._effectClasses);

});
parcelRegister("6oSd9", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $2209385ceb5f0558$export$8249372279066210);

var $6FzOo = parcelRequire("6FzOo");
"use strict";
class $2209385ceb5f0558$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $6FzOo.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
}
const $2209385ceb5f0558$export$8249372279066210 = new $2209385ceb5f0558$export$866836a21808b71c();

});
parcelRegister("6FzOo", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $2a21f3fb2c602035$export$14963ee5c8637e11);
"use strict";
class $2a21f3fb2c602035$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else item = new this._classType();
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   * @member {number}
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   * @member {number}
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   * @member {number}
   */ get totalUsed() {
        return this._count - this._index;
    }
}

});




parcelRegister("5kror", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $34a8a741e2e385c3$export$468b0762e1bfbd64);

var $fi8wV = parcelRequire("fi8wV");
"use strict";
const $34a8a741e2e385c3$export$468b0762e1bfbd64 = {
    /**
   * The instance label of the object.
   * @memberof scene.Container#
   * @member {string} label
   */ label: null,
    /**
   * The instance name of the object.
   * @deprecated since 8.0.0
   * @see scene.Container#label
   * @member {string} name
   * @memberof scene.Container#
   */ get name () {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    /**
   * @method getChildByName
   * @deprecated since 8.0.0
   * @param {string} name - Instance name.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified name.
   * @see scene.Container#getChildByLabel
   * @memberof scene.Container#
   */ getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    /**
   * Returns the first child in the container with the specified label.
   *
   * Recursive searches are done in a pre-order traversal.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified label.
   */ getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    /**
   * Returns all children in the container with the specified label.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @param {Container[]} [out=[]] - The array to store matching children in.
   * @returns {Container[]} An array of children with the specified label.
   */ getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("4MlTv", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $5e3d3a050fdd1dab$export$285e6e72e8e62f0);

var $2FMN6 = parcelRequire("2FMN6");

var $bPvY0 = parcelRequire("bPvY0");

var $aWc9h = parcelRequire("aWc9h");

var $2A18g = parcelRequire("2A18g");

var $0Jx25 = parcelRequire("0Jx25");
"use strict";
const $5e3d3a050fdd1dab$var$tempMatrix = new (0, $2FMN6.Matrix)();
const $5e3d3a050fdd1dab$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    /**
   * Retrieves the local bounds of the container as a Bounds object.
   * @returns - The bounding area.
   * @memberof scene.Container#
   */ getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $bPvY0.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didChangeId >> 12) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didChangeId >> 12;
        }
        (0, $0Jx25.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $2A18g.getLocalBounds)(this, localBoundsCacheData.localBounds, $5e3d3a050fdd1dab$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link Rectangle}.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param bounds - Optional bounds to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   * @memberof scene.Container#
   */ getBounds (skipUpdate, bounds) {
        return (0, $aWc9h.getGlobalBounds)(this, skipUpdate, bounds || new (0, $bPvY0.Bounds)());
    }
};

});
parcelRegister("bPvY0", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $2d88dca076d9debe$export$c4e9d269599ab4b4);

var $2FMN6 = parcelRequire("2FMN6");

var $cYXQE = parcelRequire("cYXQE");
"use strict";
const $2d88dca076d9debe$var$defaultMatrix = new (0, $2FMN6.Matrix)();
class $2d88dca076d9debe$export$c4e9d269599ab4b4 {
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /** @default Infinity */ this.minX = Infinity;
        /** @default Infinity */ this.minY = Infinity;
        /** @default -Infinity */ this.maxX = -Infinity;
        /** @default -Infinity */ this.maxY = -Infinity;
        this.matrix = $2d88dca076d9debe$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** The bounding rectangle of the bounds. */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $cYXQE.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $2d88dca076d9debe$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds.
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds sprite frame
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param matrix
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds.
   * @param rect - The rectangle to be added.
   * @param matrix - The matrix to apply to the bounds.
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds other {@link Bounds}.
   * @param bounds - The Bounds to be added
   * @param matrix
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param mask - The Bounds to be added.
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Adds other Bounds, multiplied with matrix.
   * @param matrix - The matrix to apply to the bounds.
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to include the given rectangle.
   * @param rect - The rectangle to be included.
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /** Ceils the bounds. */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /** Clones the bounds. */ clone() {
        return new $2d88dca076d9debe$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values
   * @param x - The X value to scale by.
   * @param y - The Y value to scale by.
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /** the x value of the bounds. */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /** the y value of the bounds. */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /** the width value of the bounds. */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /** the height value of the bounds. */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /** the left value of the bounds. */ get left() {
        return this.minX;
    }
    /** the right value of the bounds. */ get right() {
        return this.maxX;
    }
    /** the top value of the bounds. */ get top() {
        return this.minY;
    }
    /** the bottom value of the bounds. */ get bottom() {
        return this.maxY;
    }
    /** Is the bounds positive. */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param matrix
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if the point is contained within the bounds.
   * @param x - x coordinate
   * @param y - y coordinate
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("aWc9h", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $9c48774301d36b1a$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $9c48774301d36b1a$export$2022bc48a49dd6d2);

var $2FMN6 = parcelRequire("2FMN6");

var $j5ZIa = parcelRequire("j5ZIa");
"use strict";
function $9c48774301d36b1a$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $j5ZIa.matrixPool).get().identity();
            parentTransform = $9c48774301d36b1a$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $2FMN6.Matrix).IDENTITY;
    $9c48774301d36b1a$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $j5ZIa.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $9c48774301d36b1a$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $j5ZIa.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $j5ZIa.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        if (target.addBounds) {
            bounds.matrix = worldTransform;
            target.addBounds(bounds);
        }
        for(let i = 0; i < target.children.length; i++)$9c48774301d36b1a$export$ca70956e64971628(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $2FMN6.Matrix).IDENTITY);
        (0, $j5ZIa.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $j5ZIa.matrixPool).return(worldTransform);
}
function $9c48774301d36b1a$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $9c48774301d36b1a$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});
parcelRegister("j5ZIa", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $460459c4a4ea823e$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $460459c4a4ea823e$export$9194656040c1dc42);

var $2FMN6 = parcelRequire("2FMN6");

var $6FzOo = parcelRequire("6FzOo");

var $bPvY0 = parcelRequire("bPvY0");
"use strict";
const $460459c4a4ea823e$export$3849005ba4dacf72 = new (0, $6FzOo.Pool)((0, $2FMN6.Matrix));
const $460459c4a4ea823e$export$9194656040c1dc42 = new (0, $6FzOo.Pool)((0, $bPvY0.Bounds));

});


parcelRegister("2A18g", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $ce879ad38283a22d$export$ffaf4f504c4c5c9c);

var $2FMN6 = parcelRequire("2FMN6");

var $eDLY3 = parcelRequire("eDLY3");

var $j5ZIa = parcelRequire("j5ZIa");
"use strict";
function $ce879ad38283a22d$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $2FMN6.Matrix).IDENTITY);
    $ce879ad38283a22d$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $ce879ad38283a22d$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $j5ZIa.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $j5ZIa.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $j5ZIa.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            target.addBounds(bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$ce879ad38283a22d$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $2FMN6.Matrix).IDENTITY);
        (0, $j5ZIa.boundsPool).return(bounds);
    }
    (0, $j5ZIa.matrixPool).return(relativeTransform);
}
function $ce879ad38283a22d$export$58081aedf094d85b(target, root, matrix) {
    const parent = target.parent;
    if (!parent) {
        (0, $eDLY3.warn)("Item is not inside the root container");
        return;
    }
    if (parent !== root) {
        $ce879ad38283a22d$export$58081aedf094d85b(parent, root, matrix);
        parent.updateLocalTransform();
        matrix.append(parent.localTransform);
    }
}

});
parcelRegister("eDLY3", function(module, exports) {

$parcel$export(module.exports, "warn", () => $ebd671e71c112f2d$export$c106dd0671a0fc2d);
"use strict";
let $ebd671e71c112f2d$var$warnCount = 0;
const $ebd671e71c112f2d$var$maxWarnings = 500;
function $ebd671e71c112f2d$export$c106dd0671a0fc2d(...args) {
    if ($ebd671e71c112f2d$var$warnCount === $ebd671e71c112f2d$var$maxWarnings) return;
    $ebd671e71c112f2d$var$warnCount++;
    if ($ebd671e71c112f2d$var$warnCount === $ebd671e71c112f2d$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});


parcelRegister("0Jx25", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $e34177999cf607ac$export$fd5aadbd3827bcf1);
"use strict";
function $e34177999cf607ac$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const changeId = (child.uid & 255) << 24 | child._didChangeId & 16777215;
        if (previousData.data[previousData.index] !== changeId) {
            previousData.data[previousData.index] = changeId;
            previousData.didChange = true;
        }
        previousData.index++;
        if (child.children.length) $e34177999cf607ac$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("1noWE", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $06b8129f68479da4$export$2a5246d1114cb81d);
"use strict";
const $06b8129f68479da4$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    /**
   * This callback is used when the container is rendered. This is where you should add your custom
   * logic that is needed to be run every frame.
   *
   * In v7 many users used `updateTransform` for this, however the way v8 renders objects is different
   * and "updateTransform" is no longer called every frame
   * @example
   * const container = new Container();
   * container.onRender = () => {
   *    container.rotation += 0.01;
   * };
   * @memberof scene.Container#
   */ get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("6yt8T", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $124734889a1ae42f$export$eb4acdd9f4781aed);
"use strict";
const $124734889a1ae42f$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    /**
   * Should children be sorted by zIndex at the next render call.
   *
   * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortDirty: false,
    /**
   * If set to true, the container will sort its children by `zIndex` value
   * when the next render is called, or manually if `sortChildren()` is called.
   *
   * This actually changes the order of elements in the array, so should be treated
   * as a basic solution that is not performant compared to other solutions,
   * such as {@link https://github.com/pixijs/layers PixiJS Layers}
   *
   * Also be aware of that this may not work nicely with the `addChildAt()` function,
   * as the `zIndex` sorting may cause the child to automatically sorted to another position.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortableChildren: false,
    /**
   * The zIndex of the container.
   *
   * Setting this value, will automatically set the parent to be sortable. Children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see scene.Container#sortableChildren
   * @memberof scene.Container#
   */ get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.renderGroup && !this.isRenderGroupRoot) this.renderGroup.structureDidChange = true;
    },
    /**
   * Sorts children by zIndex.
   * @memberof scene.Container#
   */ sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($124734889a1ae42f$var$sortChildren);
    }
};
function $124734889a1ae42f$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("6qBjJ", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $ab9fc702b7f21035$export$38fa7a987602e8dd);

var $2FMN6 = parcelRequire("2FMN6");

var $dXIDd = parcelRequire("dXIDd");

var $aWc9h = parcelRequire("aWc9h");
"use strict";
const $ab9fc702b7f21035$export$38fa7a987602e8dd = {
    /**
   * Returns the global position of the container.
   * @param point - The optional point to write the global value to.
   * @param skipUpdate - Should we skip the update transform.
   * @returns - The updated point.
   * @memberof scene.Container#
   */ getGlobalPosition (point = new (0, $dXIDd.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    /**
   * Calculates the global position of the container.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   * @memberof scene.Container#
   */ toGlobal (position, point, skipUpdate = false) {
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $aWc9h.updateTransformBackwards)(this, new (0, $2FMN6.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.apply(position, point);
        }
        return this.worldTransform.apply(position, point);
    },
    /**
   * Calculates the local position of the container relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The Container to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   * @memberof scene.Container#
   */ toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $aWc9h.updateTransformBackwards)(this, new (0, $2FMN6.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.applyInverse(position, point);
        }
        return this.worldTransform.applyInverse(position, point);
    }
};

});

parcelRegister("bAaEb", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $0cf3c8d093c22bad$export$94d273f8d74f2a5);

var $2FMN6 = parcelRequire("2FMN6");

var $hNZWz = parcelRequire("hNZWz");
"use strict";
class $0cf3c8d093c22bad$export$94d273f8d74f2a5 {
    constructor(root){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this._children = [];
        this.worldTransform = new (0, $2FMN6.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $hNZWz.InstructionSet)();
        this._onRenderContainers = [];
        this.root = root;
        this.addChild(root);
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.onChildUpdate(renderGroupChild.root);
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.root.didChange) this._removeChildFromUpdate(renderGroupChild.root);
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        if (child !== this.root) {
            this._children.push(child);
            child.updateTick = -1;
            if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
            else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
            if (child._onRender) this.addOnRender(child);
        }
        if (child.renderGroup) {
            if (child.renderGroup.root === child) {
                this.addRenderGroupChild(child.renderGroup);
                return;
            }
        } else {
            child.renderGroup = this;
            child.didChange = true;
        }
        const children = child.children;
        if (!child.isRenderGroupRoot) this.onChildUpdate(child);
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) this.removeOnRender(child);
        if (child.renderGroup.root !== child) {
            const children = child.children;
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            if (child.didChange) child.renderGroup._removeChildFromUpdate(child);
            child.renderGroup = null;
        } else this._removeRenderGroupChild(child.renderGroup);
        const index = this._children.indexOf(child);
        if (index > -1) this._children.splice(index, 1);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    // SHOULD THIS BE HERE?
    updateRenderable(container) {
        if (container.globalDisplayStatus < 7) return;
        container.didViewUpdate = false;
        this.instructionSet.renderPipes[container.renderPipeId].updateRenderable(container);
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    _removeChildFromUpdate(child) {
        const childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) return;
        const index = childrenToUpdate.list.indexOf(child);
        if (index > -1) childrenToUpdate.list.splice(index, 1);
        childrenToUpdate.index--;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender() {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender();
    }
}

});
parcelRegister("hNZWz", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $9880ebf852ac92bb$export$2946bd01f10dd922);

var $1UVG8 = parcelRequire("1UVG8");
"use strict";
class $9880ebf852ac92bb$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $1UVG8.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   * @ignore
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});


parcelRegister("7SE2m", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $5bc2c873ce537f8d$export$59d0441a278e5935);
"use strict";
function $5bc2c873ce537f8d$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});



parcelRegister("6KN0H", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $8a98e476f0d5391a$export$12af48852c6ac574);

var $bPvY0 = parcelRequire("bPvY0");

var $aWc9h = parcelRequire("aWc9h");
"use strict";
const $8a98e476f0d5391a$var$tempBounds = new (0, $bPvY0.Bounds)();
function $8a98e476f0d5391a$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $8a98e476f0d5391a$var$tempBounds;
    mask.measurable = true;
    (0, $aWc9h.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("ftLNB", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $72554b482c47f0b4$export$7416ac774b1f1a33);

var $2A18g = parcelRequire("2A18g");

var $j5ZIa = parcelRequire("j5ZIa");

var $eDLY3 = parcelRequire("eDLY3");
"use strict";
function $72554b482c47f0b4$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $j5ZIa.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $j5ZIa.matrixPool).get().identity();
    const relativeMask = $72554b482c47f0b4$export$1536bde1a0bf3cb9(mask, localRoot, tempMatrix);
    (0, $2A18g.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $j5ZIa.matrixPool).return(tempMatrix);
    (0, $j5ZIa.boundsPool).return(boundsToMask);
}
function $72554b482c47f0b4$export$1536bde1a0bf3cb9(target, root, matrix) {
    if (!target) {
        (0, $eDLY3.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $72554b482c47f0b4$export$1536bde1a0bf3cb9(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("gT51M", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $bef2045eed4bafc8$export$1e2a2c76374c2542);

var $fgNUY = parcelRequire("fgNUY");
"use strict";
class $bef2045eed4bafc8$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$bef2045eed4bafc8$export$1e2a2c76374c2542.extension = (0, $fgNUY.ExtensionType).MaskEffect;

});

parcelRegister("57F6H", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $f2d3118c2759afbb$export$abd85894695764cb);

var $fgNUY = parcelRequire("fgNUY");

var $jNMvk = parcelRequire("jNMvk");

var $6KN0H = parcelRequire("6KN0H");

var $ftLNB = parcelRequire("ftLNB");
"use strict";
class $f2d3118c2759afbb$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $6KN0H.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $ftLNB.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $jNMvk.Container);
    }
}
$f2d3118c2759afbb$export$abd85894695764cb.extension = (0, $fgNUY.ExtensionType).MaskEffect;

});

parcelRegister("ihl4g", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $844f173de757e022$export$ca65ccf5708c6a0c);

var $lTNTn = parcelRequire("lTNTn");

var $fgNUY = parcelRequire("fgNUY");

var $cyN9N = parcelRequire("cyN9N");
"use strict";
class $844f173de757e022$export$ca65ccf5708c6a0c extends (0, $cyN9N.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $lTNTn.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        const canvas = options.resource;
        if (this.pixelWidth !== canvas.width || this.pixelWidth !== canvas.height) this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
}
$844f173de757e022$export$ca65ccf5708c6a0c.extension = (0, $fgNUY.ExtensionType).TextureSource;

});
parcelRegister("lTNTn", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $083f5fa1c36be578$export$d988306fa84f7b44);

var $lUqwP = parcelRequire("lUqwP");
"use strict";
let $083f5fa1c36be578$var$currentAdapter = (0, $lUqwP.BrowserAdapter);
const $083f5fa1c36be578$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $083f5fa1c36be578$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $083f5fa1c36be578$var$currentAdapter = adapter;
    }
};

});
parcelRegister("lUqwP", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $888cd4f6d0aa3d28$export$e467cc3399500025);
"use strict";
const $888cd4f6d0aa3d28$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getWebGL2RenderingContext: ()=>WebGL2RenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("9mHtV", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $ba42701a8d2ad563$export$280e9a68c3ffd919);

var $lTNTn = parcelRequire("lTNTn");

var $fgNUY = parcelRequire("fgNUY");

var $eDLY3 = parcelRequire("eDLY3");

var $cyN9N = parcelRequire("cyN9N");
"use strict";
class $ba42701a8d2ad563$export$280e9a68c3ffd919 extends (0, $cyN9N.TextureSource) {
    constructor(options){
        if (options.resource && globalThis.HTMLImageElement && options.resource instanceof HTMLImageElement) {
            const canvas = (0, $lTNTn.DOMAdapter).get().createCanvas(options.resource.width, options.resource.height);
            const context = canvas.getContext("2d");
            context.drawImage(options.resource, 0, 0);
            options.resource = canvas;
            (0, $eDLY3.warn)("ImageSource: Image element passed, converting to canvas. Use CanvasSource instead.");
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap;
    }
}
$ba42701a8d2ad563$export$280e9a68c3ffd919.extension = (0, $fgNUY.ExtensionType).TextureSource;

});

parcelRegister("c9Vdb", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $dda534219bd28cdb$export$f3a17123d80000c5);

var $fgNUY = parcelRequire("fgNUY");

var $fdtEa = parcelRequire("fdtEa");

var $f6W07 = parcelRequire("f6W07");

var $cyN9N = parcelRequire("cyN9N");
"use strict";
const $dda534219bd28cdb$var$_VideoSource = class _VideoSource extends (0, $cyN9N.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $fdtEa.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $f6W07.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.source.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $fdtEa.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $fdtEa.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $fdtEa.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
};
$dda534219bd28cdb$var$_VideoSource.extension = (0, $fgNUY.ExtensionType).TextureSource;
/** The default options for video sources. */ $dda534219bd28cdb$var$_VideoSource.defaultOptions = {
    ...(0, $cyN9N.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $dda534219bd28cdb$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $dda534219bd28cdb$export$f3a17123d80000c5 = $dda534219bd28cdb$var$_VideoSource;

});
parcelRegister("fdtEa", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $e75a5ed5958e93ab$export$39c54bcc89dcee11);

var $1rTxM = parcelRequire("1rTxM");

var $hJiv3 = parcelRequire("hJiv3");
"use strict";
const $e75a5ed5958e93ab$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method
     * {@link ticker.Ticker#start|start} automatically when a listener is added.
     */ this.autoStart = false;
        /**
     * Scalar time value from last frame to this frame.
     * This value is capped by setting {@link ticker.Ticker#minFPS|minFPS}
     * and is scaled with {@link ticker.Ticker#speed|speed}.
     * **Note:** The cap may be exceeded by scaling.
     */ this.deltaTime = 1;
        /**
     * The last time {@link ticker.Ticker#update|update} was invoked.
     * This value is also reset internally outside of invoking
     * update, but only when a new animation frame is requested.
     * If the platform supports DOMHighResTimeStamp,
     * this value will have a precision of 1 µs.
     */ this.lastTime = -1;
        /**
     * Factor of current {@link ticker.Ticker#deltaTime|deltaTime}.
     * @example
     * // Scales ticker.deltaTime to what would be
     * // the equivalent of approximately 120 FPS
     * ticker.speed = 2;
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     * `true` if {@link ticker.Ticker#start|start} has been called.
     * `false` if {@link ticker.Ticker#stop|Stop} has been called.
     * While `false`, this value may change to `true` in the
     * event of {@link ticker.Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $hJiv3.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $1rTxM.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $hJiv3.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $1rTxM.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $hJiv3.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link ticker.Ticker#elapsedMS|elapsedMS},
   * the current {@link ticker.Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link ticker.Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link ticker.Ticker#speed|speed}, which is specific
   * to scaling {@link ticker.Ticker#deltaTime|deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This value is used to cap {@link ticker.Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This will effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frames per millisecond.
 * @static
 */ $e75a5ed5958e93ab$var$_Ticker.targetFPMS = 0.06;
let $e75a5ed5958e93ab$export$39c54bcc89dcee11 = $e75a5ed5958e93ab$var$_Ticker;

});
parcelRegister("1rTxM", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $7885981ff21da583$export$688aaf132ba9b379);
"use strict";
var $7885981ff21da583$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($7885981ff21da583$export$688aaf132ba9b379 || {});

});

parcelRegister("hJiv3", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $46fd3a4f53249fa1$export$579021a5759a260f);
"use strict";
class $46fd3a4f53249fa1$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("f6W07", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $1af22b2d57a4dd91$export$8df68d58aae31877);
"use strict";
let $1af22b2d57a4dd91$var$promise;
async function $1af22b2d57a4dd91$export$8df68d58aae31877() {
    $1af22b2d57a4dd91$var$promise ?? ($1af22b2d57a4dd91$var$promise = (async ()=>{
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $1af22b2d57a4dd91$var$promise;
}

});


parcelRegister("PSAj8", function(module, exports) {

var $8JPvD = parcelRequire("8JPvD");

var $fgNUY = parcelRequire("fgNUY");

var $cyN9N = parcelRequire("cyN9N");

var $kYZ33 = parcelRequire("kYZ33");
"use strict";
const $f305d4fa4d2b2445$var$sources = [];
(0, $fgNUY.extensions).handleByList((0, $fgNUY.ExtensionType).TextureSource, $f305d4fa4d2b2445$var$sources);
function $f305d4fa4d2b2445$export$688bcf31fbf7eb15(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $f305d4fa4d2b2445$var$sources.length; i++){
        const Source = $f305d4fa4d2b2445$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $f305d4fa4d2b2445$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $8JPvD.Cache).has(resource)) return (0, $8JPvD.Cache).get(resource);
    const texture = new (0, $kYZ33.Texture)({
        source: $f305d4fa4d2b2445$export$688bcf31fbf7eb15(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $8JPvD.Cache).has(resource)) (0, $8JPvD.Cache).remove(resource);
    });
    if (!skipCache) (0, $8JPvD.Cache).set(resource, texture);
    return texture;
}
function $f305d4fa4d2b2445$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $8JPvD.Cache).get(id);
    else if (id instanceof (0, $cyN9N.TextureSource)) return new (0, $kYZ33.Texture)({
        source: id
    });
    return $f305d4fa4d2b2445$export$3b748ed6327ec85b(id, skipCache);
}
(0, $kYZ33.Texture).from = $f305d4fa4d2b2445$export$4266177d9730bb1;

});
parcelRegister("8JPvD", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $233850b4abf07b0a$export$94affb487e701bf2);

var $eDLY3 = parcelRequire("eDLY3");

var $7ya0J = parcelRequire("7ya0J");
"use strict";
class $233850b4abf07b0a$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $eDLY3.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $7ya0J.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $eDLY3.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $eDLY3.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $233850b4abf07b0a$export$94affb487e701bf2 = new $233850b4abf07b0a$var$CacheClass();

});
parcelRegister("7ya0J", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $be70468d6c0a5689$export$b01be8e180bf3d9b);
"use strict";
const $be70468d6c0a5689$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("1Hpjw", function(module, exports) {

var $fgNUY = parcelRequire("fgNUY");

var $iRyPU = parcelRequire("iRyPU");
"use strict";
(0, $fgNUY.extensions).add((0, $iRyPU.spritesheetAsset));

});
parcelRegister("iRyPU", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $bdbfdd0bddbd68f5$export$46dcda4f1cdd80fe);

var $jJTg7 = parcelRequire("jJTg7");

var $fbvqn = parcelRequire("fbvqn");

var $5VtFH = parcelRequire("5VtFH");

var $fgNUY = parcelRequire("fgNUY");

var $kYZ33 = parcelRequire("kYZ33");

var $1Roz8 = parcelRequire("1Roz8");

var $l2EVq = parcelRequire("l2EVq");
"use strict";
const $bdbfdd0bddbd68f5$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $bdbfdd0bddbd68f5$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $1Roz8.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $bdbfdd0bddbd68f5$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $bdbfdd0bddbd68f5$export$46dcda4f1cdd80fe = {
    extension: (0, $fgNUY.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $l2EVq.Spritesheet),
        getCacheableAssets: (keys, asset)=>$bdbfdd0bddbd68f5$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $bdbfdd0bddbd68f5$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $fbvqn.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $fgNUY.ExtensionType).LoadParser,
            priority: (0, $jJTg7.LoaderParserPriority).Normal
        },
        async testParse (asset, options) {
            return (0, $1Roz8.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename } = options?.data ?? {};
            let basePath = (0, $1Roz8.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $kYZ33.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $5VtFH.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    imagePath
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $l2EVq.Spritesheet)(texture.source, asset);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $5VtFH.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("jJTg7", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $decd30d273e98c9a$export$820ed6348c4f2750);
"use strict";
var $decd30d273e98c9a$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($decd30d273e98c9a$export$820ed6348c4f2750 || {});

});

parcelRegister("fbvqn", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $1b7d4ab487aa56e9$export$8b4c839865b08288);

var $eDLY3 = parcelRequire("eDLY3");

var $1Roz8 = parcelRequire("1Roz8");

var $7ya0J = parcelRequire("7ya0J");

var $dbmk5 = parcelRequire("dbmk5");

var $hcVgb = parcelRequire("hcVgb");
"use strict";
class $1b7d4ab487aa56e9$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $7ya0J.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $eDLY3.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $eDLY3.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $7ya0J.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: loadParser } = asset;
            const srcsToUse = (0, $7ya0J.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $dbmk5.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        loadParser = src2.loadParser ?? loadParser;
                        formattedAsset = {
                            ...formattedAsset,
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: loadParser
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $hcVgb.isSingleItem)(bundleIds);
        bundleIds = (0, $7ya0J.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $hcVgb.isSingleItem)(keys);
        keys = (0, $7ya0J.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $1Roz8.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.format = format ?? formattedAsset.format ?? $1b7d4ab487aa56e9$export$4bb0ea38086a2ed5(formattedAsset.src);
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @static
 * @name RETINA_PREFIX
 * @type {RegExp}
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $1b7d4ab487aa56e9$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $1b7d4ab487aa56e9$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("1Roz8", function(module, exports) {

$parcel$export(module.exports, "path", () => $3a0a9719f3e212ae$export$bb654e07daaf8c3a);

var $lTNTn = parcelRequire("lTNTn");
"use strict";
function $3a0a9719f3e212ae$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $3a0a9719f3e212ae$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $3a0a9719f3e212ae$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $3a0a9719f3e212ae$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($3a0a9719f3e212ae$var$escapeRegExp(find), "g"), replace);
}
function $3a0a9719f3e212ae$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $3a0a9719f3e212ae$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $3a0a9719f3e212ae$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $3a0a9719f3e212ae$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $3a0a9719f3e212ae$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $lTNTn.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $3a0a9719f3e212ae$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $3a0a9719f3e212ae$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $3a0a9719f3e212ae$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $3a0a9719f3e212ae$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        if (ext) $3a0a9719f3e212ae$var$assertPath(ext);
        path2 = $3a0a9719f3e212ae$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        path2 = $3a0a9719f3e212ae$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $3a0a9719f3e212ae$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $3a0a9719f3e212ae$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("dbmk5", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $518e683fc2d73185$export$738117acc6638004);
"use strict";
function $518e683fc2d73185$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $518e683fc2d73185$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $518e683fc2d73185$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $518e683fc2d73185$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("hcVgb", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $6702818e00163683$export$16a80d27953452d4);
"use strict";
const $6702818e00163683$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("5VtFH", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $08e81f18bb4d6e64$export$f57b97ef8be10dda);
"use strict";
const $08e81f18bb4d6e64$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("l2EVq", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $0e1859f819cbe79b$export$674d2eb4debbef0c);

var $cYXQE = parcelRequire("cYXQE");

var $kYZ33 = parcelRequire("kYZ33");
"use strict";
const $0e1859f819cbe79b$var$_Spritesheet = class _Spritesheet {
    /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   */ constructor(texture, data){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        this._texture = texture instanceof (0, $kYZ33.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $cYXQE.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $cYXQE.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $cYXQE.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $cYXQE.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $kYZ33.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/** The maximum number of Textures to build per process. */ $0e1859f819cbe79b$var$_Spritesheet.BATCH_SIZE = 1e3;
let $0e1859f819cbe79b$export$674d2eb4debbef0c = $0e1859f819cbe79b$var$_Spritesheet;

});



parcelRegister("2RX6C", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $89052a89d4467cc7$export$58ab3ed211eed562);

var $iUbYJ = parcelRequire("iUbYJ");

var $jNMvk = parcelRequire("jNMvk");

var $9i2X6 = parcelRequire("9i2X6");

var $fi8wV = parcelRequire("fi8wV");


var $9g4gv = parcelRequire("9g4gv");

var $9LsEj = parcelRequire("9LsEj");

var $hcgfX = parcelRequire("hcgfX");
"use strict";
const $89052a89d4467cc7$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "reset",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $89052a89d4467cc7$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        this.runners = /* @__PURE__ */ Object.create(null);
        this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        const combinedRunners = [
            ...$89052a89d4467cc7$var$defaultRunners,
            ...config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._addSystems(config.systems);
        this._addPipes(config.renderPipes, config.renderPipeAdaptors);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $jNMvk.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor = this.background.colorRgba;
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $iUbYJ.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height);
    }
    clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $9g4gv.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $iUbYJ.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $iUbYJ.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $9LsEj.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overrideable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $9i2X6.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
};
/** The default options for the renderer. */ $89052a89d4467cc7$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $89052a89d4467cc7$export$58ab3ed211eed562 = $89052a89d4467cc7$var$_AbstractRenderer;

});
parcelRegister("9i2X6", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $858594e7f8357e1b$export$70c0711f29adc5cf);
"use strict";
let $858594e7f8357e1b$var$unsafeEval;
function $858594e7f8357e1b$export$70c0711f29adc5cf() {
    if (typeof $858594e7f8357e1b$var$unsafeEval === "boolean") return $858594e7f8357e1b$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $858594e7f8357e1b$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (e) {
        $858594e7f8357e1b$var$unsafeEval = false;
    }
    return $858594e7f8357e1b$var$unsafeEval;
}

});

parcelRegister("9g4gv", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $6deddd2e23bdaa33$export$6c4d37c7f376a1de);
"use strict";
var $6deddd2e23bdaa33$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($6deddd2e23bdaa33$export$6c4d37c7f376a1de || {});

});

parcelRegister("9LsEj", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $52e025a77098d73d$export$ff5f2fe687fe3979);
"use strict";
class $52e025a77098d73d$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("5AbgC", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("d8QeF")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("fGguE")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("6khJu"))
]).then(()=>parcelRequire("j7KtA"));

});

parcelRegister("ajlyv", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("d8QeF")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("fGguE")),
    (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("9Nctv"))
]).then(()=>parcelRequire("cbpb1"));

});

parcelRegister("iAzZc", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $845cfc1a7a386d46$export$449e8d355fd68e43);

var $lGvus = parcelRequire("lGvus");

var $jxRST = parcelRequire("jxRST");

var $5aBuq = parcelRequire("5aBuq");
"use strict";
const $845cfc1a7a386d46$var$placeHolderBufferData = new Float32Array(1);
const $845cfc1a7a386d46$var$placeHolderIndexData = new Uint32Array(1);
class $845cfc1a7a386d46$export$449e8d355fd68e43 extends (0, $5aBuq.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lGvus.Buffer)({
            data: $845cfc1a7a386d46$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $jxRST.BufferUsage).VERTEX | (0, $jxRST.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lGvus.Buffer)({
            data: $845cfc1a7a386d46$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $jxRST.BufferUsage).INDEX | (0, $jxRST.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0,
                    location: 1
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8,
                    location: 3
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16,
                    location: 0
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20,
                    location: 2
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lGvus", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $e3250c23c28773e6$export$a143d493d941bafc);

var $hcgfX = parcelRequire("hcgfX");

var $1UVG8 = parcelRequire("1UVG8");

var $jxRST = parcelRequire("jxRST");
"use strict";
class $e3250c23c28773e6$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /**
     * a unique id for this uniform group used through the renderer
     * @internal
     * @ignore
     */ this.uid = (0, $1UVG8.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     * @ignore
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     * @ignore
     */ this._resourceId = (0, $1UVG8.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     * @ignore
     */ this._touched = 0;
        /**
     * @internal
     * @ignore
     */ this._updateID = 1;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size = size ?? data?.byteLength;
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $jxRST.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $jxRST.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $jxRST.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        if (oldData.length !== value.length) {
            if (!this.shrinkToFit && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $1UVG8.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Destroys the buffer */ destroy() {
        this.emit("destroy", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("jxRST", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $0cd225fe7b36b04e$export$f8deb2be8632fd10);
"use strict";
var $0cd225fe7b36b04e$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($0cd225fe7b36b04e$export$f8deb2be8632fd10 || {});

});


parcelRegister("5aBuq", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $3373a5e98bbea9e3$export$2db6c17465f94a2);

var $hcgfX = parcelRequire("hcgfX");

var $bPvY0 = parcelRequire("bPvY0");

var $1UVG8 = parcelRequire("1UVG8");

var $lGvus = parcelRequire("lGvus");

var $jAIDx = parcelRequire("jAIDx");

var $dt0Lo = parcelRequire("dt0Lo");
"use strict";
function $3373a5e98bbea9e3$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lGvus.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $jAIDx.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $3373a5e98bbea9e3$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options){
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        super();
        /** The unique id of the geometry. */ this.uid = (0, $1UVG8.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     * @ignore
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $bPvY0.Bounds)();
        this._boundsDirty = true;
        this.attributes = attributes;
        this.buffers = [];
        this.instanceCount = options.instanceCount || 1;
        for(const i in attributes){
            const attribute = attributes[i] = $3373a5e98bbea9e3$var$ensureIsAttribute(attributes[i]);
            const bufferIndex = this.buffers.indexOf(attribute.buffer);
            if (bufferIndex === -1) {
                this.buffers.push(attribute.buffer);
                attribute.buffer.on("update", this.onBufferUpdate, this);
                attribute.buffer.on("change", this.onBufferUpdate, this);
            }
        }
        if (indexBuffer) {
            this.indexBuffer = (0, $jAIDx.ensureIsBuffer)(indexBuffer, true);
            this.buffers.push(this.indexBuffer);
        }
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $dt0Lo.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("jAIDx", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $6e8820fa0d9166bd$export$e02adcb3cf335e03);

var $lGvus = parcelRequire("lGvus");

var $jxRST = parcelRequire("jxRST");
"use strict";
function $6e8820fa0d9166bd$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lGvus.Buffer))) {
        let usage = index ? (0, $jxRST.BufferUsage).INDEX : (0, $jxRST.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $jxRST.BufferUsage).INDEX | (0, $jxRST.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $jxRST.BufferUsage).VERTEX | (0, $jxRST.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lGvus.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("dt0Lo", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $fd404b044827caad$export$ca8be28ec6402f29);
"use strict";
function $fd404b044827caad$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("gbdZQ", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $ff537fae74be94ff$export$84c26df82650dc9b);

var $jmtJ5 = parcelRequire("jmtJ5");

var $kYZ33 = parcelRequire("kYZ33");

var $iigja = parcelRequire("iigja");
"use strict";
const $ff537fae74be94ff$var$cachedGroups = {};
function $ff537fae74be94ff$export$84c26df82650dc9b(textures, size) {
    let uid = 0;
    for(let i = 0; i < size; i++)uid = uid * 31 + textures[i].uid >>> 0;
    return $ff537fae74be94ff$var$cachedGroups[uid] || $ff537fae74be94ff$var$generateTextureBatchBindGroup(textures, uid);
}
function $ff537fae74be94ff$var$generateTextureBatchBindGroup(textures, key) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < (0, $iigja.MAX_TEXTURES); i++){
        const texture = i < textures.length ? textures[i] : (0, $kYZ33.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $jmtJ5.BindGroup)(bindGroupResources);
    $ff537fae74be94ff$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("jmtJ5", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $ae8993f3ca654522$export$6f452ee382def63c);
"use strict";
class $ae8993f3ca654522$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   * @ignore
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   * @ignore
   */ _touch(tick) {
        const resources = this.resources;
        for(const i in resources)resources[i]._touched = tick;
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange() {
        this._dirty = true;
        this._updateKey();
    }
}

});

parcelRegister("iigja", function(module, exports) {

$parcel$export(module.exports, "MAX_TEXTURES", () => $789258d60281d0bf$export$e09e7788b3f0275e);
"use strict";
const $789258d60281d0bf$export$e09e7788b3f0275e = 16;

});


parcelRegister("gwSFa", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $ba0ae01b383436b9$export$704b12ddc1dacdd2);

var $1UVG8 = parcelRequire("1UVG8");

var $dI0dX = parcelRequire("dI0dX");

var $2IHfZ = parcelRequire("2IHfZ");

var $52E60 = parcelRequire("52E60");

var $a1lWi = parcelRequire("a1lWi");

var $iigja = parcelRequire("iigja");
"use strict";
class $ba0ae01b383436b9$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.blendMode = "normal";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
    }
}
let $ba0ae01b383436b9$var$BATCH_TICK = 0;
const $ba0ae01b383436b9$var$_Batcher = class _Batcher {
    constructor(options = {}){
        this.uid = (0, $1UVG8.uid)("batcher");
        this.dirty = true;
        this.batchIndex = 0;
        this.batches = [];
        // specifics.
        this._vertexSize = 6;
        this._elements = [];
        this._batchPool = [];
        this._batchPoolIndex = 0;
        this._textureBatchPool = [];
        this._textureBatchPoolIndex = 0;
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        const { vertexSize: vertexSize, indexSize: indexSize } = options;
        this.attributeBuffer = new (0, $dI0dX.ViewableBuffer)(vertexSize * this._vertexSize * 4);
        this.indexBuffer = new Uint16Array(indexSize);
    }
    begin() {
        this.batchIndex = 0;
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        this._batchPoolIndex = 0;
        this._textureBatchPoolIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject.indexStart = this.indexSize;
        batchableObject.location = this.attributeSize;
        batchableObject.batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.vertexSize * this._vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject.batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject.textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        batchableObject.packAttributes(this.attributeBuffer.float32View, this.attributeBuffer.uint32View, batchableObject.location, batchableObject.textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        let textureBatch = this._textureBatchPool[this._textureBatchPoolIndex++] || new (0, $a1lWi.BatchTextureArray)();
        textureBatch.clear();
        if (!elements[this.elementStart]) return;
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $52E60.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const iBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        let batch = this._batchPool[this._batchPoolIndex++] || new $ba0ae01b383436b9$export$33b107562567fc47();
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $52E60.getAdjustedBlendModeBlend)(element.blendMode, source);
            const blendModeChange = blendMode !== adjustedBlendMode;
            if (source._batchTick === $ba0ae01b383436b9$var$BATCH_TICK && !blendModeChange) {
                element.textureId = source._textureBindLocation;
                size += element.indexSize;
                element.packAttributes(f32, u32, element.location, element.textureId);
                element.packIndex(iBuffer, element.indexStart, element.location / this._vertexSize);
                element.batch = batch;
                continue;
            }
            source._batchTick = $ba0ae01b383436b9$var$BATCH_TICK;
            if (textureBatch.count >= (0, $iigja.MAX_TEXTURES) || blendModeChange) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                textureBatch = this._textureBatchPool[this._textureBatchPoolIndex++] || new (0, $a1lWi.BatchTextureArray)();
                textureBatch.clear();
                batch = this._batchPool[this._batchPoolIndex++] || new $ba0ae01b383436b9$export$33b107562567fc47();
                ++$ba0ae01b383436b9$var$BATCH_TICK;
            }
            element.textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element.batch = batch;
            size += element.indexSize;
            element.packAttributes(f32, u32, element.location, element.textureId);
            element.packIndex(iBuffer, element.indexStart, element.location / this._vertexSize);
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
            start = size;
            ++$ba0ae01b383436b9$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, instructionSet, action) {
        batch.gpuBindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.start = indexStart;
        batch.size = indexSize;
        ++$ba0ae01b383436b9$var$BATCH_TICK;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $dI0dX.ViewableBuffer)(newSize);
        (0, $2IHfZ.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $2IHfZ.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    destroy() {
        for(let i = 0; i < this.batches.length; i++)this.batches[i].destroy();
        this.batches = null;
        for(let i = 0; i < this._elements.length; i++)this._elements[i].batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$ba0ae01b383436b9$var$_Batcher.defaultOptions = {
    vertexSize: 4,
    indexSize: 6
};
let $ba0ae01b383436b9$export$704b12ddc1dacdd2 = $ba0ae01b383436b9$var$_Batcher;

});
parcelRegister("dI0dX", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $4a677c0fd5547992$export$4fdbf0662aa3047a);
"use strict";
class $4a677c0fd5547992$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this.uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("2IHfZ", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $9af635e898765d0e$export$c691b0c42debe682);
"use strict";
function $9af635e898765d0e$export$c691b0c42debe682(sourceBuffer, destinationBuffer) {
    const lengthDouble = sourceBuffer.byteLength / 8 | 0;
    const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
    const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
    destinationFloat64View.set(sourceFloat64View);
    const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
    if (remainingBytes > 0) {
        const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
        const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
        destinationUint8View.set(sourceUint8View);
    }
}

});

parcelRegister("52E60", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $da1b04e7ebaa9f6c$export$ab2fc5cf3fe899fe);

var $iTIsm = parcelRequire("iTIsm");
"use strict";
function $da1b04e7ebaa9f6c$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $iTIsm.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("iTIsm", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $48120c5973de6c8e$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $48120c5973de6c8e$export$c250b85d73a91bdf);
"use strict";
const $48120c5973de6c8e$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $48120c5973de6c8e$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 3] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 4] = "NONE";
    return STENCIL_MODES2;
})($48120c5973de6c8e$export$c250b85d73a91bdf || {});

});


parcelRegister("a1lWi", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $b0e656d3dff4de85$export$aa760e0febf1a758);
"use strict";
class $b0e656d3dff4de85$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("4lIEI", function(module, exports) {

$parcel$export(module.exports, "mixColors", () => $5b498936bda355a0$export$72a85c3a80ccc403);

var $5557G = parcelRequire("5557G");
"use strict";
const $5b498936bda355a0$var$WHITE_BGR = 16777215;
function $5b498936bda355a0$export$72a85c3a80ccc403(localBGRColor, parentBGRColor) {
    if (localBGRColor === $5b498936bda355a0$var$WHITE_BGR || parentBGRColor === $5b498936bda355a0$var$WHITE_BGR) return localBGRColor + parentBGRColor - $5b498936bda355a0$var$WHITE_BGR;
    return (0, $5557G.mixHexColors)(localBGRColor, parentBGRColor, 0.5);
}
function $5b498936bda355a0$export$2c7842eb56139270(localColorRGB, localAlpha, parentColor) {
    const parentAlpha = (parentColor >> 24 & 255) / 255;
    const globalAlpha = localAlpha * parentAlpha * 255;
    const localBGRColor = ((localColorRGB & 255) << 16) + (localColorRGB & 65280) + (localColorRGB >> 16 & 255);
    const parentBGRColor = parentColor & 16777215;
    let sharedBGRColor;
    if (localBGRColor === $5b498936bda355a0$var$WHITE_BGR || parentBGRColor === $5b498936bda355a0$var$WHITE_BGR) sharedBGRColor = localBGRColor + parentBGRColor - $5b498936bda355a0$var$WHITE_BGR;
    else sharedBGRColor = (0, $5557G.mixHexColors)(localBGRColor, parentBGRColor, 0.5);
    return sharedBGRColor + (globalAlpha << 24);
}

});
parcelRegister("5557G", function(module, exports) {

$parcel$export(module.exports, "mixHexColors", () => $e49629c82e090213$export$ff72adc46f6bc63c);
"use strict";
function $e49629c82e090213$export$ff72adc46f6bc63c(color1, color2, ratio) {
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 + (r2 - r1) * ratio;
    const g = g1 + (g2 - g1) * ratio;
    const b = b1 + (b2 - b1) * ratio;
    return (r << 16) + (g << 8) + b;
}

});


parcelRegister("7JqnN", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $f38ff81abef6ec7d$export$91d2a08bbf21546b);

var $4lIEI = parcelRequire("4lIEI");
"use strict";
class $f38ff81abef6ec7d$export$91d2a08bbf21546b {
    constructor(){
        this.batcher = null;
        this.batch = null;
        this.applyTransform = true;
        this.roundPixels = 0;
    }
    get blendMode() {
        if (this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    packIndex(indexBuffer, index, indicesOffset) {
        const indices = this.geometryData.indices;
        for(let i = 0; i < this.indexSize; i++)indexBuffer[index++] = indices[i + this.indexOffset] + indicesOffset - this.vertexOffset;
    }
    packAttributes(float32View, uint32View, index, textureId) {
        const geometry = this.geometryData;
        const graphics = this.renderable;
        const positions = geometry.vertices;
        const uvs = geometry.uvs;
        const offset = this.vertexOffset * 2;
        const vertSize = (this.vertexOffset + this.vertexSize) * 2;
        const rgb = this.color;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        if (this.applyTransform) {
            const argb = (0, $4lIEI.mixColors)(bgr, graphics.groupColor) + (this.alpha * graphics.groupAlpha * 255 << 24);
            const wt = graphics.groupTransform;
            const textureIdAndRound = textureId << 16 | this.roundPixels & 65535;
            const a = wt.a;
            const b = wt.b;
            const c = wt.c;
            const d = wt.d;
            const tx = wt.tx;
            const ty = wt.ty;
            for(let i = offset; i < vertSize; i += 2){
                const x = positions[i];
                const y = positions[i + 1];
                float32View[index] = a * x + c * y + tx;
                float32View[index + 1] = b * x + d * y + ty;
                float32View[index + 2] = uvs[i];
                float32View[index + 3] = uvs[i + 1];
                uint32View[index + 4] = argb;
                uint32View[index + 5] = textureIdAndRound;
                index += 6;
            }
        } else {
            const argb = bgr + (this.alpha * 255 << 24);
            for(let i = offset; i < vertSize; i += 2){
                float32View[index] = positions[i];
                float32View[index + 1] = positions[i + 1];
                float32View[index + 2] = uvs[i];
                float32View[index + 3] = uvs[i + 1];
                uint32View[index + 4] = argb;
                uint32View[index + 5] = textureId << 16;
                index += 6;
            }
        }
    }
    // TODO rename to vertexSize
    get vertSize() {
        return this.vertexSize;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.vertexOffset = this.vertexOffset;
        gpuBuffer.vertexSize = this.vertexSize;
        gpuBuffer.color = this.color;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
    }
    reset() {
        this.applyTransform = true;
    }
}

});

parcelRegister("8EVCF", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $bab850c294f6e36c$export$f2f3ca33e4c65172);

var $fgNUY = parcelRequire("fgNUY");

var $iAzZc = parcelRequire("iAzZc");

var $gbdZQ = parcelRequire("gbdZQ");

var $gwSFa = parcelRequire("gwSFa");

var $hNZWz = parcelRequire("hNZWz");

var $6oSd9 = parcelRequire("6oSd9");

var $5c18b = parcelRequire("5c18b");
"use strict";
class $bab850c294f6e36c$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
}
class $bab850c294f6e36c$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.geometry = new (0, $iAzZc.BatchGeometry)();
        this.instructions = new (0, $hNZWz.InstructionSet)();
    }
    init() {
        this.instructions.reset();
    }
}
const $bab850c294f6e36c$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(){
        // the root context batches, used to either make a batch or geometry
        // all graphics use this as a base
        this._activeBatchers = [];
        this._gpuContextHash = {};
        // used for non-batchable graphics
        this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
        this._needsContextNeedsRebuild = [];
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    prerender() {
        this._returnActiveBatchers();
    }
    getContextRenderData(context) {
        return this._graphicsDataContextHash[context.uid] || this._initContextRenderData(context);
    }
    // Context management functions
    updateGpuContext(context) {
        let gpuContext = this._gpuContextHash[context.uid] || this._initContext(context);
        if (context.dirty) {
            if (gpuContext) this._cleanGraphicsContextData(context);
            else gpuContext = this._initContext(context);
            (0, $5c18b.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            context.dirty = false;
        }
        return gpuContext;
    }
    getGpuContext(context) {
        return this._gpuContextHash[context.uid] || this._initContext(context);
    }
    _returnActiveBatchers() {
        for(let i = 0; i < this._activeBatchers.length; i++)(0, $6oSd9.BigPool).return(this._activeBatchers[i]);
        this._activeBatchers.length = 0;
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $6oSd9.BigPool).get($bab850c294f6e36c$export$9b6a6c5b37fc8f49);
        const { batches: batches, geometryData: geometryData } = this._gpuContextHash[context.uid];
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = (0, $6oSd9.BigPool).get((0, $gwSFa.Batcher));
        this._activeBatchers.push(batcher);
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = graphicsData.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $gbdZQ.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count);
        }
        this._graphicsDataContextHash[context.uid] = graphicsData;
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $bab850c294f6e36c$export$e3e348c254036d55();
        this._gpuContextHash[context.uid] = gpuContext;
        context.on("update", this.onGraphicsContextUpdate, this);
        context.on("destroy", this.onGraphicsContextDestroy, this);
        return this._gpuContextHash[context.uid];
    }
    onGraphicsContextUpdate(context) {
        this._needsContextNeedsRebuild.push(context);
    }
    onGraphicsContextDestroy(context) {
        this._cleanGraphicsContextData(context);
        context.off("update", this.onGraphicsContextUpdate, this);
        context.off("destroy", this.onGraphicsContextDestroy, this);
        this._gpuContextHash[context.uid] = null;
    }
    _cleanGraphicsContextData(context) {
        const gpuContext = this._gpuContextHash[context.uid];
        if (!gpuContext.isBatchable) {
            if (this._graphicsDataContextHash[context.uid]) {
                (0, $6oSd9.BigPool).return(this.getContextRenderData(context));
                this._graphicsDataContextHash[context.uid] = null;
            }
        }
        if (gpuContext.batches) gpuContext.batches.forEach((batch)=>{
            (0, $6oSd9.BigPool).return(batch);
        });
    }
    destroy() {
        for (const context of this._needsContextNeedsRebuild)if (this._gpuContextHash[context.uid]) this.onGraphicsContextDestroy(context);
        this._needsContextNeedsRebuild.length = 0;
    }
};
/** @ignore */ $bab850c294f6e36c$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $fgNUY.ExtensionType).WebGLSystem,
        (0, $fgNUY.ExtensionType).WebGPUSystem,
        (0, $fgNUY.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $bab850c294f6e36c$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $bab850c294f6e36c$export$f2f3ca33e4c65172 = $bab850c294f6e36c$var$_GraphicsContextSystem;

});
parcelRegister("5c18b", function(module, exports) {

$parcel$export(module.exports, "buildContextBatches", () => $dda8a0f169b52ebe$export$e3c00f31a053d231);

var $cYXQE = parcelRequire("cYXQE");

var $390E7 = parcelRequire("390E7");

var $jxTGX = parcelRequire("jxTGX");

var $kYZ33 = parcelRequire("kYZ33");

var $6oSd9 = parcelRequire("6oSd9");

var $7JqnN = parcelRequire("7JqnN");

var $1aeL3 = parcelRequire("1aeL3");

var $1b7Gq = parcelRequire("1b7Gq");

var $3JMMk = parcelRequire("3JMMk");

var $6XtRL = parcelRequire("6XtRL");

var $7pckg = parcelRequire("7pckg");

var $bMHeI = parcelRequire("bMHeI");
"use strict";
const $dda8a0f169b52ebe$var$buildMap = {
    rectangle: (0, $6XtRL.buildRectangle),
    polygon: (0, $3JMMk.buildPolygon),
    triangle: (0, $7pckg.buildTriangle),
    circle: (0, $1aeL3.buildCircle),
    ellipse: (0, $1aeL3.buildCircle),
    roundedRectangle: (0, $1aeL3.buildCircle)
};
const $dda8a0f169b52ebe$var$tempRect = new (0, $cYXQE.Rectangle)();
function $dda8a0f169b52ebe$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $dda8a0f169b52ebe$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $dda8a0f169b52ebe$var$addShapePathToGeometryData(hole.shapePath, style, null, true, batches, geometryData);
            $dda8a0f169b52ebe$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData);
        }
    }
}
function $dda8a0f169b52ebe$var$addTextureToGeometryData(data, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    const points = [];
    const build = $dda8a0f169b52ebe$var$buildMap.rectangle;
    const rect = $dda8a0f169b52ebe$var$tempRect;
    const texture = data.image;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    build.build(rect, points);
    if (matrix) (0, $jxTGX.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $6oSd9.BigPool).get((0, $7JqnN.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.vertexOffset = vertOffset;
    graphicsBatch.vertexSize = vertices.length / 2 - vertOffset;
    graphicsBatch.color = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $dda8a0f169b52ebe$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const lastIndex = shapePath.shapePrimitives.length - 1;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix }, i)=>{
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        const points = [];
        const build = $dda8a0f169b52ebe$var$buildMap[shape.type];
        build.build(shape, points);
        if (matrix) (0, $jxTGX.transformVertices)(points, matrix);
        if (!isStroke) {
            if (hole && lastIndex === i) {
                if (lastIndex !== 0) console.warn("[Pixi Graphics] only the last shape have be cut out");
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $dda8a0f169b52ebe$var$getHoleArrays(hole.shapePath);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $bMHeI.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            (0, $1b7Gq.buildLine)(points, lineStyle, false, close, vertices, 2, vertOffset, indices, indexOffset);
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $kYZ33.Texture).WHITE) {
            const textureMatrix = style.matrix;
            if (matrix) textureMatrix.append(matrix.clone().invert());
            (0, $390E7.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $390E7.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $6oSd9.BigPool).get((0, $7JqnN.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.vertexOffset = vertOffset;
        graphicsBatch.vertexSize = vertices.length / 2 - vertOffset;
        graphicsBatch.color = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        batches.push(graphicsBatch);
    });
}
function $dda8a0f169b52ebe$var$getHoleArrays(shape) {
    if (!shape) return [];
    const holePrimitives = shape.shapePrimitives;
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $dda8a0f169b52ebe$var$buildMap[holePrimitive.type];
        holeBuilder.build(holePrimitive, holePoints);
        holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("390E7", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $26d19b963b1f50f7$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $26d19b963b1f50f7$export$580e3d8462b9fe52);
"use strict";
function $26d19b963b1f50f7$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $26d19b963b1f50f7$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("jxTGX", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $1be2c0d2355a9b58$export$cbe36b8a8d6e3d3);
"use strict";
function $1be2c0d2355a9b58$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset = offset || 0;
    stride = stride || 2;
    size = size || vertices.length / stride - offset;
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("1aeL3", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $cee8376037618f93$export$a3541b2d8ecbfcf2);
"use strict";
const $cee8376037618f93$export$a3541b2d8ecbfcf2 = {
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            x = circle.x;
            y = circle.y;
            rx = ry = circle.radius;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            x = ellipse.x;
            y = ellipse.y;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) return points;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return points;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return points;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};

});

parcelRegister("1b7Gq", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $09a7612c0d02dd06$export$45986ccf08e93b0b);

var $dXIDd = parcelRequire("dXIDd");

var $9FIkG = parcelRequire("9FIkG");

var $36EO6 = parcelRequire("36EO6");
"use strict";
function $09a7612c0d02dd06$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $09a7612c0d02dd06$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $09a7612c0d02dd06$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, _verticesStride, _verticesOffset, indices, _indicesOffset) {
    const eps = (0, $9FIkG.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $36EO6.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $dXIDd.Point)(points[0], points[1]);
    const lastPoint = new (0, $dXIDd.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $09a7612c0d02dd06$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $09a7612c0d02dd06$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $09a7612c0d02dd06$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $09a7612c0d02dd06$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $09a7612c0d02dd06$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $09a7612c0d02dd06$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $09a7612c0d02dd06$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $09a7612c0d02dd06$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $09a7612c0d02dd06$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $9FIkG.curveEps) * (0, $9FIkG.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("9FIkG", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $1435acc60d99743d$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $1435acc60d99743d$export$51a946149243709);
"use strict";
const $1435acc60d99743d$export$7159a7c43f12984 = 1e-4;
const $1435acc60d99743d$export$51a946149243709 = 1e-4;

});

parcelRegister("36EO6", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $38acbacb739516ee$export$38856eae80d480e1);
"use strict";
function $38acbacb739516ee$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("3JMMk", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $bd67287fe388baad$export$4c2d12f7b210f357);

var $bMHeI = parcelRequire("bMHeI");
"use strict";
const $bd67287fe388baad$var$emptyArray = [];
const $bd67287fe388baad$export$4c2d12f7b210f357 = {
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $bMHeI.triangulateWithHoles)(points, $bd67287fe388baad$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("bMHeI", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $941867d2323ce931$export$5a241bf9c2c3d94b);

var $7wyyT = parcelRequire("7wyyT");
"use strict";
function $941867d2323ce931$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, (/*@__PURE__*/$parcel$interopDefault($7wyyT)))(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("7wyyT", function(module, exports) {
"use strict";
module.exports = $57a654d4ad77ff33$var$earcut;
module.exports.default = $57a654d4ad77ff33$var$earcut;
function $57a654d4ad77ff33$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $57a654d4ad77ff33$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $57a654d4ad77ff33$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $57a654d4ad77ff33$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $57a654d4ad77ff33$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $57a654d4ad77ff33$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $57a654d4ad77ff33$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $57a654d4ad77ff33$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $57a654d4ad77ff33$var$equals(last, last.next)) {
        $57a654d4ad77ff33$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $57a654d4ad77ff33$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($57a654d4ad77ff33$var$equals(p, p.next) || $57a654d4ad77ff33$var$area(p.prev, p, p.next) === 0)) {
            $57a654d4ad77ff33$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $57a654d4ad77ff33$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $57a654d4ad77ff33$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $57a654d4ad77ff33$var$isEarHashed(ear, minX, minY, invSize) : $57a654d4ad77ff33$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $57a654d4ad77ff33$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $57a654d4ad77ff33$var$earcutLinked($57a654d4ad77ff33$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $57a654d4ad77ff33$var$cureLocalIntersections($57a654d4ad77ff33$var$filterPoints(ear), triangles, dim);
                $57a654d4ad77ff33$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $57a654d4ad77ff33$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $57a654d4ad77ff33$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($57a654d4ad77ff33$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $57a654d4ad77ff33$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $57a654d4ad77ff33$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($57a654d4ad77ff33$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $57a654d4ad77ff33$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $57a654d4ad77ff33$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $57a654d4ad77ff33$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $57a654d4ad77ff33$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $57a654d4ad77ff33$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $57a654d4ad77ff33$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $57a654d4ad77ff33$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$57a654d4ad77ff33$var$equals(a, b) && $57a654d4ad77ff33$var$intersects(a, p, p.next, b) && $57a654d4ad77ff33$var$locallyInside(a, b) && $57a654d4ad77ff33$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $57a654d4ad77ff33$var$removeNode(p);
            $57a654d4ad77ff33$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $57a654d4ad77ff33$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $57a654d4ad77ff33$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $57a654d4ad77ff33$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $57a654d4ad77ff33$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $57a654d4ad77ff33$var$filterPoints(a, a.next);
                c = $57a654d4ad77ff33$var$filterPoints(c, c.next);
                // run earcut on each half
                $57a654d4ad77ff33$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $57a654d4ad77ff33$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $57a654d4ad77ff33$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $57a654d4ad77ff33$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($57a654d4ad77ff33$var$getLeftmost(list));
    }
    queue.sort($57a654d4ad77ff33$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $57a654d4ad77ff33$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $57a654d4ad77ff33$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $57a654d4ad77ff33$var$eliminateHole(hole, outerNode) {
    var bridge = $57a654d4ad77ff33$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $57a654d4ad77ff33$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $57a654d4ad77ff33$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $57a654d4ad77ff33$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $57a654d4ad77ff33$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $57a654d4ad77ff33$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($57a654d4ad77ff33$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $57a654d4ad77ff33$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $57a654d4ad77ff33$var$sectorContainsSector(m, p) {
    return $57a654d4ad77ff33$var$area(m.prev, m, p.prev) < 0 && $57a654d4ad77ff33$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $57a654d4ad77ff33$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $57a654d4ad77ff33$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $57a654d4ad77ff33$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $57a654d4ad77ff33$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $57a654d4ad77ff33$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $57a654d4ad77ff33$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $57a654d4ad77ff33$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $57a654d4ad77ff33$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$57a654d4ad77ff33$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($57a654d4ad77ff33$var$locallyInside(a, b) && $57a654d4ad77ff33$var$locallyInside(b, a) && $57a654d4ad77ff33$var$middleInside(a, b) && // locally visible
    ($57a654d4ad77ff33$var$area(a.prev, a, b.prev) || $57a654d4ad77ff33$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $57a654d4ad77ff33$var$equals(a, b) && $57a654d4ad77ff33$var$area(a.prev, a, a.next) > 0 && $57a654d4ad77ff33$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $57a654d4ad77ff33$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $57a654d4ad77ff33$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $57a654d4ad77ff33$var$intersects(p1, q1, p2, q2) {
    var o1 = $57a654d4ad77ff33$var$sign($57a654d4ad77ff33$var$area(p1, q1, p2));
    var o2 = $57a654d4ad77ff33$var$sign($57a654d4ad77ff33$var$area(p1, q1, q2));
    var o3 = $57a654d4ad77ff33$var$sign($57a654d4ad77ff33$var$area(p2, q2, p1));
    var o4 = $57a654d4ad77ff33$var$sign($57a654d4ad77ff33$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $57a654d4ad77ff33$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $57a654d4ad77ff33$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $57a654d4ad77ff33$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $57a654d4ad77ff33$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $57a654d4ad77ff33$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $57a654d4ad77ff33$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $57a654d4ad77ff33$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $57a654d4ad77ff33$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $57a654d4ad77ff33$var$locallyInside(a, b) {
    return $57a654d4ad77ff33$var$area(a.prev, a, a.next) < 0 ? $57a654d4ad77ff33$var$area(a, b, a.next) >= 0 && $57a654d4ad77ff33$var$area(a, a.prev, b) >= 0 : $57a654d4ad77ff33$var$area(a, b, a.prev) < 0 || $57a654d4ad77ff33$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $57a654d4ad77ff33$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $57a654d4ad77ff33$var$splitPolygon(a, b) {
    var a2 = new $57a654d4ad77ff33$var$Node(a.i, a.x, a.y), b2 = new $57a654d4ad77ff33$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $57a654d4ad77ff33$var$insertNode(i, x, y, last) {
    var p = new $57a654d4ad77ff33$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $57a654d4ad77ff33$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $57a654d4ad77ff33$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$57a654d4ad77ff33$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($57a654d4ad77ff33$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($57a654d4ad77ff33$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $57a654d4ad77ff33$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$57a654d4ad77ff33$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});



parcelRegister("6XtRL", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $0df25a3f3e3326a5$export$cbe813d11f2192b2);
"use strict";
const $0df25a3f3e3326a5$export$cbe813d11f2192b2 = {
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width >= 0 && height >= 0)) return points;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("7pckg", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $613d9350953c306f$export$8eb75cb9f614d270);
"use strict";
const $613d9350953c306f$export$8eb75cb9f614d270 = {
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});



parcelRegister("3Qnjg", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $3d08f8352573da06$export$722a6ea8c60ca86);

var $iUbYJ = parcelRequire("iUbYJ");

var $lTNTn = parcelRequire("lTNTn");

var $2FMN6 = parcelRequire("2FMN6");

var $9mHtV = parcelRequire("9mHtV");

var $kYZ33 = parcelRequire("kYZ33");

var $1UVG8 = parcelRequire("1UVG8");
"use strict";
const $3d08f8352573da06$var$_FillGradient = class _FillGradient {
    constructor(x0, y0, x1, y1){
        this.uid = (0, $1UVG8.uid)("fillGradient");
        this.type = "linear";
        this.gradientStops = [];
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    addColorStop(offset, color) {
        this.gradientStops.push({
            offset: offset,
            color: (0, $iUbYJ.Color).shared.setValue(color).toHex()
        });
        return this;
    }
    // TODO move to the system!
    buildLinearGradient() {
        const defaultSize = _FillGradient.defaultTextureSize;
        const { gradientStops: gradientStops } = this;
        const canvas = (0, $lTNTn.DOMAdapter).get().createCanvas();
        canvas.width = defaultSize;
        canvas.height = defaultSize;
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, _FillGradient.defaultTextureSize, 1);
        for(let i = 0; i < gradientStops.length; i++){
            const stop = gradientStops[i];
            gradient.addColorStop(stop.offset, stop.color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $kYZ33.Texture)({
            source: new (0, $9mHtV.ImageSource)({
                resource: canvas,
                addressModeU: "clamp-to-edge",
                addressModeV: "repeat"
            })
        });
        const { x0: x0, y0: y0, x1: x1, y1: y1 } = this;
        const m = new (0, $2FMN6.Matrix)();
        const dx = x1 - x0;
        const dy = y1 - y0;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        m.translate(-x0, -y0);
        m.scale(1 / defaultSize, 1 / defaultSize);
        m.rotate(-angle);
        m.scale(256 / dist, 1);
        this.transform = m;
    }
};
$3d08f8352573da06$var$_FillGradient.defaultTextureSize = 256;
let $3d08f8352573da06$export$722a6ea8c60ca86 = $3d08f8352573da06$var$_FillGradient;

});

parcelRegister("aNCqh", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $fe930bc71334a4d1$export$3d1378c7410cd8e);

var $2FMN6 = parcelRequire("2FMN6");

var $1UVG8 = parcelRequire("1UVG8");
"use strict";
const $fe930bc71334a4d1$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $fe930bc71334a4d1$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        this.uid = (0, $1UVG8.uid)("fillPattern");
        this.transform = new (0, $2FMN6.Matrix)();
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $fe930bc71334a4d1$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $fe930bc71334a4d1$var$repetitionMap[repetition].addressModeV;
        }
    }
    setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
    }
}

});

parcelRegister("8Tto2", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $914d87ccb7027da8$export$29d3e417456abdad);

var $fi8wV = parcelRequire("fi8wV");

var $jNMvk = parcelRequire("jNMvk");

var $dWKjp = parcelRequire("dWKjp");
"use strict";
class $914d87ccb7027da8$export$29d3e417456abdad extends (0, $jNMvk.Container) {
    /**
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $dWKjp.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        this.canBundle = true;
        this.renderPipeId = "graphics";
        this._roundPixels = 0;
        if (!context) this._context = this._ownedContext = new (0, $dWKjp.GraphicsContext)();
        else this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        this._context.off("update", this.onViewUpdate, this);
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphic.
   * @type {rendering.Bounds}
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        bounds.addBounds(this._context.bounds);
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   *  Whether or not to round the x/y position of the graphic.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    onViewUpdate() {
        this._didChangeId += 4096;
        this._didGraphicsUpdate = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        if (this.renderGroup) this.renderGroup.onChildViewUpdate(this);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @param {boolean} [options.texture=false] - Should destroy the texture of the graphics context
   * @param {boolean} [options.textureSource=false] - Should destroy the texture source of the graphics context
   * @param {boolean} [options.context=false] - Should destroy the context
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param {FillStyleInputs} args - The fill style to apply. This can be a simple color, a gradient or
   * pattern object, or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param {FillStyleInputs} args - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   * or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyleInputs parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param {FillStyleInputs} args - (Optional) The stroke style to apply. Can be defined as a simple color or a more
   * complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * The fill style to use.
   * @type {ConvertedFillStyle}
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * The stroke style to use.
   * @type {ConvertedStrokeStyle}
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object.
   * Note that only the context of the object is cloned, not its transform (position,scale,etc)
   * @param deep - Whether to create a deep clone of the graphics object. If false, the context
   * will be shared between the two objects (default false). If true, the context will be
   * cloned (recommended if you need to modify the context in any way).
   * @returns - A clone of the graphics object
   */ clone(deep = false) {
        if (deep) return new $914d87ccb7027da8$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $914d87ccb7027da8$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        color && (fillStyle.color = color);
        alpha && (fillStyle.alpha = alpha);
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $dWKjp.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $dWKjp.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $dWKjp.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});
parcelRegister("dWKjp", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $a8c2e583e11f8661$export$cde35afe8b5f985);

var $hcgfX = parcelRequire("hcgfX");

var $iUbYJ = parcelRequire("iUbYJ");

var $2FMN6 = parcelRequire("2FMN6");

var $dXIDd = parcelRequire("dXIDd");

var $kYZ33 = parcelRequire("kYZ33");

var $1UVG8 = parcelRequire("1UVG8");

var $fi8wV = parcelRequire("fi8wV");

var $bPvY0 = parcelRequire("bPvY0");

var $kP4ei = parcelRequire("kP4ei");

var $aZfTk = parcelRequire("aZfTk");

var $1s2cj = parcelRequire("1s2cj");
"use strict";
const $a8c2e583e11f8661$var$tmpPoint = new (0, $dXIDd.Point)();
const $a8c2e583e11f8661$var$tempMatrix = new (0, $2FMN6.Matrix)();
const $a8c2e583e11f8661$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    constructor(){
        super(...arguments);
        this.uid = (0, $1UVG8.uid)("graphicsContext");
        this.dirty = true;
        this.batchMode = "auto";
        this.instructions = [];
        this._activePath = new (0, $kP4ei.GraphicsPath)();
        this._transform = new (0, $2FMN6.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $bPvY0.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $1s2cj.convertFillInputToFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $1s2cj.convertFillInputToFillStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $1s2cj.convertFillInputToFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $1s2cj.convertFillInputToFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint ? (0, $iUbYJ.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $kP4ei.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $1s2cj.convertFillInputToFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $dXIDd.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyleInputs parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $1s2cj.convertFillInputToFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $aZfTk.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $2FMN6.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $2FMN6.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $a8c2e583e11f8661$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($a8c2e583e11f8661$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
        this._boundsDirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const padding = data.style.width / 2;
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - padding, _bounds.minY - padding, _bounds.maxX + padding, _bounds.maxY + padding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $a8c2e583e11f8661$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, style.width);
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the fill/stroke style?
   * @param {boolean} [options.textureSource=false] - Should it destroy the texture source of the fill/stroke style?
   */ destroy(options = false) {
        this._stateStack.length = 0;
        this._transform = null;
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $a8c2e583e11f8661$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $kYZ33.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
/** The default stroke style to use when none is provided. */ $a8c2e583e11f8661$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $kYZ33.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
let $a8c2e583e11f8661$export$cde35afe8b5f985 = $a8c2e583e11f8661$var$_GraphicsContext;

});
parcelRegister("kP4ei", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $81b9a1d34f496b2e$export$7e54506375634c19);

var $dXIDd = parcelRequire("dXIDd");

var $1UVG8 = parcelRequire("1UVG8");

var $eDLY3 = parcelRequire("eDLY3");

var $iX8Hx = parcelRequire("iX8Hx");

var $7yWdE = parcelRequire("7yWdE");
"use strict";
class $81b9a1d34f496b2e$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   */ constructor(instructions){
        this.instructions = [];
        this.uid = (0, $1UVG8.uid)("graphicsPath");
        this._dirty = true;
        if (typeof instructions === "string") (0, $iX8Hx.SVGToGraphicsPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $7yWdE.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $dXIDd.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $dXIDd.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius = innerRadius || radius / 2;
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $81b9a1d34f496b2e$export$7e54506375634c19();
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $81b9a1d34f496b2e$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $81b9a1d34f496b2e$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $81b9a1d34f496b2e$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $81b9a1d34f496b2e$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $81b9a1d34f496b2e$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $eDLY3.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $81b9a1d34f496b2e$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("iX8Hx", function(module, exports) {

$parcel$export(module.exports, "SVGToGraphicsPath", () => $586d8918bfc16170$export$14a4a8042d02aa8d);

var $i0EsP = parcelRequire("i0EsP");

var $eDLY3 = parcelRequire("eDLY3");
"use strict";
function $586d8918bfc16170$export$14a4a8042d02aa8d(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($i0EsP)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], data[3], data[4], lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4], lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "Z":
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $eDLY3.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("i0EsP", function(module, exports) {
module.exports = $d1c79d5fcbcf1f8e$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $d1c79d5fcbcf1f8e$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $d1c79d5fcbcf1f8e$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $d1c79d5fcbcf1f8e$var$parse(path) {
    var data = [];
    path.replace($d1c79d5fcbcf1f8e$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $d1c79d5fcbcf1f8e$var$parseValues(args);
        // overloaded moveTo
        if (type == "m" && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = "l";
            command = command == "m" ? "l" : "L";
        }
        while(true){
            if (args.length == $d1c79d5fcbcf1f8e$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $d1c79d5fcbcf1f8e$var$length[type]) throw new Error("malformed path data");
            data.push([
                command
            ].concat(args.splice(0, $d1c79d5fcbcf1f8e$var$length[type])));
        }
    });
    return data;
}
var $d1c79d5fcbcf1f8e$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $d1c79d5fcbcf1f8e$var$parseValues(args) {
    var numbers = args.match($d1c79d5fcbcf1f8e$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("7yWdE", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $1399b28dcc6322c6$export$148534a3c727230b);

var $kMmiX = parcelRequire("kMmiX");

var $alo3m = parcelRequire("alo3m");

var $hBOGP = parcelRequire("hBOGP");

var $cYXQE = parcelRequire("cYXQE");

var $gww0Y = parcelRequire("gww0Y");

var $bPvY0 = parcelRequire("bPvY0");

var $bcpub = parcelRequire("bcpub");

var $lWYH1 = parcelRequire("lWYH1");

var $imF7Q = parcelRequire("imF7Q");

var $cmv6r = parcelRequire("cmv6r");

var $hy8HJ = parcelRequire("hy8HJ");

var $1hKd2 = parcelRequire("1hKd2");
"use strict";
const $1399b28dcc6322c6$var$tempRectangle = new (0, $cYXQE.Rectangle)();
class $1399b28dcc6322c6$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $bPvY0.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $imF7Q.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $cmv6r.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $hy8HJ.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $bcpub.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $lWYH1.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $cYXQE.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $kMmiX.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $hBOGP.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $1hKd2.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $1hKd2.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $alo3m.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $gww0Y.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $hBOGP.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $hBOGP.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (!lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($1399b28dcc6322c6$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("kMmiX", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f65158e5416f09a3$export$c89a927ffc67e6fa);

var $cYXQE = parcelRequire("cYXQE");
"use strict";
class $f65158e5416f09a3$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'circle'
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $f65158e5416f09a3$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @returns Whether the x/y coordinates are within this Circle
   */ strokeContains(x, y, width) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const r = this.radius;
        const w2 = width / 2;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance < r + w2 && distance > r - w2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $cYXQE.Rectangle)();
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @param circle - The circle to copy from.
   * @returns Returns itself.
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @param circle - The circle to copy to.
   * @returns Returns given parameter.
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("alo3m", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $eb5efb9ce0af0371$export$80b0269ab108fa11);

var $cYXQE = parcelRequire("cYXQE");
"use strict";
class $eb5efb9ce0af0371$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'ellipse'
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {Ellipse} A copy of the ellipse
   */ clone() {
        return new $eb5efb9ce0af0371$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width
   * @returns Whether the x/y coords are within this ellipse
   */ strokeContains(x, y, width) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const halfStrokeWidth = width / 2;
        const innerA = halfWidth - halfStrokeWidth;
        const innerB = halfHeight - halfStrokeWidth;
        const outerA = halfWidth + halfStrokeWidth;
        const outerB = halfHeight + halfStrokeWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerA * innerA) + normalizedY * normalizedY / (innerB * innerB);
        const outerEllipse = normalizedX * normalizedX / (outerA * outerA) + normalizedY * normalizedY / (outerB * outerB);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $cYXQE.Rectangle)(this.x - this.halfWidth, this.y - this.halfHeight, this.halfWidth * 2, this.halfHeight * 2);
    }
    /**
   * Copies another ellipse to this one.
   * @param ellipse - The ellipse to copy from.
   * @returns Returns itself.
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @param ellipse - The ellipse to copy to.
   * @returns Returns given parameter.
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("hBOGP", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $bab07ed19f948b9d$export$7d31b617c820d435);

var $g1wQX = parcelRequire("g1wQX");

var $cYXQE = parcelRequire("cYXQE");
"use strict";
class $bab07ed19f948b9d$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'polygon'
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice();
        const polygon = new $bab07ed19f948b9d$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this polygon
   */ strokeContains(x, y, strokeWidth) {
        const halfStrokeWidth = strokeWidth / 2;
        const halfStrokeWidthSqrd = halfStrokeWidth * halfStrokeWidth;
        const { points: points } = this;
        for(let i = 0; i < points.length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSqrd = (0, $g1wQX.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            if (distanceSqrd <= halfStrokeWidthSqrd) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $cYXQE.Rectangle)();
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @param polygon - The polygon to copy from.
   * @returns Returns itself.
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @param polygon - The polygon to copy to.
   * @returns Returns given parameter.
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon
   * @readonly
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon
   * @readonly
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon
   * @readonly
   */ get x() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */ get y() {
        return this.points[this.points.length - 1];
    }
}

});
parcelRegister("g1wQX", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $40ddc04a04839d9b$export$db32ff20ff695a);
"use strict";
function $40ddc04a04839d9b$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("gww0Y", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $9a1f70bd9423997f$export$d55ab2e3dc5a4263);

var $cYXQE = parcelRequire("cYXQE");
"use strict";
const $9a1f70bd9423997f$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, halfStrokeWidth)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - halfStrokeWidth && distance <= radius + halfStrokeWidth;
};
class $9a1f70bd9423997f$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'roundedRectangle'
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $cYXQE.Rectangle)();
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $9a1f70bd9423997f$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(pX, pY, strokeWidth) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const halfStrokeWidth = strokeWidth / 2;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - halfStrokeWidth && pX <= x + halfStrokeWidth || pX >= rightBound - halfStrokeWidth && pX <= rightBound + halfStrokeWidth) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - halfStrokeWidth && pY <= y + halfStrokeWidth || pY >= bottomBound - halfStrokeWidth && pY <= bottomBound + halfStrokeWidth) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $9a1f70bd9423997f$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY < innerY && $9a1f70bd9423997f$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY > bottomBound - radius && $9a1f70bd9423997f$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, halfStrokeWidth) || pX < innerX && pY > bottomBound - radius && $9a1f70bd9423997f$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, halfStrokeWidth));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("bcpub", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $d4ea763236305467$export$7dab5eac414ecba2);

var $8EVCF = parcelRequire("8EVCF");
"use strict";
const $d4ea763236305467$var$RECURSION_LIMIT = 8;
const $d4ea763236305467$var$FLT_EPSILON = 11920929e-14;
const $d4ea763236305467$var$PATH_DISTANCE_EPSILON = 1;
const $d4ea763236305467$var$curveAngleToleranceEpsilon = 0.01;
const $d4ea763236305467$var$mAngleTolerance = 0;
const $d4ea763236305467$var$mCuspLimit = 0;
function $d4ea763236305467$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $8EVCF.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($d4ea763236305467$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $d4ea763236305467$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $d4ea763236305467$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $d4ea763236305467$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $d4ea763236305467$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $d4ea763236305467$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $d4ea763236305467$var$FLT_EPSILON && d3 > $d4ea763236305467$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($d4ea763236305467$var$mAngleTolerance < $d4ea763236305467$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $d4ea763236305467$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($d4ea763236305467$var$mCuspLimit !== 0) {
                    if (da1 > $d4ea763236305467$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $d4ea763236305467$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $d4ea763236305467$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($d4ea763236305467$var$mAngleTolerance < $d4ea763236305467$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $d4ea763236305467$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($d4ea763236305467$var$mCuspLimit !== 0) {
                    if (da1 > $d4ea763236305467$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $d4ea763236305467$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($d4ea763236305467$var$mAngleTolerance < $d4ea763236305467$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $d4ea763236305467$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($d4ea763236305467$var$mCuspLimit !== 0) {
                    if (da1 > $d4ea763236305467$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $d4ea763236305467$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $d4ea763236305467$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});

parcelRegister("lWYH1", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $3bf61d260bf9ad76$export$d53ce9debfe7a6c2);

var $8EVCF = parcelRequire("8EVCF");
"use strict";
const $3bf61d260bf9ad76$var$RECURSION_LIMIT = 8;
const $3bf61d260bf9ad76$var$FLT_EPSILON = 11920929e-14;
const $3bf61d260bf9ad76$var$PATH_DISTANCE_EPSILON = 1;
const $3bf61d260bf9ad76$var$curveAngleToleranceEpsilon = 0.01;
const $3bf61d260bf9ad76$var$mAngleTolerance = 0;
function $3bf61d260bf9ad76$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $8EVCF.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($3bf61d260bf9ad76$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $3bf61d260bf9ad76$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $3bf61d260bf9ad76$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $3bf61d260bf9ad76$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $3bf61d260bf9ad76$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $3bf61d260bf9ad76$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $3bf61d260bf9ad76$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($3bf61d260bf9ad76$var$mAngleTolerance < $3bf61d260bf9ad76$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $3bf61d260bf9ad76$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $3bf61d260bf9ad76$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $3bf61d260bf9ad76$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("imF7Q", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $3f0f0653a4982d2b$export$ed8eebdc6998f0f6);
"use strict";
function $3f0f0653a4982d2b$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps = steps || Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI)));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("cmv6r", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $33cd6ebe24217921$export$d46b7933b415e02f);

var $imF7Q = parcelRequire("imF7Q");
"use strict";
function $33cd6ebe24217921$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $imF7Q.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("hy8HJ", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $c74bf45ac7e7de1c$export$71ccaa6dca53075e);

var $bcpub = parcelRequire("bcpub");
"use strict";
const $c74bf45ac7e7de1c$var$TAU = Math.PI * 2;
const $c74bf45ac7e7de1c$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $c74bf45ac7e7de1c$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $c74bf45ac7e7de1c$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $c74bf45ac7e7de1c$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $c74bf45ac7e7de1c$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $c74bf45ac7e7de1c$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $c74bf45ac7e7de1c$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $c74bf45ac7e7de1c$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $c74bf45ac7e7de1c$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $c74bf45ac7e7de1c$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $c74bf45ac7e7de1c$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $c74bf45ac7e7de1c$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $c74bf45ac7e7de1c$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $c74bf45ac7e7de1c$var$out);
    let { ang1: ang1, ang2: ang2 } = $c74bf45ac7e7de1c$var$out;
    const { centerX: centerX, centerY: centerY } = $c74bf45ac7e7de1c$var$out;
    let ratio = Math.abs(ang2) / ($c74bf45ac7e7de1c$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $c74bf45ac7e7de1c$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $c74bf45ac7e7de1c$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $c74bf45ac7e7de1c$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $c74bf45ac7e7de1c$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $bcpub.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("1hKd2", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $6dad69b0daf4879b$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $6dad69b0daf4879b$export$cf503f371c53af9e);
"use strict";
function $6dad69b0daf4879b$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $6dad69b0daf4879b$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("aZfTk", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $866789be72ef8eec$export$2cc2aaca18109aab);

var $iUbYJ = parcelRequire("iUbYJ");

var $kP4ei = parcelRequire("kP4ei");
"use strict";
function $866789be72ef8eec$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        path: new (0, $kP4ei.GraphicsPath)()
    };
    $866789be72ef8eec$var$renderChildren(svg, session, null, null);
    return graphicsContext;
}
function $866789be72ef8eec$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = $866789be72ef8eec$var$parseStyle(svg);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    session.context.fillStyle = fillStyle;
    session.context.strokeStyle = strokeStyle;
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            d = svg.getAttribute("d");
            graphicsPath = new (0, $kP4ei.GraphicsPath)(d);
            session.context.path(graphicsPath);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "circle":
            cx = $866789be72ef8eec$var$parseFloatAttribute(svg, "cx", 0);
            cy = $866789be72ef8eec$var$parseFloatAttribute(svg, "cy", 0);
            r = $866789be72ef8eec$var$parseFloatAttribute(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "rect":
            x = $866789be72ef8eec$var$parseFloatAttribute(svg, "x", 0);
            y = $866789be72ef8eec$var$parseFloatAttribute(svg, "y", 0);
            width = $866789be72ef8eec$var$parseFloatAttribute(svg, "width", 0);
            height = $866789be72ef8eec$var$parseFloatAttribute(svg, "height", 0);
            rx = $866789be72ef8eec$var$parseFloatAttribute(svg, "rx", 0);
            ry = $866789be72ef8eec$var$parseFloatAttribute(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "ellipse":
            cx = $866789be72ef8eec$var$parseFloatAttribute(svg, "cx", 0);
            cy = $866789be72ef8eec$var$parseFloatAttribute(svg, "cy", 0);
            rx = $866789be72ef8eec$var$parseFloatAttribute(svg, "rx", 0);
            ry = $866789be72ef8eec$var$parseFloatAttribute(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "line":
            x1 = $866789be72ef8eec$var$parseFloatAttribute(svg, "x1", 0);
            y1 = $866789be72ef8eec$var$parseFloatAttribute(svg, "y1", 0);
            x2 = $866789be72ef8eec$var$parseFloatAttribute(svg, "x2", 0);
            y2 = $866789be72ef8eec$var$parseFloatAttribute(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke();
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke();
            break;
        case "g":
        case "svg":
            break;
        default:
            console.info(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    for(let i = 0; i < children.length; i++)$866789be72ef8eec$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}
function $866789be72ef8eec$var$parseFloatAttribute(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}
function $866789be72ef8eec$var$parseStyle(svg) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    let useFill = false;
    let useStroke = false;
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i];
            const [key, value] = stylePart.split(":");
            switch(key){
                case "stroke":
                    if (value !== "none") {
                        strokeStyle.color = (0, $iUbYJ.Color).shared.setValue(value).toNumber();
                        useStroke = true;
                    }
                    break;
                case "stroke-width":
                    strokeStyle.width = Number(value);
                    break;
                case "fill":
                    if (value !== "none") {
                        useFill = true;
                        fillStyle.color = (0, $iUbYJ.Color).shared.setValue(value).toNumber();
                    }
                    break;
                case "fill-opacity":
                    fillStyle.alpha = Number(value);
                    break;
                case "stroke-opacity":
                    strokeStyle.alpha = Number(value);
                    break;
                case "opacity":
                    fillStyle.alpha = Number(value);
                    strokeStyle.alpha = Number(value);
                    break;
            }
        }
    } else {
        const stroke = svg.getAttribute("stroke");
        if (stroke && stroke !== "none") {
            useStroke = true;
            strokeStyle.color = (0, $iUbYJ.Color).shared.setValue(stroke).toNumber();
            strokeStyle.width = $866789be72ef8eec$var$parseFloatAttribute(svg, "stroke-width", 1);
        }
        const fill = svg.getAttribute("fill");
        if (fill && fill !== "none") {
            useFill = true;
            fillStyle.color = (0, $iUbYJ.Color).shared.setValue(fill).toNumber();
        }
    }
    return {
        strokeStyle: useStroke ? strokeStyle : null,
        fillStyle: useFill ? fillStyle : null
    };
}

});

parcelRegister("1s2cj", function(module, exports) {

$parcel$export(module.exports, "convertFillInputToFillStyle", () => $88b2df16ab45da0d$export$816bdeacb94f608f);

var $iUbYJ = parcelRequire("iUbYJ");

var $2FMN6 = parcelRequire("2FMN6");

var $kYZ33 = parcelRequire("kYZ33");

var $3Qnjg = parcelRequire("3Qnjg");

var $aNCqh = parcelRequire("aNCqh");
"use strict";
function $88b2df16ab45da0d$export$816bdeacb94f608f(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    let fillStyleToParse;
    let styleToMerge;
    if (value?.fill) {
        styleToMerge = value.fill;
        fillStyleToParse = {
            ...defaultStyle,
            ...value
        };
    } else {
        styleToMerge = value;
        fillStyleToParse = defaultStyle;
    }
    if ((0, $iUbYJ.Color).isColorLike(styleToMerge)) {
        const temp = (0, $iUbYJ.Color).shared.setValue(styleToMerge ?? 0);
        const opts = {
            ...fillStyleToParse,
            color: temp.toNumber(),
            alpha: temp.alpha === 1 ? fillStyleToParse.alpha : temp.alpha,
            texture: (0, $kYZ33.Texture).WHITE
        };
        return opts;
    } else if (styleToMerge instanceof (0, $aNCqh.FillPattern)) {
        const pattern = styleToMerge;
        return {
            ...fillStyleToParse,
            color: 16777215,
            texture: pattern.texture,
            matrix: pattern.transform,
            fill: fillStyleToParse.fill ?? null
        };
    } else if (styleToMerge instanceof (0, $3Qnjg.FillGradient)) {
        const gradient = styleToMerge;
        gradient.buildLinearGradient();
        return {
            ...fillStyleToParse,
            color: 16777215,
            texture: gradient.texture,
            matrix: gradient.transform
        };
    }
    const style = {
        ...defaultStyle,
        ...value
    };
    if (style.texture) {
        if (style.texture !== (0, $kYZ33.Texture).WHITE) {
            const m = style.matrix?.invert() || new (0, $2FMN6.Matrix)();
            m.scale(1 / style.texture.frame.width, 1 / style.texture.frame.height);
            style.matrix = m;
        }
        const sourceStyle = style.texture.source.style;
        if (sourceStyle.addressMode === "clamp-to-edge") sourceStyle.addressMode = "repeat";
    }
    const color = (0, $iUbYJ.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    style.matrix = style.matrix ? style.matrix.clone() : null;
    return style;
}

});



var $aa8570e847843fce$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("iIcUB"), JSON.parse('["iIcUB","initializer.js","1cJ4E","browserAll.b17b60eb.js","lvvYF","browserAll.c8033cb6.js","fGguE","browserAll.99ac5e47.js","gFiOe","webworkerAll.61695748.js","6khJu","WebGPURenderer.3c439df4.js","d8QeF","WebGPURenderer.5d2f51fe.js","9Nctv","WebGLRenderer.1b254aeb.js"]'));


function $c62271cf5485deee$export$7f4472f6708afaf3(element) {
    return new Animation(new KeyframeEffect(element, [
        {
            transform: "translateY(0px)"
        },
        {
            transform: "translateY(-10px)"
        },
        {
            transform: "translateY(0px)"
        }
    ], {
        duration: 200
    }), document.timeline);
}
function $c62271cf5485deee$export$9b47139b511b56e4(element) {
    return new Animation(new KeyframeEffect(element, [
        {
            transform: "scale(1)"
        },
        {
            transform: "scale(0.9)"
        },
        {
            transform: "scale(1.1)"
        },
        {
            transform: "scale(1)"
        }
    ], {
        duration: 200
    }), document.timeline);
}
function $c62271cf5485deee$export$9337593a59c580a0(element) {
    return new Animation(new KeyframeEffect(element, [
        {
            transform: "scale(1)"
        },
        {
            transform: "scale(0.85)"
        },
        {
            transform: "scale(1.15)"
        }
    ], {
        duration: 100,
        fill: "forwards"
    }), document.timeline);
}
function $c62271cf5485deee$export$6fadf95f00be44ec(element) {
    return new Animation(new KeyframeEffect(element, [
        {
            transform: "scale(1.15)"
        },
        {
            transform: "scale(1)"
        }
    ], {
        duration: 200,
        fill: "forwards"
    }), document.timeline);
}


const $adc8ed603088d5e4$var$yesButton = document.getElementById("yes");
const $adc8ed603088d5e4$var$noButton = document.getElementById("no");
const $adc8ed603088d5e4$var$startButton = document.getElementById("startButton");
const $adc8ed603088d5e4$var$backButton = document.getElementById("backButton");
const $adc8ed603088d5e4$var$footer = document.getElementById("footer");
const $adc8ed603088d5e4$var$settingsButton = document.getElementById("settingsButton");
const $adc8ed603088d5e4$var$helpButton = document.getElementById("helpButton");
const $adc8ed603088d5e4$var$explanationButton = document.getElementById("explanationButton");
const $adc8ed603088d5e4$var$explanationRow = document.getElementById("explanationRow");
const $adc8ed603088d5e4$var$explanationTextElement = document.getElementById("explanationText");
let $adc8ed603088d5e4$var$executeYesAnimation;
let $adc8ed603088d5e4$var$executeNoAnimation;
function $adc8ed603088d5e4$export$3b0bdf174ee79f95() {
    $adc8ed603088d5e4$var$explanationRow.classList.remove("d-none");
}
function $adc8ed603088d5e4$export$7bc8a245db2f4a6b() {
    $adc8ed603088d5e4$var$explanationRow.classList.add("d-none");
}
function $adc8ed603088d5e4$export$cc1444630dea247e() {
    $adc8ed603088d5e4$var$explanationButton.click();
}
function $adc8ed603088d5e4$export$fe0f91bfdcf210e0() {
    return !$adc8ed603088d5e4$var$explanationRow.classList.contains("d-none");
}
function $adc8ed603088d5e4$export$920fcc4645588d0e(text) {
    $adc8ed603088d5e4$var$explanationTextElement.innerHTML = text;
}
function $adc8ed603088d5e4$export$24102e422af3ddc2() {
    $adc8ed603088d5e4$var$yesButton.removeAttribute("disabled");
    $adc8ed603088d5e4$var$noButton.removeAttribute("disabled");
}
function $adc8ed603088d5e4$export$c44775eff6da4080() {
    $adc8ed603088d5e4$var$yesButton.setAttribute("disabled", "");
    $adc8ed603088d5e4$var$noButton.setAttribute("disabled", "");
}
function $adc8ed603088d5e4$export$e8b704861ed71a45() {
    $adc8ed603088d5e4$var$footer.classList.remove("d-none");
    $adc8ed603088d5e4$var$backButton.classList.add("d-none");
    $adc8ed603088d5e4$var$startButton.classList.remove("d-none");
    $adc8ed603088d5e4$var$settingsButton.classList.remove("invisible");
    $adc8ed603088d5e4$var$helpButton.classList.remove("d-none");
}
function $adc8ed603088d5e4$export$d1c87d7358bc8511() {
    $adc8ed603088d5e4$var$footer.classList.add("d-none");
    $adc8ed603088d5e4$var$startButton.classList.add("d-none");
    $adc8ed603088d5e4$var$backButton.classList.remove("d-none");
    $adc8ed603088d5e4$var$settingsButton.classList.add("invisible");
    $adc8ed603088d5e4$var$helpButton.classList.add("d-none");
}
function $adc8ed603088d5e4$export$d43aff215272e449() {
    return $adc8ed603088d5e4$var$yesButton.hasAttribute("disabled");
}
function $adc8ed603088d5e4$export$4bf5b96b516333b0() {
    return $adc8ed603088d5e4$var$noButton.hasAttribute("disabled");
}
function $adc8ed603088d5e4$export$d195ba7bb0fc15ea() {
    $adc8ed603088d5e4$var$yesButton.click();
}
function $adc8ed603088d5e4$export$2727bd01848e46aa() {
    $adc8ed603088d5e4$var$noButton.click();
}
function $adc8ed603088d5e4$export$a6eb1b0ae9ee63a1() {
    $adc8ed603088d5e4$var$startButton.click();
}
function $adc8ed603088d5e4$export$b073e1d36c4e6dbe() {
    return !$adc8ed603088d5e4$var$startButton.classList.contains("d-none");
}
function $adc8ed603088d5e4$export$43770586b72cc035() {
    return !$adc8ed603088d5e4$var$backButton.classList.contains("d-none");
}
function $adc8ed603088d5e4$export$2cd8252107eb640b() {
    $adc8ed603088d5e4$export$c44775eff6da4080();
    $adc8ed603088d5e4$var$executeYesAnimation = $c62271cf5485deee$export$9b47139b511b56e4($adc8ed603088d5e4$var$yesButton);
    $adc8ed603088d5e4$var$executeNoAnimation = $c62271cf5485deee$export$9b47139b511b56e4($adc8ed603088d5e4$var$noButton);
    $adc8ed603088d5e4$var$yesButton.onclick = ()=>{
        $adc8ed603088d5e4$var$executeYesAnimation.play();
        $0198b660ad8ac7b1$export$4f450b57e5b3f1d();
    };
    $adc8ed603088d5e4$var$noButton.onclick = ()=>{
        $adc8ed603088d5e4$var$executeNoAnimation.play();
        $0198b660ad8ac7b1$export$7021fabe1775dd8e();
    };
    $adc8ed603088d5e4$var$startButton.onclick = ()=>$0198b660ad8ac7b1$export$b01d08d42f405260();
    $adc8ed603088d5e4$var$backButton.onclick = ()=>$0198b660ad8ac7b1$export$c6938de3bf17624f();
    $adc8ed603088d5e4$var$settingsButton.onclick = ()=>$0198b660ad8ac7b1$export$e88d48933ac88f9e();
    $adc8ed603088d5e4$var$helpButton.onclick = ()=>$0198b660ad8ac7b1$export$6aac607299271c78();
    $adc8ed603088d5e4$var$explanationButton.onclick = ()=>$0198b660ad8ac7b1$export$7203a8ef4c4339b7();
}


function $ddf6b663eb139b5e$export$b141de964f0a90c1(min, max) {
    return Math.trunc(min + Math.random() * (max + 1 - min));
}
function $ddf6b663eb139b5e$export$980429ae575bc36f() {
    return Math.trunc(Math.random() * 2) === 0;
}
function $ddf6b663eb139b5e$export$23b1f9ce5361528e(length) {
    return $ddf6b663eb139b5e$export$b141de964f0a90c1(0, length - 1);
}


let $d69a6cb7004c4199$var$ultLevel = 0;
let $d69a6cb7004c4199$var$circles = document.getElementsByClassName("circle");
function $d69a6cb7004c4199$export$9eaace35961779f6() {
    return $d69a6cb7004c4199$var$ultLevel;
}
function $d69a6cb7004c4199$export$ccdc94379da04ede(currentHp, maximumHp) {
    let damage;
    switch($d69a6cb7004c4199$var$ultLevel){
        case 1:
            damage = 150 + 0.25 * (maximumHp - currentHp);
            break;
        case 2:
            damage = 300 + 0.3 * (maximumHp - currentHp);
            break;
        case 3:
            damage = 450 + 0.35 * (maximumHp - currentHp);
            break;
        default:
            return 0;
    }
    return Math.trunc(damage);
}
function $d69a6cb7004c4199$export$31a01f80a9edd186(currentHp, finalHp) {
    let damage;
    switch($d69a6cb7004c4199$var$ultLevel){
        case 1:
            damage = (currentHp - finalHp - 150) / 0.25 + currentHp;
            break;
        case 2:
            damage = (currentHp - finalHp - 300) / 0.3 + currentHp;
            break;
        case 3:
            damage = (currentHp - finalHp - 450) / 0.35 + currentHp;
            break;
        default:
            return 0;
    }
    return Math.trunc(damage);
}
function $d69a6cb7004c4199$export$4673b02ba7dd4876(maximumHp, finalHp) {
    let currentHp;
    switch($d69a6cb7004c4199$var$ultLevel){
        case 1:
            currentHp = (150 + 0.25 * maximumHp + finalHp) / 1.25;
            break;
        case 2:
            currentHp = (300 + 0.3 * maximumHp + finalHp) / 1.3;
            break;
        case 3:
            currentHp = (450 + 0.35 * maximumHp + finalHp) / 1.35;
            break;
        default:
            return 0;
    }
    return Math.trunc(currentHp);
}
function $d69a6cb7004c4199$var$updateUltLevel(newUltLevel) {
    $d69a6cb7004c4199$var$ultLevel = newUltLevel;
    $d69a6cb7004c4199$var$resetCircles();
    $d69a6cb7004c4199$var$selectCircles();
}
function $d69a6cb7004c4199$var$resetCircles() {
    for(let i = 0; i < $d69a6cb7004c4199$var$circles.length; i++)$d69a6cb7004c4199$var$circles[i].setAttribute("src", "../img/UltimateCircles/black_circle_color.svg");
}
function $d69a6cb7004c4199$var$selectCircles() {
    for(let i = 0; i < $d69a6cb7004c4199$var$ultLevel; i++)$d69a6cb7004c4199$var$circles[i].setAttribute("src", "../img/UltimateCircles/yellow_circle_color.svg");
}
function $d69a6cb7004c4199$export$e4af5c3d35f050ae() {
    let newUltLevel = $ddf6b663eb139b5e$export$b141de964f0a90c1(1, 3);
    if (newUltLevel === $d69a6cb7004c4199$var$ultLevel) {
        $d69a6cb7004c4199$export$e4af5c3d35f050ae();
        return;
    }
    $d69a6cb7004c4199$var$updateUltLevel(newUltLevel);
}
function $d69a6cb7004c4199$export$aad8462122ac592b() {
    $d69a6cb7004c4199$var$updateUltLevel(0);
}


const $4560290abc280b4c$var$timerBar = document.getElementById("timerBar");
let $4560290abc280b4c$var$barWidth = 100;
let $4560290abc280b4c$var$start = undefined;
let $4560290abc280b4c$var$stop = false;
const $4560290abc280b4c$var$maxDuration = 5;
const $4560290abc280b4c$var$minDuration = 1.5;
let $4560290abc280b4c$var$duration = $4560290abc280b4c$var$maxDuration;
let $4560290abc280b4c$var$requestID = null;
function $4560290abc280b4c$export$82e78ea772886f8c() {
    return $4560290abc280b4c$var$timerBar;
}
function $4560290abc280b4c$export$5985f5b4428bec55(callback) {
    $4560290abc280b4c$var$stop = false;
    requestAnimationFrame((e)=>$4560290abc280b4c$var$updateTimerBar(e, callback));
}
function $4560290abc280b4c$export$4d41f7386211339a() {
    if ($4560290abc280b4c$var$requestID !== null) cancelAnimationFrame($4560290abc280b4c$var$requestID);
    $4560290abc280b4c$var$stop = true;
}
function $4560290abc280b4c$export$148d61ea341bbff7() {
    $4560290abc280b4c$var$barWidth = 100;
    $4560290abc280b4c$var$timerBar.style.width = "100%";
}
function $4560290abc280b4c$export$c4688174d3db5a2c() {
    $4560290abc280b4c$var$start = undefined;
    $4560290abc280b4c$var$duration = $4560290abc280b4c$var$maxDuration;
    $4560290abc280b4c$export$148d61ea341bbff7();
}
function $4560290abc280b4c$export$55d6b35100aa8a91(value) {
    $4560290abc280b4c$var$duration -= value;
    if ($4560290abc280b4c$var$duration < $4560290abc280b4c$var$minDuration) $4560290abc280b4c$var$duration = $4560290abc280b4c$var$minDuration;
}
function $4560290abc280b4c$var$updateTimerBar(step, callback) {
    if ($4560290abc280b4c$var$start === undefined) $4560290abc280b4c$var$start = step;
    $4560290abc280b4c$var$barWidth -= (step - $4560290abc280b4c$var$start) / (10 * $4560290abc280b4c$var$duration);
    $4560290abc280b4c$var$timerBar.style.width = $4560290abc280b4c$var$barWidth + "%";
    $4560290abc280b4c$var$start = step;
    if ($4560290abc280b4c$var$stop) return;
    if ($4560290abc280b4c$var$barWidth <= 0) {
        $4560290abc280b4c$var$timerBar.style.width = "0%";
        callback();
        return;
    }
    $4560290abc280b4c$var$requestID = requestAnimationFrame((e)=>$4560290abc280b4c$var$updateTimerBar(e, callback));
}




const $94a4639c454b28ff$var$highscoreElement = document.getElementById("highscore");
const $94a4639c454b28ff$var$resetButton = document.getElementById("resetHighscoreButton");
const $94a4639c454b28ff$var$scoreElement = document.getElementById("score");
let $94a4639c454b28ff$var$scoreAnimation;
let $94a4639c454b28ff$var$highscoreAnimation;
function $94a4639c454b28ff$export$482310739c8f9d71(newScore) {
    $94a4639c454b28ff$var$scoreElement.innerText = String(newScore);
    $94a4639c454b28ff$var$scoreAnimation.play();
}
function $94a4639c454b28ff$export$d1dff7db5cbbcb72(newHighscore) {
    $94a4639c454b28ff$var$highscoreElement.innerText = String(newHighscore);
    $94a4639c454b28ff$var$highscoreAnimation.play();
    if (newHighscore === 0) $94a4639c454b28ff$var$disableButton();
    else $94a4639c454b28ff$var$enableButton();
}
function $94a4639c454b28ff$var$enableButton() {
    $94a4639c454b28ff$var$resetButton.removeAttribute("disabled");
}
function $94a4639c454b28ff$var$disableButton() {
    $94a4639c454b28ff$var$resetButton.setAttribute("disabled", "");
}
function $94a4639c454b28ff$export$2cd8252107eb640b() {
    document.getElementById("resetHighscoreButton").onclick = $0198b660ad8ac7b1$export$d8d89c11f461d47c;
    $94a4639c454b28ff$var$scoreAnimation = $c62271cf5485deee$export$7f4472f6708afaf3($94a4639c454b28ff$var$scoreElement);
    $94a4639c454b28ff$var$highscoreAnimation = $c62271cf5485deee$export$7f4472f6708afaf3($94a4639c454b28ff$var$highscoreElement);
}





var $fgNUY = parcelRequire("fgNUY");
"use strict";

const $608a77bfa6d2fa18$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $fgNUY.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("seZ39"));
    }
};



var $fgNUY = parcelRequire("fgNUY");
"use strict";

const $dab2ef07f0ad5aa1$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $fgNUY.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("hdGnR"));
    }
};



var $fgNUY = parcelRequire("fgNUY");
parcelRequire("guhjI");
parcelRequire("1Hpjw");












































var $fgNUY = parcelRequire("fgNUY");

var $fgNUY = parcelRequire("fgNUY");
"use strict";
const $bbaf6acc910ad932$var$environments = [];
(0, $fgNUY.extensions).handleByNamedList((0, $fgNUY.ExtensionType).Environment, $bbaf6acc910ad932$var$environments);
async function $bbaf6acc910ad932$export$72225172dd907279(manageImports) {
    if (!manageImports) return;
    for(let i = 0; i < $bbaf6acc910ad932$var$environments.length; i++){
        const env = $bbaf6acc910ad932$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}



var $lTNTn = parcelRequire("lTNTn");

var $2RX6C = parcelRequire("2RX6C");
"use strict";
let $fc17eafe10d636d8$var$_isWebGLSupported;
function $fc17eafe10d636d8$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($fc17eafe10d636d8$var$_isWebGLSupported !== void 0) return $fc17eafe10d636d8$var$_isWebGLSupported;
    $fc17eafe10d636d8$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $2RX6C.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $lTNTn.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $lTNTn.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    })();
    return $fc17eafe10d636d8$var$_isWebGLSupported;
}



var $lTNTn = parcelRequire("lTNTn");
"use strict";
let $a8eb154d6278a017$var$_isWebGPUSupported;
async function $a8eb154d6278a017$export$216169f30082c873(options = {}) {
    if ($a8eb154d6278a017$var$_isWebGPUSupported !== void 0) return $a8eb154d6278a017$var$_isWebGPUSupported;
    $a8eb154d6278a017$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $lTNTn.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await navigator.gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (e) {
            return false;
        }
    })();
    return $a8eb154d6278a017$var$_isWebGPUSupported;
}



var $2RX6C = parcelRequire("2RX6C");
"use strict";
const $cc58ee04f76b9661$var$renderPriority = [
    "webgpu",
    "webgl",
    "canvas"
];


async function $cc58ee04f76b9661$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $cc58ee04f76b9661$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $cc58ee04f76b9661$var$renderPriority.slice();
    let RendererClass;
    await (0, $bbaf6acc910ad932$export$72225172dd907279)(options.manageImports ?? true);
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $a8eb154d6278a017$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("5AbgC"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $fc17eafe10d636d8$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $2RX6C.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("ajlyv"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            break;
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $jNMvk = parcelRequire("jNMvk");

var $fi8wV = parcelRequire("fi8wV");
"use strict";
const $3182dfdbc87ae945$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /** The root display container that's rendered. */ this.stage = new (0, $jNMvk.Container)();
        if (args[0] !== void 0) (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * @param options - The optional application and renderer parameters.
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $cc58ee04f76b9661$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element.
   * @readonly
   * @member {HTMLCanvasElement}
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {HTMLCanvasElement}
   * @deprecated since 8.0.0
   */ get view() {
        (0, $fi8wV.deprecation)((0, $fi8wV.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @readonly
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   * @param {object|boolean}[rendererDestroyOptions=false] - The options for destroying the renderer.
   * @param {boolean}[rendererDestroyOptions.removeView=false] - Removes the Canvas element from the DOM.
   * @param {object|boolean} [options=false] - The options for destroying the stage.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy method
   * called as well. `options` will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true,
   * it should destroy the texture of the child sprite.
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   *  If options.children is set to true,
   * it should destroy the texture source of the child sprite.
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true,
   * it should destroy the context of the child graphics.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @alias _plugins
 */ $3182dfdbc87ae945$var$_Application._plugins = [];
let $3182dfdbc87ae945$export$16975c34e60e1e61 = $3182dfdbc87ae945$var$_Application;
(0, $fgNUY.extensions).handleByList((0, $fgNUY.ExtensionType).Application, $3182dfdbc87ae945$export$16975c34e60e1e61._plugins);






























































































































































































































































































































var $PSAj8 = parcelRequire("PSAj8");




















































var $3Qnjg = parcelRequire("3Qnjg");


var $8Tto2 = parcelRequire("8Tto2");






























































































var $hcgfX = parcelRequire("hcgfX");
















var $7wyyT = parcelRequire("7wyyT");
"use strict";
(0, $fgNUY.extensions).add((0, $608a77bfa6d2fa18$export$a6aad6334ef58a1c), (0, $dab2ef07f0ad5aa1$export$ee43dd1acddf6cf8));


var $8Tto2 = parcelRequire("8Tto2");
var $3Qnjg = parcelRequire("3Qnjg");
let $ff8afec5bc7f4525$var$currentHp = 0;
let $ff8afec5bc7f4525$var$maximumHp = 0;
const $ff8afec5bc7f4525$var$thickLineWidth = 4;
const $ff8afec5bc7f4525$var$thinLineWidth = 2;
let $ff8afec5bc7f4525$var$app = new (0, $3182dfdbc87ae945$export$16975c34e60e1e61)();
let $ff8afec5bc7f4525$var$graphics = new (0, $8Tto2.Graphics)();
let $ff8afec5bc7f4525$var$canvas = document.getElementById("hpBar");
var $ff8afec5bc7f4525$var$Direction;
(function(Direction) {
    Direction[Direction["Up"] = 0] = "Up";
    Direction[Direction["Right"] = 1] = "Right";
    Direction[Direction["Down"] = 2] = "Down";
    Direction[Direction["Left"] = 3] = "Left";
})($ff8afec5bc7f4525$var$Direction || ($ff8afec5bc7f4525$var$Direction = {}));
function $ff8afec5bc7f4525$export$b22679e45cae3d6f() {
    return $ff8afec5bc7f4525$var$currentHp;
}
function $ff8afec5bc7f4525$export$4185a9fe0d63b2e6() {
    return $ff8afec5bc7f4525$var$maximumHp;
}
function $ff8afec5bc7f4525$export$17e2c3331411e3a9(difficulty) {
    $ff8afec5bc7f4525$var$graphics.clear();
    $ff8afec5bc7f4525$var$generateHealth(difficulty);
    $ff8afec5bc7f4525$var$updateHpBar();
    $ff8afec5bc7f4525$var$app.stage.addChild($ff8afec5bc7f4525$var$graphics);
}
function $ff8afec5bc7f4525$export$7a03d8bb05d3f187() {
    $ff8afec5bc7f4525$var$app.canvas.classList.remove("d-none");
}
function $ff8afec5bc7f4525$export$c7e1758fe1fe8869() {
    $ff8afec5bc7f4525$var$app.canvas.classList.add("d-none");
}
function $ff8afec5bc7f4525$export$82e78ea772886f8c() {
    return $ff8afec5bc7f4525$var$app.canvas;
}
function $ff8afec5bc7f4525$var$updateHpBar() {
    if ($ff8afec5bc7f4525$var$currentHp > $ff8afec5bc7f4525$var$maximumHp) return;
    const visibleLineAmount = $ff8afec5bc7f4525$var$currentHp / 100;
    const totalLineAmount = $ff8afec5bc7f4525$var$maximumHp / 100;
    const step = $ff8afec5bc7f4525$var$canvas.width / totalLineAmount;
    const visibleWidth = visibleLineAmount * step;
    const invisibleWidth = $ff8afec5bc7f4525$var$canvas.width - visibleWidth;
    $ff8afec5bc7f4525$var$drawHpColors(visibleWidth, invisibleWidth);
    $ff8afec5bc7f4525$var$drawHpLines(visibleLineAmount, step);
}
function $ff8afec5bc7f4525$var$drawRectGradient(x, y, width, height, colors, direction) {
    const colorStops = colors;
    let gradientFill;
    switch(direction){
        case 0:
            gradientFill = new (0, $3Qnjg.FillGradient)(0, height, 0, 0);
            break;
        case 1:
            gradientFill = new (0, $3Qnjg.FillGradient)(0, 0, height, 0);
            break;
        case 2:
            gradientFill = new (0, $3Qnjg.FillGradient)(0, 0, 0, height);
            break;
        case 3:
            gradientFill = new (0, $3Qnjg.FillGradient)(height, 0, 0, 0);
            break;
        default:
            return;
    }
    colorStops.forEach((number, index)=>{
        const ratio = index / colorStops.length;
        gradientFill.addColorStop(ratio, number);
    });
    $ff8afec5bc7f4525$var$drawRectFill(x, y, width, height, gradientFill);
}
function $ff8afec5bc7f4525$var$drawRectFill(x, y, width, height, color) {
    $ff8afec5bc7f4525$var$graphics.rect(x, y, width, height).fill(color);
}
function $ff8afec5bc7f4525$var$drawHpColors(visibleWidth, invisibleWidth) {
    $ff8afec5bc7f4525$var$drawRectGradient(0, 0, visibleWidth, $ff8afec5bc7f4525$var$canvas.height, [
        "#f48d84",
        "#c64135",
        "#8e0b00"
    ], 2);
    $ff8afec5bc7f4525$var$drawRectFill(visibleWidth, 0, invisibleWidth, $ff8afec5bc7f4525$var$canvas.height, "black");
}
function $ff8afec5bc7f4525$var$drawHpLines(visibleLineAmount, step) {
    for(let i = 1; i <= visibleLineAmount; i++){
        let currentStep = i * step;
        if (i % 10 === 0) $ff8afec5bc7f4525$var$drawRectFill(currentStep - $ff8afec5bc7f4525$var$thickLineWidth / 2, 0, $ff8afec5bc7f4525$var$thickLineWidth, $ff8afec5bc7f4525$var$canvas.height, "black");
        else $ff8afec5bc7f4525$var$drawRectFill(currentStep - $ff8afec5bc7f4525$var$thinLineWidth / 2, 0, $ff8afec5bc7f4525$var$thinLineWidth, $ff8afec5bc7f4525$var$canvas.height / 2, "black");
    }
}
function $ff8afec5bc7f4525$var$generateHealth(difficulty) {
    let low;
    let max;
    switch(difficulty){
        case 0:
            low = 200;
            max = 250;
            break;
        case 1:
            low = 150;
            max = 200;
            break;
        case 2:
            low = 100;
            max = 150;
            break;
        case 3:
            low = 50;
            max = 100;
            break;
        case 4:
            low = 25;
            max = 50;
            break;
        default:
            return;
    }
    let finalHp = $ddf6b663eb139b5e$export$b141de964f0a90c1(low, max);
    if ($ddf6b663eb139b5e$export$980429ae575bc36f()) finalHp *= -1;
    switch($d69a6cb7004c4199$export$9eaace35961779f6()){
        case 1:
            $ff8afec5bc7f4525$var$maximumHp = $ddf6b663eb139b5e$export$b141de964f0a90c1(1250, 2250);
            break;
        case 2:
            $ff8afec5bc7f4525$var$maximumHp = $ddf6b663eb139b5e$export$b141de964f0a90c1(2250, 3250);
            break;
        case 3:
            $ff8afec5bc7f4525$var$maximumHp = $ddf6b663eb139b5e$export$b141de964f0a90c1(3250, 6000);
            break;
    }
    $ff8afec5bc7f4525$var$currentHp = $d69a6cb7004c4199$export$4673b02ba7dd4876($ff8afec5bc7f4525$var$maximumHp, finalHp);
}
async function $ff8afec5bc7f4525$export$2cd8252107eb640b() {
    let computedStyle = getComputedStyle($ff8afec5bc7f4525$var$canvas);
    let borderX = parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.borderRightWidth);
    let borderY = parseFloat(computedStyle.borderTopWidth) + parseFloat(computedStyle.borderBottomWidth);
    let desiredWidth = $ff8afec5bc7f4525$var$canvas.offsetWidth - borderX;
    let desiredHeight = $ff8afec5bc7f4525$var$canvas.offsetHeight - borderY;
    await $ff8afec5bc7f4525$var$app.init({
        width: desiredWidth,
        height: desiredHeight
    });
    $ff8afec5bc7f4525$var$app.canvas.classList.add("w-100", "h-100", "d-none");
    $ff8afec5bc7f4525$var$app.canvas.width = desiredWidth;
    $ff8afec5bc7f4525$var$app.canvas.height = desiredHeight;
    $ff8afec5bc7f4525$var$app.canvas.style.width = String(desiredWidth);
    $ff8afec5bc7f4525$var$app.canvas.style.height = String(desiredHeight);
    $ff8afec5bc7f4525$var$canvas.replaceWith($ff8afec5bc7f4525$var$app.canvas);
    $ff8afec5bc7f4525$var$canvas = $ff8afec5bc7f4525$var$app.canvas;
}


function $affe6f755c7ef6eb$export$a8a369b1165c658c(currentHp, maximumHp, ultDamage) {
    return `CORRECT ANSWER: <span>${ultDamage >= currentHp ? "\uD83D\uDC4D" : "\uD83D\uDC4E"}</span><br>
            MAXIMUM HP: <span>${Math.trunc(maximumHp)}</span><br>
            CURRENT HP: <span>${currentHp}</span><br>
            ULT DAMAGE: <span>${Math.trunc(ultDamage)}</span><br>
            REMAINING HP: <span>${Math.trunc(currentHp - ultDamage)}</span>`;
}


const $1938e89565799da2$var$keys = {
    highscore: "highscore-",
    cursor: "cursor",
    difficulty: "difficulty",
    theme: "theme"
};
function $1938e89565799da2$var$get(key) {
    return localStorage.getItem(key);
}
function $1938e89565799da2$var$set(key, value) {
    localStorage.setItem(key, value);
}
function $1938e89565799da2$var$getNumber(key) {
    let value = $1938e89565799da2$var$get(key);
    if (value === null) return null;
    return Number(value);
}
function $1938e89565799da2$var$setNumber(key, value) {
    $1938e89565799da2$var$set(key, String(value));
}
function $1938e89565799da2$export$324a59f4a7abce50(difficulty) {
    return $1938e89565799da2$var$getNumber($1938e89565799da2$var$keys.highscore + difficulty) ?? 0;
}
function $1938e89565799da2$export$fdd11945b7cd5309(highscore, difficulty) {
    $1938e89565799da2$var$setNumber($1938e89565799da2$var$keys.highscore + difficulty, highscore);
}
function $1938e89565799da2$export$da3f040fb23d21f() {
    return $1938e89565799da2$var$getNumber($1938e89565799da2$var$keys.cursor) ?? 1;
}
function $1938e89565799da2$export$ca17b14bf34aba4(value) {
    $1938e89565799da2$var$setNumber($1938e89565799da2$var$keys.cursor, value);
}
function $1938e89565799da2$export$97b5f4a7021b3b89() {
    return $1938e89565799da2$var$getNumber($1938e89565799da2$var$keys.difficulty) ?? 0;
}
function $1938e89565799da2$export$97047fee56e872c0(difficulty) {
    $1938e89565799da2$var$setNumber($1938e89565799da2$var$keys.difficulty, difficulty);
}
function $1938e89565799da2$export$89cbf1a0881c8b9c() {
    return $1938e89565799da2$var$getNumber($1938e89565799da2$var$keys.theme) ?? 0;
}
function $1938e89565799da2$export$2e49b867b7a0847c(value) {
    $1938e89565799da2$var$setNumber($1938e89565799da2$var$keys.theme, value);
}



const $b153e45f560be665$var$basePath = "../audio/";
const $b153e45f560be665$var$correctFolder = "correct/";
const $b153e45f560be665$var$incorrectFolder = "incorrect/";
const $b153e45f560be665$var$correctSounds = [
    "hit-1.mp3",
    "hit-2.mp3",
    "hit-3.mp3",
    "hit-4.mp3"
];
const $b153e45f560be665$var$incorrectSounds = [
    "death.mp3"
];
let $b153e45f560be665$var$audio = new Audio();
function $b153e45f560be665$export$214c7098e52ba5d8() {
    return [
        ...$b153e45f560be665$var$correctSounds,
        ...$b153e45f560be665$var$incorrectSounds
    ];
}
function $b153e45f560be665$export$fa6813432f753b0d() {
    if ($b153e45f560be665$var$audio.paused) return;
    $b153e45f560be665$var$audio.pause();
}
function $b153e45f560be665$export$34f45ef1be1c83fd() {
    let randomIndex = $ddf6b663eb139b5e$export$23b1f9ce5361528e($b153e45f560be665$var$correctSounds.length);
    $b153e45f560be665$var$audio.src = $b153e45f560be665$var$correctSounds[randomIndex];
    $b153e45f560be665$var$audio.play();
}
function $b153e45f560be665$export$a20be2e32b519a82() {
    let randomIndex = $ddf6b663eb139b5e$export$23b1f9ce5361528e($b153e45f560be665$var$incorrectSounds.length);
    $b153e45f560be665$var$audio.src = $b153e45f560be665$var$incorrectSounds[randomIndex];
    $b153e45f560be665$var$audio.play();
}
function $b153e45f560be665$export$2cd8252107eb640b() {
    for(let i = 0; i < $b153e45f560be665$var$correctSounds.length; i++)$b153e45f560be665$var$correctSounds[i] = $b153e45f560be665$var$basePath + $b153e45f560be665$var$correctFolder + $b153e45f560be665$var$correctSounds[i];
    for(let i = 0; i < $b153e45f560be665$var$incorrectSounds.length; i++)$b153e45f560be665$var$incorrectSounds[i] = $b153e45f560be665$var$basePath + $b153e45f560be665$var$incorrectFolder + $b153e45f560be665$var$incorrectSounds[i];
}




const $f944e50d54776358$var$body = document.getElementsByTagName("body")[0];
const $f944e50d54776358$var$cards = document.getElementsByClassName("card");
const $f944e50d54776358$var$primaryButtons = document.getElementsByClassName("btn-primary");
const $f944e50d54776358$var$ultImage = document.getElementById("ultImage");
const $f944e50d54776358$var$timerBar = $4560290abc280b4c$export$82e78ea772886f8c();
const $f944e50d54776358$var$progressBar = document.getElementById("progressBar");
let $f944e50d54776358$var$hpBar;
const $f944e50d54776358$var$backgroundImages = [
    "../img/GarenBackground/default.png",
    "../img/GarenBackground/sanguine.png",
    "../img/GarenBackground/deserttrooper.png",
    "../img/GarenBackground/commando.png",
    "../img/GarenBackground/dreadknight.png",
    "../img/GarenBackground/rugged.png",
    "../img/GarenBackground/steellegion.png",
    "../img/GarenBackground/rogueadmiral.png",
    "../img/GarenBackground/warringkingdoms.png",
    "../img/GarenBackground/godking.png",
    "../img/GarenBackground/demaciavice.png",
    "../img/GarenBackground/mechakingdoms.png",
    "../img/GarenBackground/prestigemechakingdoms.png",
    "../img/GarenBackground/battleacademia.png",
    "../img/GarenBackground/mythmaker.png"
];
function $f944e50d54776358$export$2e4fbd3e6b050ced() {
    return $f944e50d54776358$var$backgroundImages;
}
function $f944e50d54776358$export$e6eb54368342cb84(theme) {
    switch(theme){
        case 0:
            $f944e50d54776358$var$newTheme(theme, "#c6936f", "#314598");
            break;
        case 1:
            $f944e50d54776358$var$newTheme(theme, "#c33d0f", "#3d3935");
            break;
        case 2:
            $f944e50d54776358$var$newTheme(theme, "#9c5d33", "#86a4ad");
            break;
        case 3:
            $f944e50d54776358$var$newTheme(theme, "#41512b", "#bea028");
            break;
        case 4:
            $f944e50d54776358$var$newTheme(theme, "#708bb6", "#9a6b7e");
            break;
        case 5:
            $f944e50d54776358$var$newTheme(theme, "#4e5862", "#836b54");
            break;
        case 6:
            $f944e50d54776358$var$newTheme(theme, "#373737", "#744a30");
            break;
        case 7:
            $f944e50d54776358$var$newTheme(theme, "#503221", "#2d2231");
            break;
        case 8:
            $f944e50d54776358$var$newTheme(theme, "#a26331", "#da4040");
            break;
        case 9:
            $f944e50d54776358$var$newTheme(theme, "#5c4744", "#51a7bc");
            break;
        case 10:
            $f944e50d54776358$var$newTheme(theme, "#10c3e5", "#e442ee");
            break;
        case 11:
            $f944e50d54776358$var$newTheme(theme, "#685c4d", "#5ea4e5");
            break;
        case 12:
            $f944e50d54776358$var$newTheme(theme, "#685449", "#f6a15f");
            break;
        case 13:
            $f944e50d54776358$var$newTheme(theme, "#1c263f", "#f92136");
            break;
        case 14:
            $f944e50d54776358$var$newTheme(theme, "#d45256", "#948c9b");
            break;
        default:
            return;
    }
}
function $f944e50d54776358$var$newTheme(theme, cardColor, buttonColor) {
    $f944e50d54776358$var$body.style.backgroundImage = "url('" + $f944e50d54776358$var$backgroundImages[theme] + "')";
    $f944e50d54776358$var$hpBar.style.borderColor = cardColor;
    $f944e50d54776358$var$ultImage.style.outlineColor = buttonColor;
    $f944e50d54776358$var$timerBar.style.backgroundColor = buttonColor;
    $f944e50d54776358$var$progressBar.style.borderColor = cardColor;
    $f944e50d54776358$var$changeCardColors(cardColor, buttonColor);
    $f944e50d54776358$var$changeButtonColors(buttonColor, cardColor);
}
function $f944e50d54776358$var$changeCardColors(color, borderColor) {
    for(let i = 0; i < $f944e50d54776358$var$cards.length; i++){
        $f944e50d54776358$var$cards[i].style.backgroundColor = color;
        $f944e50d54776358$var$cards[i].style.borderColor = borderColor;
    }
}
function $f944e50d54776358$var$changeButtonColors(color, borderColor) {
    for(let i = 0; i < $f944e50d54776358$var$primaryButtons.length; i++){
        let button = $f944e50d54776358$var$primaryButtons[i];
        button.style.backgroundColor = color;
        button.style.borderColor = borderColor;
        button.addEventListener("mouseenter", ()=>{
            let changedColor = $f944e50d54776358$var$changeColor(color, 50);
            button.style.backgroundColor = changedColor;
            button.style.borderColor = borderColor;
        });
        button.addEventListener("mousedown", ()=>{
            let changedColor = $f944e50d54776358$var$changeColor(color, -50);
            button.style.backgroundColor = changedColor;
            button.style.borderColor = borderColor;
        });
        button.addEventListener("mouseleave", ()=>{
            button.style.backgroundColor = color;
            button.style.borderColor = borderColor;
        });
    }
}
function $f944e50d54776358$var$hexToInt(hex) {
    return parseInt("0x" + hex);
}
function $f944e50d54776358$var$applyColorOffset(color, offset) {
    let applied = Math.max(0, Math.round(Math.min(255, color + offset)));
    if (applied < 10) return "0" + applied;
    return applied.toString(16);
}
function $f944e50d54776358$var$changeColor(color, offset) {
    color = color.slice(1);
    let r = color.slice(0, 2);
    let g = color.slice(2, 4);
    let b = color.slice(4, 6);
    let rInt = $f944e50d54776358$var$hexToInt(r);
    let gInt = $f944e50d54776358$var$hexToInt(g);
    let bInt = $f944e50d54776358$var$hexToInt(b);
    let rApplied = $f944e50d54776358$var$applyColorOffset(rInt, offset);
    let gApplied = $f944e50d54776358$var$applyColorOffset(gInt, offset);
    let bApplied = $f944e50d54776358$var$applyColorOffset(bInt, offset);
    return "#" + rApplied + gApplied + bApplied;
}
function $f944e50d54776358$export$2cd8252107eb640b(value) {
    $f944e50d54776358$var$hpBar = $ff8afec5bc7f4525$export$82e78ea772886f8c();
    $f944e50d54776358$export$e6eb54368342cb84(value);
}


const $9ca73d2835015f55$var$title = document.getElementById("title");
function $9ca73d2835015f55$var$difficultyToText(difficulty) {
    switch(difficulty){
        case 0:
            return "Easy\uD83D\uDE03";
        case 1:
            return "Medium\uD83D\uDE0C";
        case 2:
            return "Hard\uD83D\uDE10";
        case 3:
            return "Extreme\uD83D\uDE21";
        case 4:
            return "Insane\uD83D\uDE08";
        default:
            return "";
    }
}
function $9ca73d2835015f55$export$383340abfc62eacf(difficulty) {
    $9ca73d2835015f55$var$title.innerText = `Garen Ult Trainer (${$9ca73d2835015f55$var$difficultyToText(difficulty)})`;
}


const $c8596aa4033924f9$var$body = document.getElementsByTagName("body")[0];
const $c8596aa4033924f9$var$buttons = document.querySelectorAll(".btn, .btn-close");
function $c8596aa4033924f9$export$56acf8839b1f401e(value) {
    let path;
    switch(value){
        case 0:
            path = "../cursors/legacy.cur";
            break;
        case 1:
            path = "../cursors/modern.cur";
            break;
        default:
            return;
    }
    let fullString = "cursor: url('" + path + "'), auto;";
    $c8596aa4033924f9$var$body.style.cssText += fullString;
    for(let i = 0; i < $c8596aa4033924f9$var$buttons.length; i++)$c8596aa4033924f9$var$buttons[i].onmouseenter = ()=>{
        $c8596aa4033924f9$var$buttons[i].style.cssText += fullString;
    };
}
function $c8596aa4033924f9$export$2cd8252107eb640b(value) {
    $c8596aa4033924f9$export$56acf8839b1f401e(value);
}




const $a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3 = document.querySelectorAll("div#difficultyButtons img");
const $a3cd9ccef2b1fd6c$export$95fdfa010a6521f9 = document.querySelectorAll("div#themeButtons img");
const $a3cd9ccef2b1fd6c$export$926c44934bdc9131 = document.querySelectorAll("div#cursorButtons img");
const $a3cd9ccef2b1fd6c$var$modal = document.getElementById("exampleModal");
const $a3cd9ccef2b1fd6c$var$modalCloseButton = document.getElementById("modalCloseButton");
const $a3cd9ccef2b1fd6c$var$applyButton = document.getElementById("modalApplyButton");
function $a3cd9ccef2b1fd6c$export$4bd23268ceb72264() {
    return $a3cd9ccef2b1fd6c$var$modal.classList.contains("show");
}
function $a3cd9ccef2b1fd6c$export$331ecbe217d179da() {
    $a3cd9ccef2b1fd6c$var$modal.classList.add("show");
    $a3cd9ccef2b1fd6c$var$modal.style.display = "block";
}
function $a3cd9ccef2b1fd6c$export$542cf336a574a3f8(button, color) {
    if (color === undefined) color = "white";
    button.style.borderColor = color;
    $c62271cf5485deee$export$9337593a59c580a0(button).play();
}
function $a3cd9ccef2b1fd6c$export$3d7e4fe7955c1865(button) {
    button.style.borderColor = "";
    $c62271cf5485deee$export$6fadf95f00be44ec(button).play();
}
function $a3cd9ccef2b1fd6c$export$2cd8252107eb640b() {
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($a3cd9ccef2b1fd6c$export$95fdfa010a6521f9[$0198b660ad8ac7b1$export$89cbf1a0881c8b9c()]);
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3[$0198b660ad8ac7b1$export$97b5f4a7021b3b89()]);
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($a3cd9ccef2b1fd6c$export$926c44934bdc9131[$0198b660ad8ac7b1$export$da3f040fb23d21f()]);
    $a3cd9ccef2b1fd6c$var$initializeButtons();
}
function $a3cd9ccef2b1fd6c$export$3f6fecd573f3fa48() {
    $a3cd9ccef2b1fd6c$var$modal.classList.remove("show");
    $a3cd9ccef2b1fd6c$var$modal.style.display = "";
}
function $a3cd9ccef2b1fd6c$var$initializeButtons() {
    $a3cd9ccef2b1fd6c$var$modalCloseButton.onclick = $0198b660ad8ac7b1$export$8a9aed55ddd6cae8;
    $a3cd9ccef2b1fd6c$var$applyButton.onclick = $0198b660ad8ac7b1$export$eaac77e85e7cf16e;
    $a3cd9ccef2b1fd6c$var$buttonsInit($a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3, (i)=>{
        $0198b660ad8ac7b1$export$b71fe41f8336314(i);
    });
    $a3cd9ccef2b1fd6c$var$buttonsInit($a3cd9ccef2b1fd6c$export$95fdfa010a6521f9, (i)=>{
        $0198b660ad8ac7b1$export$a771412762fa4a7b(i);
    });
    $a3cd9ccef2b1fd6c$var$buttonsInit($a3cd9ccef2b1fd6c$export$926c44934bdc9131, (i)=>{
        $0198b660ad8ac7b1$export$3511b11875c57135(i);
    });
}
function $a3cd9ccef2b1fd6c$var$buttonsInit(buttons, callback) {
    for(let i = 0; i < buttons.length; i++)buttons[i].onclick = ()=>{
        callback(i);
    };
}


const $f60691be2a0a7ed3$var$modal = document.getElementById("helpModal");
const $f60691be2a0a7ed3$var$modalClose = document.getElementById("helpModalClose");
const $f60691be2a0a7ed3$var$closeButton = document.getElementById("helpModalCloseButton");
function $f60691be2a0a7ed3$export$78ff1c4cffbf30c() {
    $f60691be2a0a7ed3$var$modal.classList.add("show");
    $f60691be2a0a7ed3$var$modal.style.display = "block";
}
function $f60691be2a0a7ed3$export$217836194a782c5() {
    return $f60691be2a0a7ed3$var$modal.classList.contains("show");
}
function $f60691be2a0a7ed3$export$3f6fecd573f3fa48() {
    $f60691be2a0a7ed3$var$modal.classList.remove("show");
    $f60691be2a0a7ed3$var$modal.style.display = "";
}
function $f60691be2a0a7ed3$var$initializeButtons() {
    $f60691be2a0a7ed3$var$modalClose.onclick = ()=>{
        $f60691be2a0a7ed3$export$3f6fecd573f3fa48();
    };
    $f60691be2a0a7ed3$var$closeButton.onclick = ()=>{
        $f60691be2a0a7ed3$export$3f6fecd573f3fa48();
    };
}
function $f60691be2a0a7ed3$export$2cd8252107eb640b() {
    $f60691be2a0a7ed3$var$initializeButtons();
}


let $0198b660ad8ac7b1$export$c417cded29e3dfdf = true;
let $0198b660ad8ac7b1$var$highscore;
let $0198b660ad8ac7b1$var$currentScore = 0;
let $0198b660ad8ac7b1$var$theme;
let $0198b660ad8ac7b1$var$difficulty;
let $0198b660ad8ac7b1$var$cursor;
let $0198b660ad8ac7b1$var$currentDifficultySelection;
let $0198b660ad8ac7b1$var$currentThemeSelection;
let $0198b660ad8ac7b1$var$currentCursorSelection;
let $0198b660ad8ac7b1$var$recentlySelectedElement;
let $0198b660ad8ac7b1$var$currentRow = 0;
var $0198b660ad8ac7b1$export$cacd6541cfeeb6c1;
(function(Direction) {
    Direction[Direction["Left"] = 0] = "Left";
    Direction[Direction["Up"] = 1] = "Up";
    Direction[Direction["Right"] = 2] = "Right";
    Direction[Direction["Down"] = 3] = "Down";
})($0198b660ad8ac7b1$export$cacd6541cfeeb6c1 || ($0198b660ad8ac7b1$export$cacd6541cfeeb6c1 = {}));
var $0198b660ad8ac7b1$var$Rows;
(function(Rows) {
    Rows[Rows["Difficulty"] = 0] = "Difficulty";
    Rows[Rows["Theme"] = 1] = "Theme";
    Rows[Rows["Cursor"] = 2] = "Cursor";
})($0198b660ad8ac7b1$var$Rows || ($0198b660ad8ac7b1$var$Rows = {}));
const $0198b660ad8ac7b1$var$maxRows = Object.keys($0198b660ad8ac7b1$var$Rows).length / 2 - 1;
function $0198b660ad8ac7b1$export$d195ba7bb0fc15ea() {
    if ($adc8ed603088d5e4$export$d43aff215272e449()) return;
    $adc8ed603088d5e4$export$d195ba7bb0fc15ea();
}
function $0198b660ad8ac7b1$export$2727bd01848e46aa() {
    if ($adc8ed603088d5e4$export$4bf5b96b516333b0()) return;
    $adc8ed603088d5e4$export$2727bd01848e46aa();
}
function $0198b660ad8ac7b1$export$2d1e44b34940e29a() {
    if ($a3cd9ccef2b1fd6c$export$4bd23268ceb72264()) {
        $0198b660ad8ac7b1$export$8a9aed55ddd6cae8();
        return;
    }
    if ($f60691be2a0a7ed3$export$217836194a782c5()) {
        $f60691be2a0a7ed3$export$3f6fecd573f3fa48();
        return;
    }
    if (!$0198b660ad8ac7b1$export$c417cded29e3dfdf) {
        $0198b660ad8ac7b1$export$c6938de3bf17624f();
        return;
    }
}
function $0198b660ad8ac7b1$export$e88d48933ac88f9e() {
    if (!$0198b660ad8ac7b1$export$c417cded29e3dfdf || $f60691be2a0a7ed3$export$217836194a782c5() || $a3cd9ccef2b1fd6c$export$4bd23268ceb72264()) return;
    $a3cd9ccef2b1fd6c$export$331ecbe217d179da();
    switch($0198b660ad8ac7b1$var$currentRow){
        case 0:
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3[$0198b660ad8ac7b1$var$currentDifficultySelection];
            break;
        case 1:
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$95fdfa010a6521f9[$0198b660ad8ac7b1$var$currentThemeSelection];
            break;
        case 2:
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$926c44934bdc9131[$0198b660ad8ac7b1$var$currentCursorSelection];
            break;
    }
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement, "red");
}
function $0198b660ad8ac7b1$export$6aac607299271c78() {
    if (!$0198b660ad8ac7b1$export$c417cded29e3dfdf || $a3cd9ccef2b1fd6c$export$4bd23268ceb72264() || $f60691be2a0a7ed3$export$217836194a782c5()) return;
    $f60691be2a0a7ed3$export$78ff1c4cffbf30c();
}
function $0198b660ad8ac7b1$export$6beb556a5f60b002(direction) {
    if (!$a3cd9ccef2b1fd6c$export$4bd23268ceb72264()) return;
    switch(direction){
        case 0:
            $0198b660ad8ac7b1$export$564ba41fc92bea40(-1);
            break;
        case 1:
            $0198b660ad8ac7b1$export$7bf89a3cf90a21bf(-1);
            break;
        case 2:
            $0198b660ad8ac7b1$export$564ba41fc92bea40(1);
            break;
        case 3:
            $0198b660ad8ac7b1$export$7bf89a3cf90a21bf(1);
            break;
    }
}
function $0198b660ad8ac7b1$export$564ba41fc92bea40(offset) {
    switch($0198b660ad8ac7b1$var$currentRow){
        case 0:
            $a3cd9ccef2b1fd6c$export$3d7e4fe7955c1865($0198b660ad8ac7b1$var$recentlySelectedElement);
            $0198b660ad8ac7b1$var$currentDifficultySelection = $0198b660ad8ac7b1$export$d8f448587d4d827f($0198b660ad8ac7b1$var$currentDifficultySelection, offset, $a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3.length - 1);
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3[$0198b660ad8ac7b1$var$currentDifficultySelection];
            $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement, "red");
            $0198b660ad8ac7b1$export$8bc9b643859d68ae();
            break;
        case 1:
            $a3cd9ccef2b1fd6c$export$3d7e4fe7955c1865($0198b660ad8ac7b1$var$recentlySelectedElement);
            $0198b660ad8ac7b1$var$currentThemeSelection = $0198b660ad8ac7b1$export$d8f448587d4d827f($0198b660ad8ac7b1$var$currentThemeSelection, offset, $a3cd9ccef2b1fd6c$export$95fdfa010a6521f9.length - 1);
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$95fdfa010a6521f9[$0198b660ad8ac7b1$var$currentThemeSelection];
            $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement, "red");
            $f944e50d54776358$export$e6eb54368342cb84($0198b660ad8ac7b1$var$currentThemeSelection);
            break;
        case 2:
            $a3cd9ccef2b1fd6c$export$3d7e4fe7955c1865($0198b660ad8ac7b1$var$recentlySelectedElement);
            $0198b660ad8ac7b1$var$currentCursorSelection = $0198b660ad8ac7b1$export$d8f448587d4d827f($0198b660ad8ac7b1$var$currentCursorSelection, offset, $a3cd9ccef2b1fd6c$export$926c44934bdc9131.length - 1);
            $0198b660ad8ac7b1$var$recentlySelectedElement = $a3cd9ccef2b1fd6c$export$926c44934bdc9131[$0198b660ad8ac7b1$var$currentCursorSelection];
            $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement, "red");
            $c8596aa4033924f9$export$56acf8839b1f401e($0198b660ad8ac7b1$var$currentCursorSelection);
            break;
    }
}
function $0198b660ad8ac7b1$export$7bf89a3cf90a21bf(offset) {
    if (offset === 0) return;
    if (offset > 0) switch($0198b660ad8ac7b1$var$currentRow){
        case 0:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$95fdfa010a6521f9[$0198b660ad8ac7b1$var$currentThemeSelection]);
            $0198b660ad8ac7b1$export$8bc9b643859d68ae();
            break;
        case 1:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$926c44934bdc9131[$0198b660ad8ac7b1$var$currentCursorSelection]);
            $f944e50d54776358$export$e6eb54368342cb84($0198b660ad8ac7b1$var$currentThemeSelection);
            break;
        case 2:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3[$0198b660ad8ac7b1$var$currentDifficultySelection]);
            $c8596aa4033924f9$export$56acf8839b1f401e($0198b660ad8ac7b1$var$currentCursorSelection);
            break;
    }
    else switch($0198b660ad8ac7b1$var$currentRow){
        case 0:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$926c44934bdc9131[$0198b660ad8ac7b1$var$currentCursorSelection]);
            $0198b660ad8ac7b1$export$8bc9b643859d68ae();
            break;
        case 1:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3[$0198b660ad8ac7b1$var$currentDifficultySelection]);
            $f944e50d54776358$export$e6eb54368342cb84($0198b660ad8ac7b1$var$currentThemeSelection);
            break;
        case 2:
            $0198b660ad8ac7b1$var$verticalSelection($a3cd9ccef2b1fd6c$export$95fdfa010a6521f9[$0198b660ad8ac7b1$var$currentThemeSelection]);
            $c8596aa4033924f9$export$56acf8839b1f401e($0198b660ad8ac7b1$var$currentCursorSelection);
            break;
    }
    $0198b660ad8ac7b1$var$currentRow = $0198b660ad8ac7b1$export$d8f448587d4d827f($0198b660ad8ac7b1$var$currentRow, offset, $0198b660ad8ac7b1$var$maxRows);
}
function $0198b660ad8ac7b1$var$verticalSelection(button) {
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement);
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8(button, "red");
    $0198b660ad8ac7b1$var$recentlySelectedElement = button;
}
function $0198b660ad8ac7b1$export$d8f448587d4d827f(value, operand, limit) {
    if (operand === 0) return value;
    if (operand < 0) return $0198b660ad8ac7b1$export$51916cb5043b1f39(value, limit);
    return $0198b660ad8ac7b1$export$906d693ce977c21a(value, limit);
}
function $0198b660ad8ac7b1$export$51916cb5043b1f39(value, limit) {
    value--;
    if (value < 0) value = limit;
    return value;
}
function $0198b660ad8ac7b1$export$906d693ce977c21a(value, limit) {
    value++;
    if (value > limit) value = 0;
    return value;
}
function $0198b660ad8ac7b1$export$8a9aed55ddd6cae8() {
    $0198b660ad8ac7b1$export$f9100f15fd70a5df();
    $a3cd9ccef2b1fd6c$export$3f6fecd573f3fa48();
}
function $0198b660ad8ac7b1$export$eaac77e85e7cf16e() {
    $0198b660ad8ac7b1$export$4b80e08960f15b4f();
    $a3cd9ccef2b1fd6c$export$3f6fecd573f3fa48();
}
function $0198b660ad8ac7b1$export$f9100f15fd70a5df() {
    $0198b660ad8ac7b1$export$a771412762fa4a7b($0198b660ad8ac7b1$var$theme);
    $0198b660ad8ac7b1$export$b71fe41f8336314($0198b660ad8ac7b1$var$difficulty);
    $0198b660ad8ac7b1$export$3511b11875c57135($0198b660ad8ac7b1$var$cursor);
}
function $0198b660ad8ac7b1$export$4b80e08960f15b4f() {
    $0198b660ad8ac7b1$var$saveTheme();
    $0198b660ad8ac7b1$var$saveDifficulty();
    $0198b660ad8ac7b1$var$saveCursor();
}
function $0198b660ad8ac7b1$export$89cbf1a0881c8b9c() {
    return $0198b660ad8ac7b1$var$theme;
}
function $0198b660ad8ac7b1$export$97b5f4a7021b3b89() {
    return $0198b660ad8ac7b1$var$difficulty;
}
function $0198b660ad8ac7b1$export$da3f040fb23d21f() {
    return $0198b660ad8ac7b1$var$cursor;
}
function $0198b660ad8ac7b1$export$8bc9b643859d68ae() {
    $9ca73d2835015f55$export$383340abfc62eacf($0198b660ad8ac7b1$var$currentDifficultySelection);
    $0198b660ad8ac7b1$export$cb367f98a11d0e82($0198b660ad8ac7b1$var$currentDifficultySelection);
}
function $0198b660ad8ac7b1$export$b71fe41f8336314(newIndex) {
    if ($0198b660ad8ac7b1$var$currentDifficultySelection === newIndex) return;
    $0198b660ad8ac7b1$var$rowCheck(0);
    $0198b660ad8ac7b1$var$clickSelection($a3cd9ccef2b1fd6c$export$98bc4de4c93ae0f3, $0198b660ad8ac7b1$var$currentDifficultySelection, newIndex);
    $0198b660ad8ac7b1$var$currentDifficultySelection = newIndex;
    $0198b660ad8ac7b1$export$8bc9b643859d68ae();
}
function $0198b660ad8ac7b1$export$a771412762fa4a7b(newIndex) {
    if ($0198b660ad8ac7b1$var$currentThemeSelection === newIndex) return;
    $0198b660ad8ac7b1$var$rowCheck(1);
    $0198b660ad8ac7b1$var$clickSelection($a3cd9ccef2b1fd6c$export$95fdfa010a6521f9, $0198b660ad8ac7b1$var$currentThemeSelection, newIndex);
    $0198b660ad8ac7b1$var$currentThemeSelection = newIndex;
    $f944e50d54776358$export$e6eb54368342cb84($0198b660ad8ac7b1$var$currentThemeSelection);
}
function $0198b660ad8ac7b1$export$3511b11875c57135(newIndex) {
    if ($0198b660ad8ac7b1$var$currentCursorSelection === newIndex) return;
    $0198b660ad8ac7b1$var$rowCheck(2);
    $0198b660ad8ac7b1$var$clickSelection($a3cd9ccef2b1fd6c$export$926c44934bdc9131, $0198b660ad8ac7b1$var$currentCursorSelection, newIndex);
    $0198b660ad8ac7b1$var$currentCursorSelection = newIndex;
    $c8596aa4033924f9$export$56acf8839b1f401e($0198b660ad8ac7b1$var$currentCursorSelection);
}
function $0198b660ad8ac7b1$var$rowCheck(rowID) {
    if ($0198b660ad8ac7b1$var$currentRow !== rowID) {
        $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement);
        $0198b660ad8ac7b1$var$currentRow = rowID;
    }
}
function $0198b660ad8ac7b1$var$clickSelection(buttons, oldIndex, newIndex) {
    $a3cd9ccef2b1fd6c$export$3d7e4fe7955c1865(buttons[oldIndex]);
    $0198b660ad8ac7b1$var$recentlySelectedElement = buttons[newIndex];
    $a3cd9ccef2b1fd6c$export$542cf336a574a3f8($0198b660ad8ac7b1$var$recentlySelectedElement, "red");
}
function $0198b660ad8ac7b1$var$saveTheme() {
    $0198b660ad8ac7b1$var$theme = $0198b660ad8ac7b1$var$currentThemeSelection;
    $1938e89565799da2$export$2e49b867b7a0847c($0198b660ad8ac7b1$var$theme);
}
function $0198b660ad8ac7b1$var$saveDifficulty() {
    $0198b660ad8ac7b1$var$difficulty = $0198b660ad8ac7b1$var$currentDifficultySelection;
    $1938e89565799da2$export$97047fee56e872c0($0198b660ad8ac7b1$var$difficulty);
}
function $0198b660ad8ac7b1$var$saveCursor() {
    $0198b660ad8ac7b1$var$cursor = $0198b660ad8ac7b1$var$currentCursorSelection;
    $1938e89565799da2$export$ca17b14bf34aba4($0198b660ad8ac7b1$var$cursor);
}
function $0198b660ad8ac7b1$export$cb367f98a11d0e82(difficulty) {
    $0198b660ad8ac7b1$var$highscore = $1938e89565799da2$export$324a59f4a7abce50(difficulty);
    $94a4639c454b28ff$export$d1dff7db5cbbcb72($0198b660ad8ac7b1$var$highscore);
}
function $0198b660ad8ac7b1$export$482310739c8f9d71(newScore) {
    $0198b660ad8ac7b1$var$currentScore = newScore;
    $94a4639c454b28ff$export$482310739c8f9d71(newScore);
}
function $0198b660ad8ac7b1$export$d1dff7db5cbbcb72(newHighscore) {
    if (newHighscore === undefined) {
        newHighscore = $0198b660ad8ac7b1$var$currentScore;
        if (newHighscore < $0198b660ad8ac7b1$var$highscore) return;
    }
    if (newHighscore === $0198b660ad8ac7b1$var$highscore) return;
    $0198b660ad8ac7b1$var$highscore = newHighscore;
    $94a4639c454b28ff$export$d1dff7db5cbbcb72(newHighscore);
    $1938e89565799da2$export$fdd11945b7cd5309(newHighscore, $1938e89565799da2$export$97b5f4a7021b3b89());
}
function $0198b660ad8ac7b1$export$12aa28bac0501f7e() {
    if ($adc8ed603088d5e4$export$b073e1d36c4e6dbe() && !$a3cd9ccef2b1fd6c$export$4bd23268ceb72264() && !$f60691be2a0a7ed3$export$217836194a782c5()) {
        $adc8ed603088d5e4$export$a6eb1b0ae9ee63a1();
        return;
    }
    if ($adc8ed603088d5e4$export$fe0f91bfdcf210e0()) {
        $adc8ed603088d5e4$export$cc1444630dea247e();
        return;
    }
    if ($a3cd9ccef2b1fd6c$export$4bd23268ceb72264()) {
        $0198b660ad8ac7b1$export$eaac77e85e7cf16e();
        return;
    }
    if ($f60691be2a0a7ed3$export$217836194a782c5()) {
        $f60691be2a0a7ed3$export$3f6fecd573f3fa48();
        return;
    }
}
function $0198b660ad8ac7b1$export$e09b512eecac7579(key) {
    switch(key){
        case "1":
            $0198b660ad8ac7b1$export$d195ba7bb0fc15ea();
            break;
        case "2":
            $0198b660ad8ac7b1$export$2727bd01848e46aa();
            break;
        case " ":
        case "Enter":
            $0198b660ad8ac7b1$export$12aa28bac0501f7e();
            break;
        case "r":
            $0198b660ad8ac7b1$export$d1dff7db5cbbcb72(0);
            break;
        case "Escape":
            $0198b660ad8ac7b1$export$2d1e44b34940e29a();
            break;
        case "s":
            $0198b660ad8ac7b1$export$e88d48933ac88f9e();
            break;
        case "h":
            $0198b660ad8ac7b1$export$6aac607299271c78();
            break;
        case "ArrowLeft":
            $0198b660ad8ac7b1$export$6beb556a5f60b002(0);
            break;
        case "ArrowUp":
            $0198b660ad8ac7b1$export$6beb556a5f60b002(1);
            break;
        case "ArrowRight":
            $0198b660ad8ac7b1$export$6beb556a5f60b002(2);
            break;
        case "ArrowDown":
            $0198b660ad8ac7b1$export$6beb556a5f60b002(3);
            break;
    }
}
function $0198b660ad8ac7b1$export$d0c9d28c41fac78f(word) {
    switch(word){
        case "demacia":
            $0198b660ad8ac7b1$export$d1dff7db5cbbcb72(999999999);
            break;
        case "darius":
            $0198b660ad8ac7b1$export$d1dff7db5cbbcb72(-999999999);
            break;
    }
}
function $0198b660ad8ac7b1$export$d8d89c11f461d47c() {
    $0198b660ad8ac7b1$var$highscore = 0;
    $1938e89565799da2$export$fdd11945b7cd5309($0198b660ad8ac7b1$var$highscore, $1938e89565799da2$export$97b5f4a7021b3b89());
    $94a4639c454b28ff$export$d1dff7db5cbbcb72($0198b660ad8ac7b1$var$highscore);
}
function $0198b660ad8ac7b1$export$4f450b57e5b3f1d() {
    $0198b660ad8ac7b1$var$progress(true);
}
function $0198b660ad8ac7b1$export$7021fabe1775dd8e() {
    $0198b660ad8ac7b1$var$progress(false);
}
function $0198b660ad8ac7b1$export$b01d08d42f405260() {
    $0198b660ad8ac7b1$export$c417cded29e3dfdf = false;
    $adc8ed603088d5e4$export$d1c87d7358bc8511();
    $ff8afec5bc7f4525$export$7a03d8bb05d3f187();
    $0198b660ad8ac7b1$export$4021de1c0df2c0bd();
}
function $0198b660ad8ac7b1$export$c6938de3bf17624f() {
    if (!$adc8ed603088d5e4$export$43770586b72cc035()) return;
    $0198b660ad8ac7b1$var$back();
}
function $0198b660ad8ac7b1$export$7203a8ef4c4339b7() {
    $adc8ed603088d5e4$export$7bc8a245db2f4a6b();
    $0198b660ad8ac7b1$export$d1dff7db5cbbcb72();
    $0198b660ad8ac7b1$export$482310739c8f9d71(0);
    $4560290abc280b4c$export$c4688174d3db5a2c();
    $0198b660ad8ac7b1$export$4021de1c0df2c0bd();
}
function $0198b660ad8ac7b1$export$4021de1c0df2c0bd() {
    $b153e45f560be665$export$fa6813432f753b0d();
    $0198b660ad8ac7b1$export$482310739c8f9d71(0);
    $0198b660ad8ac7b1$var$setButtons(true);
    $4560290abc280b4c$export$c4688174d3db5a2c();
    $0198b660ad8ac7b1$var$nextRound();
}
function $0198b660ad8ac7b1$var$progress(answer) {
    $4560290abc280b4c$export$4d41f7386211339a();
    let currentHp = $ff8afec5bc7f4525$export$b22679e45cae3d6f();
    let maximumHp = $ff8afec5bc7f4525$export$4185a9fe0d63b2e6();
    let ultDamage = $d69a6cb7004c4199$export$ccdc94379da04ede(currentHp, maximumHp);
    if (ultDamage >= currentHp === answer) {
        $b153e45f560be665$export$34f45ef1be1c83fd();
        $4560290abc280b4c$export$55d6b35100aa8a91(0.25);
        $4560290abc280b4c$export$148d61ea341bbff7();
        $0198b660ad8ac7b1$var$currentScore++;
        $0198b660ad8ac7b1$export$482310739c8f9d71($0198b660ad8ac7b1$var$currentScore);
        $0198b660ad8ac7b1$var$nextRound();
    } else $0198b660ad8ac7b1$var$gameOver(ultDamage);
}
function $0198b660ad8ac7b1$var$nextRound() {
    let difficulty = $1938e89565799da2$export$97b5f4a7021b3b89();
    $d69a6cb7004c4199$export$e4af5c3d35f050ae();
    $ff8afec5bc7f4525$export$17e2c3331411e3a9(difficulty);
    $4560290abc280b4c$export$5985f5b4428bec55(()=>$0198b660ad8ac7b1$var$gameOver($d69a6cb7004c4199$export$ccdc94379da04ede($ff8afec5bc7f4525$export$b22679e45cae3d6f(), $ff8afec5bc7f4525$export$4185a9fe0d63b2e6())));
}
function $0198b660ad8ac7b1$var$gameOver(ultDamage) {
    $b153e45f560be665$export$a20be2e32b519a82();
    $0198b660ad8ac7b1$var$setButtons(false);
    let explanation = $affe6f755c7ef6eb$export$a8a369b1165c658c($ff8afec5bc7f4525$export$b22679e45cae3d6f(), $ff8afec5bc7f4525$export$4185a9fe0d63b2e6(), ultDamage);
    $adc8ed603088d5e4$export$920fcc4645588d0e(explanation);
    $adc8ed603088d5e4$export$3b0bdf174ee79f95();
}
function $0198b660ad8ac7b1$var$setButtons(bool) {
    if (bool) $adc8ed603088d5e4$export$24102e422af3ddc2();
    else $adc8ed603088d5e4$export$c44775eff6da4080();
}
function $0198b660ad8ac7b1$var$back() {
    $0198b660ad8ac7b1$export$c417cded29e3dfdf = true;
    $adc8ed603088d5e4$export$e8b704861ed71a45();
    $4560290abc280b4c$export$4d41f7386211339a();
    $4560290abc280b4c$export$148d61ea341bbff7();
    $0198b660ad8ac7b1$export$482310739c8f9d71(0);
    $0198b660ad8ac7b1$var$setButtons(false);
    $ff8afec5bc7f4525$export$c7e1758fe1fe8869();
    $adc8ed603088d5e4$export$7bc8a245db2f4a6b();
    $d69a6cb7004c4199$export$aad8462122ac592b();
}
async function $0198b660ad8ac7b1$export$2cd8252107eb640b() {
    let tempHighscore = $1938e89565799da2$export$324a59f4a7abce50($1938e89565799da2$export$97b5f4a7021b3b89());
    $0198b660ad8ac7b1$export$d1dff7db5cbbcb72(tempHighscore);
    await $ff8afec5bc7f4525$export$2cd8252107eb640b();
    $0198b660ad8ac7b1$var$theme = $1938e89565799da2$export$89cbf1a0881c8b9c();
    $0198b660ad8ac7b1$var$difficulty = $1938e89565799da2$export$97b5f4a7021b3b89();
    $0198b660ad8ac7b1$var$cursor = $1938e89565799da2$export$da3f040fb23d21f();
    $0198b660ad8ac7b1$var$currentThemeSelection = $0198b660ad8ac7b1$var$theme;
    $0198b660ad8ac7b1$var$currentDifficultySelection = $0198b660ad8ac7b1$var$difficulty;
    $0198b660ad8ac7b1$var$currentCursorSelection = $0198b660ad8ac7b1$var$cursor;
    $f944e50d54776358$export$2cd8252107eb640b($0198b660ad8ac7b1$var$theme);
    $9ca73d2835015f55$export$383340abfc62eacf($0198b660ad8ac7b1$var$difficulty);
    $c8596aa4033924f9$export$2cd8252107eb640b($0198b660ad8ac7b1$var$cursor);
    $a3cd9ccef2b1fd6c$export$2cd8252107eb640b();
}



const $046d4436da9e9b2c$var$words = [];
let $046d4436da9e9b2c$var$buffer = "";
let $046d4436da9e9b2c$var$maxBufferLength = 0;
function $046d4436da9e9b2c$export$2cd8252107eb640b() {
    $046d4436da9e9b2c$var$addKeyListener();
    $046d4436da9e9b2c$var$detectWord("demacia");
    $046d4436da9e9b2c$var$detectWord("darius");
}
function $046d4436da9e9b2c$var$addKeyListener() {
    document.onkeydown = (e)=>{
        $0198b660ad8ac7b1$export$e09b512eecac7579(e.key);
    };
}
function $046d4436da9e9b2c$var$detectWord(word) {
    $046d4436da9e9b2c$var$words.push(word);
    if (word.length > $046d4436da9e9b2c$var$maxBufferLength) $046d4436da9e9b2c$var$maxBufferLength = word.length;
    if ($046d4436da9e9b2c$var$words.length > 1) return;
    document.onkeyup = (e)=>{
        if (e.key.length > 1) return;
        $046d4436da9e9b2c$var$buffer += e.key;
        if ($046d4436da9e9b2c$var$buffer.length > $046d4436da9e9b2c$var$maxBufferLength) $046d4436da9e9b2c$var$buffer = $046d4436da9e9b2c$var$buffer.substring(1);
        for (const word of $046d4436da9e9b2c$var$words)if ($046d4436da9e9b2c$var$buffer.includes(word)) {
            $046d4436da9e9b2c$var$buffer = "";
            $0198b660ad8ac7b1$export$d0c9d28c41fac78f(word);
            break;
        }
    };
}




function $7ed2eb5ecafe09d5$export$513ccb98c53b8039() {
    let backgroundImages = $f944e50d54776358$export$2e4fbd3e6b050ced();
    backgroundImages.forEach((e)=>{
        let img = new Image();
        img.src = e;
    });
    let sounds = $b153e45f560be665$export$214c7098e52ba5d8();
    sounds.forEach((e)=>{
        let audio = new Audio(e);
        audio.preload = "auto";
    });
}


function $c53cb8b92d216e35$export$2cd8252107eb640b() {
    const tooltipTriggerList = document.querySelectorAll("[data-bs-toggle='tooltip']");
    [
        ...tooltipTriggerList
    ].map((tooltipTriggerEl)=>new bootstrap.Tooltip(tooltipTriggerEl));
}






(async ()=>{
    $7ed2eb5ecafe09d5$export$513ccb98c53b8039();
    $94a4639c454b28ff$export$2cd8252107eb640b();
    $f60691be2a0a7ed3$export$2cd8252107eb640b();
    $b153e45f560be665$export$2cd8252107eb640b();
    $046d4436da9e9b2c$export$2cd8252107eb640b();
    $c53cb8b92d216e35$export$2cd8252107eb640b();
    await $0198b660ad8ac7b1$export$2cd8252107eb640b();
    $adc8ed603088d5e4$export$2cd8252107eb640b();
})();

})();
//# sourceMappingURL=initializer.js.map
